/* eslint-disable */
// @ts-nocheck
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** Decimal (fixed-point) */
  Decimal: { input: any; output: any; }
  /** The `GenericScalar` scalar type represents a generic GraphQL scalar value compatible with graphene.types.generic.GenericScalar. */
  GenericScalar: { input: any; output: any; }
  /** The `JSONString` scalar type represents a JSON value as a string. (graphene-compatible: clients can JSON.parse the string back into an object/array.) */
  JSONString: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** Represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccessScopeType = {
  __typename?: 'AccessScopeType';
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  networks: Array<NetworkType>;
  professions: Array<ProfessionType>;
  specialities: Array<SpecialityType>;
  universities: Array<UniversityType>;
  updated: Scalars['DateTime']['output'];
};

export type AchievementType = {
  __typename?: 'AchievementType';
  created: Scalars['DateTime']['output'];
  currentAchivement: Array<DailyTipperType>;
  id: Scalars['UUID']['output'];
  learningDays: Scalars['Int']['output'];
  nextAchievement: Array<DailyTipperType>;
  updated: Scalars['DateTime']['output'];
};

export type ActiveDuelsType = {
  __typename?: 'ActiveDuelsType';
  id?: Maybe<Scalars['UUID']['output']>;
  isInitiator?: Maybe<Scalars['Boolean']['output']>;
  opponent?: Maybe<UserType>;
  round?: Maybe<DuelRoundType>;
  session?: Maybe<ClassRoomLearningSessionType>;
  youTurn?: Maybe<Scalars['Boolean']['output']>;
};

export type ActiveQuizDuelsType = {
  __typename?: 'ActiveQuizDuelsType';
  id?: Maybe<Scalars['UUID']['output']>;
  isInitiator?: Maybe<Scalars['Boolean']['output']>;
  opponent?: Maybe<UserType>;
  round?: Maybe<DuelRoundType>;
  session?: Maybe<QuizTimeSessionType>;
};

export enum ActualLearnWeekStatus {
  Finished = 'FINISHED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type ActualLearnWeekType = {
  __typename?: 'ActualLearnWeekType';
  completedDays: Scalars['Int']['output'];
  correctAnswersCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  dailyTipper: DailyTipperType;
  dailytipperquestionanswerSet: Array<DailyTipperQuestionAnswerType>;
  id: Scalars['UUID']['output'];
  isPunished: Scalars['Boolean']['output'];
  status?: Maybe<ActualLearnWeekStatus>;
  updated: Scalars['DateTime']['output'];
  weekNumber: Scalars['Int']['output'];
  weekProgress: Scalars['JSONString']['output'];
  weeklyGoal: ActualLearnWeekWeeklyGoal;
  wrongAnswersCount: Scalars['Int']['output'];
};

export enum ActualLearnWeekWeeklyGoal {
  A_4 = 'A_4',
  A_5 = 'A_5',
  A_6 = 'A_6',
  A_7 = 'A_7'
}

export type AddWaitingUser = {
  __typename?: 'AddWaitingUser';
  waitingUser?: Maybe<UserQuizSessionSettingsType>;
};

export type AggregatedRateType = {
  __typename?: 'AggregatedRateType';
  averageRate?: Maybe<Scalars['Int']['output']>;
  classroomSet: Array<ClassRoomType>;
  classroomlectureSet: Array<ClassRoomLectureType>;
  created: Scalars['DateTime']['output'];
  feedbackCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  lectorSet: Array<LectorType>;
  updated: Scalars['DateTime']['output'];
};

export type AnswersType = {
  __typename?: 'AnswersType';
  correctAnswer: Array<DuelRoundQuestionAnswerType>;
  created: Scalars['DateTime']['output'];
  dailytipperquestionanswerSet: Array<DailyTipperQuestionAnswerType>;
  id: Scalars['UUID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  onboardingCorrectAnswer: Array<UserOnboardingQuestionAnswerDataType>;
  onboardingUserAnswer: Array<UserOnboardingQuestionAnswerDataType>;
  question?: Maybe<QuestionType>;
  questionCorrectAnswer: Array<DailyTipperQuestionAnswerType>;
  updated: Scalars['DateTime']['output'];
  userAnswer: Array<DuelRoundQuestionAnswerType>;
  userLekQuestionAnswer: Array<UserLekQuestionAnswerDataType>;
  userLekQuestionAnswerData: Array<UserLekQuestionAnswerDataType>;
  value: Scalars['String']['output'];
};

export type ApplyClassRoomCodeMutation = {
  __typename?: 'ApplyClassRoomCodeMutation';
  classRoom?: Maybe<ClassRoomLearningSessionType>;
};

export type ApplyNetworkCodeForUserMutation = {
  __typename?: 'ApplyNetworkCodeForUserMutation';
  codes?: Maybe<Array<Maybe<CodesType>>>;
};

export type CancelSubscriptionMutation = {
  __typename?: 'CancelSubscriptionMutation';
  subscription?: Maybe<SubscriptionType>;
};

export type CanceledInAppSubscribeMutation = {
  __typename?: 'CanceledInAppSubscribeMutation';
  inAppSubscription?: Maybe<InAppSubscriptionType>;
};

export type CertificateType = {
  __typename?: 'CertificateType';
  classroomSet: Array<ClassRoomType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  points: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type ChangeInAppSubscribeMutation = {
  __typename?: 'ChangeInAppSubscribeMutation';
  inAppSubscription?: Maybe<InAppSubscriptionType>;
};

export type ChangeSubscriptionMutation = {
  __typename?: 'ChangeSubscriptionMutation';
  subscription?: Maybe<SubscriptionType>;
};

export enum CheckoutSessionMode {
  Payment = 'PAYMENT',
  Setup = 'SETUP',
  Subscription = 'SUBSCRIPTION'
}

export type CheckoutSessionStatusType = {
  __typename?: 'CheckoutSessionStatusType';
  session?: Maybe<Scalars['GenericScalar']['output']>;
  status: Scalars['String']['output'];
};

export type CityType = {
  __typename?: 'CityType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lectorSet: Array<LectorType>;
  organizerSet: Array<OrganizerType>;
  title?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export enum ClassRoomLearningSessionStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ClassRoomLearningSessionType = {
  __typename?: 'ClassRoomLearningSessionType';
  classRoom: ClassRoomType;
  code?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  deepLink?: Maybe<Scalars['String']['output']>;
  duelResultUserData: Array<DuelResultUserDataType>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isForPremiumOnly: Scalars['Boolean']['output'];
  isForSingle: Scalars['Boolean']['output'];
  isForTest: Scalars['Boolean']['output'];
  isOnboardingSession: Scalars['Boolean']['output'];
  lekSession: Array<LekSessionType>;
  maxUserCapacity?: Maybe<Scalars['Int']['output']>;
  specialityGroupIcon?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  status?: Maybe<ClassRoomLearningSessionStatus>;
  updated: Scalars['DateTime']['output'];
  userClassRoomCorrectAnswersData: Array<UserLearningSessionCorrectAnswersDataType>;
  userClassRoomLearningSessionSettings: Array<UserClassRoomLearningSessionSettingsType>;
  userLectureCorrectAnswersData: Array<UserLectureCorrectAnswersDataType>;
  users: Array<UserType>;
};

export enum ClassRoomLectureStatus {
  Deleted = 'DELETED',
  Joined = 'JOINED'
}

export type ClassRoomLectureType = {
  __typename?: 'ClassRoomLectureType';
  aggregatedRate?: Maybe<AggregatedRateType>;
  classRoom: ClassRoomType;
  correctAnswerCount?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  lecture: LectureType;
  lectureGoal?: Maybe<Scalars['Int']['output']>;
  lectureNumber: Scalars['Int']['output'];
  lectureQuestionCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ClassRoomLectureStatus>;
  updated: Scalars['DateTime']['output'];
};


export type ClassRoomLectureTypeCorrectAnswerCountArgs = {
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ClassRoomLectureTypeLectureGoalArgs = {
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ClassRoomLectureTypeLectureQuestionCountArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ClassRoomMemberType = {
  __typename?: 'ClassRoomMemberType';
  id?: Maybe<Scalars['UUID']['output']>;
  isAvailableForDuel?: Maybe<Scalars['Boolean']['output']>;
  userData?: Maybe<UserLearningSessionCorrectAnswersDataType>;
};

export type ClassRoomType = {
  __typename?: 'ClassRoomType';
  aggregatedRate?: Maybe<AggregatedRateType>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  certificate?: Maybe<CertificateType>;
  classRoomImage?: Maybe<Scalars['String']['output']>;
  classRoomLearningSession: Array<ClassRoomLearningSessionType>;
  classRoomLecture: Array<ClassRoomLectureType>;
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  enrollmentType?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  isExternalOrganizer?: Maybe<Scalars['Boolean']['output']>;
  learningMoreInfoLink?: Maybe<Scalars['String']['output']>;
  lectures: Array<LectureType>;
  organizer?: Maybe<OrganizerType>;
  professions: Array<ProfessionType>;
  specialities: Array<SpecialityType>;
  specialityGroups: Array<SpecialityGroupType>;
  sponsors: Array<SponsorType>;
  title: Scalars['String']['output'];
  university?: Maybe<UniversityType>;
  updated: Scalars['DateTime']['output'];
};

export enum CodeModelCodeMode {
  A_1 = 'A_1',
  A_2 = 'A_2'
}

export type CodesType = {
  __typename?: 'CodesType';
  code: Scalars['Int']['output'];
  codeMode?: Maybe<CodeModelCodeMode>;
  created: Scalars['DateTime']['output'];
  finishDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxCodeUserCount?: Maybe<Scalars['Int']['output']>;
  network?: Maybe<NetworkType>;
  numberOfCodes?: Maybe<Scalars['Int']['output']>;
  periodOfValidity?: Maybe<Scalars['Int']['output']>;
  professions: Array<ProfessionType>;
  specialities: Array<SpecialityType>;
  sponsor?: Maybe<SponsorType>;
  startDate: Scalars['Date']['output'];
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export enum CouponStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum CouponSubscriptionType {
  ProfessionalMonthly = 'PROFESSIONAL_MONTHLY',
  ProfessionalYearly = 'PROFESSIONAL_YEARLY',
  StudentMonthly = 'STUDENT_MONTHLY',
  StudentYearly = 'STUDENT_YEARLY'
}

export type CouponType = {
  __typename?: 'CouponType';
  couponName?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['String']['output']>;
  finishActiveDatetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  startActiveDatetime?: Maybe<Scalars['DateTime']['output']>;
  status: CouponStatus;
  subscriptionType: CouponSubscriptionType;
  updated: Scalars['DateTime']['output'];
};

export type CreateCheckoutSessionMutation = {
  __typename?: 'CreateCheckoutSessionMutation';
  session?: Maybe<Scalars['GenericScalar']['output']>;
  subscription?: Maybe<SubscriptionType>;
};

export type CreateDailyTipperMutation = {
  __typename?: 'CreateDailyTipperMutation';
  dailyTipperData?: Maybe<DailyTipperDataType>;
};

export type CreateDuelMutation = {
  __typename?: 'CreateDuelMutation';
  duel?: Maybe<DuelType>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateFeedbackForQuestionMutation = {
  __typename?: 'CreateFeedbackForQuestionMutation';
  feedbackForQuestion?: Maybe<FeedbackForQuestionType>;
};

export type CreateQuizDuelByOpponentMutation = {
  __typename?: 'CreateQuizDuelByOpponentMutation';
  duel?: Maybe<DuelType>;
};

export type CreateQuizDuelMutation = {
  __typename?: 'CreateQuizDuelMutation';
  duel?: Maybe<DuelType>;
};

export type CreateRoundMutation = {
  __typename?: 'CreateRoundMutation';
  round?: Maybe<DuelRoundType>;
};

export type CreateSetupCheckoutSessionMutation = {
  __typename?: 'CreateSetupCheckoutSessionMutation';
  session?: Maybe<Scalars['GenericScalar']['output']>;
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  code?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  exponent: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priceSet: Array<PriceType>;
  symbol?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type CustomerType = {
  __typename?: 'CustomerType';
  created: Scalars['DateTime']['output'];
  defaultCard?: Maybe<DefaultCardType>;
  id: Scalars['UUID']['output'];
  paymentSubscription?: Maybe<SubscriptionType>;
  subscription?: Maybe<SubscriptionType>;
  updated: Scalars['DateTime']['output'];
  user: UserType;
};

export enum DailyStatusType {
  Minus = 'MINUS',
  Plus = 'PLUS',
  TakeAchievement = 'TAKE_ACHIEVEMENT',
  TakeYearAchievement = 'TAKE_YEAR_ACHIEVEMENT'
}

export type DailyTipperAchievementsType = {
  __typename?: 'DailyTipperAchievementsType';
  achievement?: Maybe<AchievementType>;
  isAchieved?: Maybe<Scalars['Boolean']['output']>;
  usersWithAchievement?: Maybe<Array<Maybe<DailyTipperType>>>;
  usersWithAchievementCount?: Maybe<Scalars['Int']['output']>;
};

export type DailyTipperDataType = {
  __typename?: 'DailyTipperDataType';
  currentAchievement?: Maybe<Scalars['Int']['output']>;
  dailyResultStatus?: Maybe<DailyStatusType>;
  dailyTipperQuestions?: Maybe<Array<Maybe<DailyTipperQuestionAnswerType>>>;
  daysLost?: Maybe<Scalars['Int']['output']>;
  questionsInfo?: Maybe<Array<Maybe<DailyTipperQuestionsInfoType>>>;
  yearNumber?: Maybe<Scalars['Int']['output']>;
};

export type DailyTipperQuestionAnswerDailyStatusType = {
  __typename?: 'DailyTipperQuestionAnswerDailyStatusType';
  dailyStatus?: Maybe<DailyStatusType>;
  dailyTipperQuestionAnswer?: Maybe<DailyTipperQuestionAnswerType>;
};

export type DailyTipperQuestionAnswerType = {
  __typename?: 'DailyTipperQuestionAnswerType';
  actualLearningWeek?: Maybe<ActualLearnWeekType>;
  answerIsCorrect?: Maybe<Scalars['Boolean']['output']>;
  correctAnswer?: Maybe<AnswersType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionType>;
  questionNumber?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  userAnswer?: Maybe<AnswersType>;
};

export type DailyTipperQuestionsInfoType = {
  __typename?: 'DailyTipperQuestionsInfoType';
  classRoomLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  questionId?: Maybe<Scalars['UUID']['output']>;
};

export enum DailyTipperStatusType {
  Finished = 'FINISHED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type DailyTipperType = {
  __typename?: 'DailyTipperType';
  actuallearnweekSet: Array<ActualLearnWeekType>;
  created: Scalars['DateTime']['output'];
  currentAchievement?: Maybe<AchievementType>;
  dailyStatus?: Maybe<DailyTipperStatusType>;
  id: Scalars['UUID']['output'];
  nextAchievement?: Maybe<AchievementType>;
  totalProgress?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  yearAchievement?: Maybe<YearAchievementType>;
};

export type DataProtectionType = {
  __typename?: 'DataProtectionType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type DeepLinkType = {
  __typename?: 'DeepLinkType';
  targetObjectId: Scalars['UUID']['output'];
  targetType?: Maybe<Scalars['String']['output']>;
};

export type DefaultCardType = {
  __typename?: 'DefaultCardType';
  brand?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type DeleteAccountMutation = {
  __typename?: 'DeleteAccountMutation';
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DirectChangeSystemMutation = {
  __typename?: 'DirectChangeSystemMutation';
  result?: Maybe<Scalars['GenericScalar']['output']>;
};

export type DiseaseType = {
  __typename?: 'DiseaseType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lectureSet: Array<LectureType>;
  lekSet: Array<LekType>;
  questionsSet: Array<QuestionType>;
  quizTime: Array<QuizTimeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type DuelDataType = {
  __typename?: 'DuelDataType';
  id?: Maybe<Scalars['UUID']['output']>;
  isOnboardingDuel?: Maybe<Scalars['Boolean']['output']>;
  opponentScore?: Maybe<DuelResultUserDataType>;
  quizSession?: Maybe<QuizTimeSessionType>;
  rounds?: Maybe<Array<Maybe<DuelRoundType>>>;
  session?: Maybe<ClassRoomLearningSessionType>;
  status?: Maybe<DuelStatusesEnum>;
  userScore?: Maybe<DuelResultUserDataType>;
};

export type DuelResultType = {
  __typename?: 'DuelResultType';
  currentUserData?: Maybe<DuelResultUserDataType>;
  opponentData?: Maybe<DuelResultUserDataType>;
};

export type DuelResultUserDataType = {
  __typename?: 'DuelResultUserDataType';
  classRoomLearningSession?: Maybe<ClassRoomLearningSessionType>;
  created: Scalars['DateTime']['output'];
  duel?: Maybe<DuelType>;
  duelScore?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  initiator?: Maybe<Scalars['Boolean']['output']>;
  quizSession?: Maybe<QuizTimeSessionType>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  userClassRoomLearningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
  userStatus: DuelResultUserDataUserStatus;
  youTurn?: Maybe<Scalars['Boolean']['output']>;
};

export enum DuelResultUserDataUserStatus {
  A_1 = 'A_1',
  A_2 = 'A_2',
  A_3 = 'A_3',
  A_4 = 'A_4'
}

export type DuelRoundQuestionAnswerType = {
  __typename?: 'DuelRoundQuestionAnswerType';
  answerCorrect?: Maybe<Scalars['Boolean']['output']>;
  correctAnswer?: Maybe<AnswersType>;
  created: Scalars['DateTime']['output'];
  duelRound?: Maybe<DuelRoundType>;
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionType>;
  questionNumber?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  userAnswer?: Maybe<AnswersType>;
};

export type DuelRoundType = {
  __typename?: 'DuelRoundType';
  created: Scalars['DateTime']['output'];
  duel?: Maybe<DuelType>;
  id: Scalars['UUID']['output'];
  roundNumber: Scalars['Int']['output'];
  specification?: Maybe<SpecificationType>;
  statusIgnored: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
  userQuestions: Array<DuelRoundQuestionAnswerType>;
};

export enum DuelStatus {
  Finished = 'FINISHED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum DuelStatusesEnum {
  Finished = 'FINISHED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type DuelType = {
  __typename?: 'DuelType';
  created: Scalars['DateTime']['output'];
  duelResultUserData: Array<DuelResultUserDataType>;
  duelRound: Array<DuelRoundType>;
  id: Scalars['UUID']['output'];
  isOnboardingDuel: Scalars['Boolean']['output'];
  result?: Maybe<DuelResultType>;
  status?: Maybe<DuelStatus>;
  updated: Scalars['DateTime']['output'];
};

export type EarlyFinishBlendedClassRoomMutation = {
  __typename?: 'EarlyFinishBlendedClassRoomMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type EarlyFinishLekClassRoomMutation = {
  __typename?: 'EarlyFinishLEKClassRoomMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type EarlyFinishNetworkClassRoomMutation = {
  __typename?: 'EarlyFinishNetworkClassRoomMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type EducationLevelType = {
  __typename?: 'EducationLevelType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type ExplanationType = {
  __typename?: 'ExplanationType';
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type FeatureFlagType = {
  __typename?: 'FeatureFlagType';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type FeedbackForQuestionType = {
  __typename?: 'FeedbackForQuestionType';
  comment?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  interestRate?: Maybe<Scalars['Int']['output']>;
  isReviewed: Scalars['Boolean']['output'];
  question: QuestionType;
  relevanceRate?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  user: UserType;
};

export type FinishedClassRoomLearningSessionType = {
  __typename?: 'FinishedClassRoomLearningSessionType';
  correctAnswersAmount?: Maybe<Scalars['Int']['output']>;
  correctAnswersGoal?: Maybe<Scalars['Int']['output']>;
  learningSession?: Maybe<ClassRoomLearningSessionType>;
  networkStartDate?: Maybe<Scalars['String']['output']>;
  outViaSubscriptionDate?: Maybe<Scalars['String']['output']>;
  questionsAmount?: Maybe<Scalars['Int']['output']>;
  specialityGroupIcon?: Maybe<Scalars['String']['output']>;
  userLearningSessionSettingsId?: Maybe<Scalars['UUID']['output']>;
};

export type FinishedUserQuizSessionType = {
  __typename?: 'FinishedUserQuizSessionType';
  id?: Maybe<Scalars['UUID']['output']>;
  quizSession?: Maybe<QuizTimeSessionType>;
  userRank?: Maybe<Scalars['Int']['output']>;
};

export type FreeTagType = {
  __typename?: 'FreeTagType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lecture: Array<LectureType>;
  lekSet: Array<LekType>;
  questionsSet: Array<QuestionType>;
  quizTimes: Array<QuizTimeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type GetDeepLink = {
  __typename?: 'GetDeepLink';
  deepLink?: Maybe<DeepLinkType>;
};

export type HomeQuizTimeSessionsType = {
  __typename?: 'HomeQuizTimeSessionsType';
  id?: Maybe<Scalars['UUID']['output']>;
  quizSession?: Maybe<QuizTimeSessionType>;
  userStatus?: Maybe<Scalars['String']['output']>;
};

export type Icd10TagType = {
  __typename?: 'Icd10TagType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lecture: Array<LectureType>;
  lekSet: Array<LekType>;
  questionsSet: Array<QuestionType>;
  quizTimes: Array<QuizTimeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type ImpressumType = {
  __typename?: 'ImpressumType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type InAppSubscribeMutation = {
  __typename?: 'InAppSubscribeMutation';
  inAppSubscription?: Maybe<InAppSubscriptionType>;
};

export enum InAppSubscriptionSubscriptingType {
  ProfessionalMonthly = 'PROFESSIONAL_MONTHLY',
  ProfessionalPro = 'PROFESSIONAL_PRO',
  ProfessionalYearly = 'PROFESSIONAL_YEARLY',
  StudentMonthly = 'STUDENT_MONTHLY',
  StudentSprint = 'STUDENT_SPRINT',
  StudentSystem = 'STUDENT_SYSTEM',
  StudentYearly = 'STUDENT_YEARLY'
}

export type InAppSubscriptionType = {
  __typename?: 'InAppSubscriptionType';
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer: UserType;
  expirationDatetime?: Maybe<Scalars['DateTime']['output']>;
  firstPaymentSent: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  me?: Maybe<UserType>;
  price: Scalars['Decimal']['output'];
  revenuecatPayloadList?: Maybe<Scalars['JSONString']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Scalars['String']['output']>;
  subscriptingType?: Maybe<InAppSubscriptionSubscriptingType>;
  subscription?: Maybe<UserSubscriptionType>;
  subscriptionObject?: Maybe<Scalars['GenericScalar']['output']>;
  updated: Scalars['DateTime']['output'];
  webhookObjectList?: Maybe<Scalars['JSONString']['output']>;
};

export type JoinToBlendedClassRoomMutation = {
  __typename?: 'JoinToBlendedClassRoomMutation';
  classRoomSession?: Maybe<ClassRoomLearningSessionType>;
};

export type JoinToCmeClassRoomMutation = {
  __typename?: 'JoinToCMEClassRoomMutation';
  classRoomSession?: Maybe<ClassRoomLearningSessionType>;
};

export type JoinToLekClassRoomMutation = {
  __typename?: 'JoinToLEKClassRoomMutation';
  classRoomSession?: Maybe<ClassRoomLearningSessionType>;
};

export type JoinToNetworkClassRoomMutation = {
  __typename?: 'JoinToNetworkClassRoomMutation';
  classRoomSession?: Maybe<ClassRoomLearningSessionType>;
};

export type JoinToQuizMutation = {
  __typename?: 'JoinToQuizMutation';
  quizSession?: Maybe<QuizTimeSessionType>;
};

export type LekFinishMutation = {
  __typename?: 'LEKFinishMutation';
  userLekData?: Maybe<UserLekDataType>;
};

export type LekQuestionsType = {
  __typename?: 'LEKQuestionsType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lek: LekType;
  question: QuestionType;
  updated: Scalars['DateTime']['output'];
};

export enum LekSessionFinishTime {
  A_00_00 = 'A_00_00',
  A_00_15 = 'A_00_15',
  A_00_30 = 'A_00_30',
  A_00_45 = 'A_00_45',
  A_01_00 = 'A_01_00',
  A_01_15 = 'A_01_15',
  A_01_30 = 'A_01_30',
  A_01_45 = 'A_01_45',
  A_02_00 = 'A_02_00',
  A_02_15 = 'A_02_15',
  A_02_30 = 'A_02_30',
  A_02_45 = 'A_02_45',
  A_03_00 = 'A_03_00',
  A_03_15 = 'A_03_15',
  A_03_30 = 'A_03_30',
  A_03_45 = 'A_03_45',
  A_04_00 = 'A_04_00',
  A_04_15 = 'A_04_15',
  A_04_30 = 'A_04_30',
  A_04_45 = 'A_04_45',
  A_05_00 = 'A_05_00',
  A_05_15 = 'A_05_15',
  A_05_30 = 'A_05_30',
  A_05_45 = 'A_05_45',
  A_06_00 = 'A_06_00',
  A_06_15 = 'A_06_15',
  A_06_30 = 'A_06_30',
  A_06_45 = 'A_06_45',
  A_07_00 = 'A_07_00',
  A_07_15 = 'A_07_15',
  A_07_30 = 'A_07_30',
  A_07_45 = 'A_07_45',
  A_08_00 = 'A_08_00',
  A_08_15 = 'A_08_15',
  A_08_30 = 'A_08_30',
  A_08_45 = 'A_08_45',
  A_09_00 = 'A_09_00',
  A_09_15 = 'A_09_15',
  A_09_30 = 'A_09_30',
  A_09_45 = 'A_09_45',
  A_10_00 = 'A_10_00',
  A_10_15 = 'A_10_15',
  A_10_30 = 'A_10_30',
  A_10_45 = 'A_10_45',
  A_11_00 = 'A_11_00',
  A_11_15 = 'A_11_15',
  A_11_30 = 'A_11_30',
  A_11_45 = 'A_11_45',
  A_12_00 = 'A_12_00',
  A_12_15 = 'A_12_15',
  A_12_30 = 'A_12_30',
  A_12_45 = 'A_12_45',
  A_13_00 = 'A_13_00',
  A_13_15 = 'A_13_15',
  A_13_30 = 'A_13_30',
  A_13_45 = 'A_13_45',
  A_14_00 = 'A_14_00',
  A_14_15 = 'A_14_15',
  A_14_30 = 'A_14_30',
  A_14_45 = 'A_14_45',
  A_15_00 = 'A_15_00',
  A_15_15 = 'A_15_15',
  A_15_30 = 'A_15_30',
  A_15_45 = 'A_15_45',
  A_16_00 = 'A_16_00',
  A_16_15 = 'A_16_15',
  A_16_30 = 'A_16_30',
  A_16_45 = 'A_16_45',
  A_17_00 = 'A_17_00',
  A_17_15 = 'A_17_15',
  A_17_30 = 'A_17_30',
  A_17_45 = 'A_17_45',
  A_18_00 = 'A_18_00',
  A_18_15 = 'A_18_15',
  A_18_30 = 'A_18_30',
  A_18_45 = 'A_18_45',
  A_19_00 = 'A_19_00',
  A_19_15 = 'A_19_15',
  A_19_30 = 'A_19_30',
  A_19_45 = 'A_19_45',
  A_20_00 = 'A_20_00',
  A_20_15 = 'A_20_15',
  A_20_30 = 'A_20_30',
  A_20_45 = 'A_20_45',
  A_21_00 = 'A_21_00',
  A_21_15 = 'A_21_15',
  A_21_30 = 'A_21_30',
  A_21_45 = 'A_21_45',
  A_22_00 = 'A_22_00',
  A_22_15 = 'A_22_15',
  A_22_30 = 'A_22_30',
  A_22_45 = 'A_22_45',
  A_23_00 = 'A_23_00',
  A_23_15 = 'A_23_15',
  A_23_30 = 'A_23_30',
  A_23_45 = 'A_23_45'
}

export enum LekSessionStartTime {
  A_00_00 = 'A_00_00',
  A_00_15 = 'A_00_15',
  A_00_30 = 'A_00_30',
  A_00_45 = 'A_00_45',
  A_01_00 = 'A_01_00',
  A_01_15 = 'A_01_15',
  A_01_30 = 'A_01_30',
  A_01_45 = 'A_01_45',
  A_02_00 = 'A_02_00',
  A_02_15 = 'A_02_15',
  A_02_30 = 'A_02_30',
  A_02_45 = 'A_02_45',
  A_03_00 = 'A_03_00',
  A_03_15 = 'A_03_15',
  A_03_30 = 'A_03_30',
  A_03_45 = 'A_03_45',
  A_04_00 = 'A_04_00',
  A_04_15 = 'A_04_15',
  A_04_30 = 'A_04_30',
  A_04_45 = 'A_04_45',
  A_05_00 = 'A_05_00',
  A_05_15 = 'A_05_15',
  A_05_30 = 'A_05_30',
  A_05_45 = 'A_05_45',
  A_06_00 = 'A_06_00',
  A_06_15 = 'A_06_15',
  A_06_30 = 'A_06_30',
  A_06_45 = 'A_06_45',
  A_07_00 = 'A_07_00',
  A_07_15 = 'A_07_15',
  A_07_30 = 'A_07_30',
  A_07_45 = 'A_07_45',
  A_08_00 = 'A_08_00',
  A_08_15 = 'A_08_15',
  A_08_30 = 'A_08_30',
  A_08_45 = 'A_08_45',
  A_09_00 = 'A_09_00',
  A_09_15 = 'A_09_15',
  A_09_30 = 'A_09_30',
  A_09_45 = 'A_09_45',
  A_10_00 = 'A_10_00',
  A_10_15 = 'A_10_15',
  A_10_30 = 'A_10_30',
  A_10_45 = 'A_10_45',
  A_11_00 = 'A_11_00',
  A_11_15 = 'A_11_15',
  A_11_30 = 'A_11_30',
  A_11_45 = 'A_11_45',
  A_12_00 = 'A_12_00',
  A_12_15 = 'A_12_15',
  A_12_30 = 'A_12_30',
  A_12_45 = 'A_12_45',
  A_13_00 = 'A_13_00',
  A_13_15 = 'A_13_15',
  A_13_30 = 'A_13_30',
  A_13_45 = 'A_13_45',
  A_14_00 = 'A_14_00',
  A_14_15 = 'A_14_15',
  A_14_30 = 'A_14_30',
  A_14_45 = 'A_14_45',
  A_15_00 = 'A_15_00',
  A_15_15 = 'A_15_15',
  A_15_30 = 'A_15_30',
  A_15_45 = 'A_15_45',
  A_16_00 = 'A_16_00',
  A_16_15 = 'A_16_15',
  A_16_30 = 'A_16_30',
  A_16_45 = 'A_16_45',
  A_17_00 = 'A_17_00',
  A_17_15 = 'A_17_15',
  A_17_30 = 'A_17_30',
  A_17_45 = 'A_17_45',
  A_18_00 = 'A_18_00',
  A_18_15 = 'A_18_15',
  A_18_30 = 'A_18_30',
  A_18_45 = 'A_18_45',
  A_19_00 = 'A_19_00',
  A_19_15 = 'A_19_15',
  A_19_30 = 'A_19_30',
  A_19_45 = 'A_19_45',
  A_20_00 = 'A_20_00',
  A_20_15 = 'A_20_15',
  A_20_30 = 'A_20_30',
  A_20_45 = 'A_20_45',
  A_21_00 = 'A_21_00',
  A_21_15 = 'A_21_15',
  A_21_30 = 'A_21_30',
  A_21_45 = 'A_21_45',
  A_22_00 = 'A_22_00',
  A_22_15 = 'A_22_15',
  A_22_30 = 'A_22_30',
  A_22_45 = 'A_22_45',
  A_23_00 = 'A_23_00',
  A_23_15 = 'A_23_15',
  A_23_30 = 'A_23_30',
  A_23_45 = 'A_23_45'
}

export enum LekSessionStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type LekSessionType = {
  __typename?: 'LEKSessionType';
  classRoomLearningSession: ClassRoomLearningSessionType;
  created: Scalars['DateTime']['output'];
  finishDate: Scalars['Date']['output'];
  finishDateTime?: Maybe<Scalars['DateTime']['output']>;
  finishTime?: Maybe<LekSessionFinishTime>;
  id: Scalars['UUID']['output'];
  lek: LekType;
  startDate: Scalars['Date']['output'];
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<LekSessionStartTime>;
  status?: Maybe<LekSessionStatus>;
  updated: Scalars['DateTime']['output'];
  userLekData: Array<UserLekDataType>;
};

export type LekStartMutation = {
  __typename?: 'LEKStartMutation';
  userLekData?: Maybe<UserLekDataType>;
};

export type LekType = {
  __typename?: 'LEKType';
  answerTimeDuration: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  diseases: Array<DiseaseType>;
  freeTags: Array<FreeTagType>;
  icd10tags: Array<Icd10TagType>;
  id: Scalars['UUID']['output'];
  lekGoal: Scalars['Int']['output'];
  lekQuestions: Array<LekQuestionsType>;
  lekSession: Array<LekSessionType>;
  possibleAttempts: Scalars['Int']['output'];
  professions: Array<ProfessionType>;
  questionCount?: Maybe<Scalars['Int']['output']>;
  questions: Array<QuestionType>;
  specialities: Array<SpecialityType>;
  specifications: Array<SpecificationType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type LeaveClassRoomMutation = {
  __typename?: 'LeaveClassRoomMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type LeaveNetworkClassRoomMutation = {
  __typename?: 'LeaveNetworkClassRoomMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type LeaveQuizMutation = {
  __typename?: 'LeaveQuizMutation';
  session?: Maybe<QuizTimeSessionType>;
};

export type LectorType = {
  __typename?: 'LectorType';
  about?: Maybe<Scalars['String']['output']>;
  aggregatedRate?: Maybe<AggregatedRateType>;
  city?: Maybe<CityType>;
  created: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  lectureSet: Array<LectureType>;
  photo?: Maybe<Scalars['String']['output']>;
  professions: Array<ProfessionType>;
  specialities: Array<SpecialityType>;
  updated: Scalars['DateTime']['output'];
};

export type LectureType = {
  __typename?: 'LectureType';
  classRoomLecture: Array<ClassRoomLectureType>;
  classroomSet: Array<ClassRoomType>;
  correctAnswersGoal?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  diseases: Array<DiseaseType>;
  freeTags: Array<FreeTagType>;
  icd10tags: Array<Icd10TagType>;
  id: Scalars['UUID']['output'];
  lectors: Array<LectorType>;
  lectureLink?: Maybe<Scalars['String']['output']>;
  networkCorrectAnswersGoal?: Maybe<Scalars['Int']['output']>;
  professions: Array<ProfessionType>;
  questions: Array<QuestionType>;
  specialities: Array<SpecialityType>;
  specifications: Array<SpecificationType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  userLectureCorrectAnswersData: Array<UserLectureCorrectAnswersDataType>;
};

export type LinkCategoryType = {
  __typename?: 'LinkCategoryType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  link: Array<LinkType>;
  placeNumber: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type LinkType = {
  __typename?: 'LinkType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  linkCategory: LinkCategoryType;
  questionLink: Array<QuestionLinkType>;
  questions: Array<QuestionType>;
  updated: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type MonthlyScoreType = {
  __typename?: 'MonthlyScoreType';
  created: Scalars['DateTime']['output'];
  duels: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  loss: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  ties: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  wins: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addWaitingUser?: Maybe<AddWaitingUser>;
  applyClassRoomCode?: Maybe<ApplyClassRoomCodeMutation>;
  applyNetworkCodeForUser?: Maybe<ApplyNetworkCodeForUserMutation>;
  cancelSubscription?: Maybe<CancelSubscriptionMutation>;
  canceledInAppSubscription?: Maybe<CanceledInAppSubscribeMutation>;
  changeInAppSubscription?: Maybe<ChangeInAppSubscribeMutation>;
  changeSubscription?: Maybe<ChangeSubscriptionMutation>;
  createCheckoutSession?: Maybe<CreateCheckoutSessionMutation>;
  createDailyTipper?: Maybe<CreateDailyTipperMutation>;
  createDuel?: Maybe<CreateDuelMutation>;
  createFeedbackForQuestion?: Maybe<CreateFeedbackForQuestionMutation>;
  createQuizDuel?: Maybe<CreateQuizDuelMutation>;
  createQuizDuelByOpponent?: Maybe<CreateQuizDuelByOpponentMutation>;
  createRound?: Maybe<CreateRoundMutation>;
  createSetupCheckoutSession?: Maybe<CreateSetupCheckoutSessionMutation>;
  deleteAccount?: Maybe<DeleteAccountMutation>;
  deleteDefaultPaymentMethod?: Maybe<RemoveDefaultPaymentMethodMutation>;
  directChangeSystem?: Maybe<DirectChangeSystemMutation>;
  earlyFinishBlendedClassRoom?: Maybe<EarlyFinishBlendedClassRoomMutation>;
  earlyFinishLekClassRoom?: Maybe<EarlyFinishLekClassRoomMutation>;
  earlyFinishNetworkClassRoom?: Maybe<EarlyFinishNetworkClassRoomMutation>;
  editFeedbackForQuestion?: Maybe<UpdateFeedbackForQuestionMutation>;
  getDeepLink?: Maybe<GetDeepLink>;
  inAppSubscribe?: Maybe<InAppSubscribeMutation>;
  joinToBlendedClassRoom?: Maybe<JoinToBlendedClassRoomMutation>;
  joinToCmeClassRoom?: Maybe<JoinToCmeClassRoomMutation>;
  joinToLekClassRoom?: Maybe<JoinToLekClassRoomMutation>;
  joinToNetworkClassRoom?: Maybe<JoinToNetworkClassRoomMutation>;
  joinToQuiz?: Maybe<JoinToQuizMutation>;
  leaveClassRoom?: Maybe<LeaveClassRoomMutation>;
  leaveNetworkClassRoom?: Maybe<LeaveNetworkClassRoomMutation>;
  leaveQuiz?: Maybe<LeaveQuizMutation>;
  lekFinish?: Maybe<LekFinishMutation>;
  lekStart?: Maybe<LekStartMutation>;
  notificationStatus?: Maybe<NotificationMutation>;
  pauseBlendedClassRoom?: Maybe<PauseBlendedClassRoomSessionMutation>;
  quizStartByUser?: Maybe<QuizStartByUserMutation>;
  renewSubscription?: Maybe<RenewSubscriptionMutation>;
  resetKeyCheck?: Maybe<ResetPasswordKeyCheckMutation>;
  resumeBlendedClassRoom?: Maybe<ResumeBlendedClassRoomSessionMutation>;
  setAnswer?: Maybe<SetAnswerMutation>;
  setDailyTipperAnswer?: Maybe<SetDailyTipperAnswerMutation>;
  setLekAnswer?: Maybe<SetLekAnswerMutation>;
  setOnboardingAnswer?: Maybe<SetOnboardingAnswerMutation>;
  setUserExpoToken?: Maybe<SetUserExpoTokenMutation>;
  switchPauseMode?: Maybe<SwitchPauseModeMutation>;
  updateUserClassRoomSettings?: Maybe<UserClassRoomLearningSessionSettingsMutation>;
  updateUserData?: Maybe<UserUpdateProfileMutation>;
  updateUserSettings?: Maybe<UserSettingsUpdateMutation>;
  uploadPhoto?: Maybe<UserPhotoMutations>;
  userConfirm?: Maybe<UserConfirmMutation>;
  userForgotPassword?: Maybe<UserForgotPasswordMutation>;
  userLogin?: Maybe<UserLoginMutation>;
  userRegistration?: Maybe<UserRegistrationMutation>;
  userRestorePassword?: Maybe<UserRestorePasswordMutation>;
  userSubscribeToNews?: Maybe<UserSubscribeToNewsMutation>;
  userUnsubscribeToNews?: Maybe<UserUnsubscribeToNewsMutation>;
};


export type MutationAddWaitingUserArgs = {
  sessionId: Scalars['UUID']['input'];
};


export type MutationApplyClassRoomCodeArgs = {
  code?: InputMaybe<Scalars['Int']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  isAvailableTab?: InputMaybe<Scalars['Boolean']['input']>;
  isNetworkType?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  specialityGroupIcon?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApplyNetworkCodeForUserArgs = {
  code?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCanceledInAppSubscriptionArgs = {
  subscriptionObject?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationChangeInAppSubscriptionArgs = {
  subscriptionObject?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationChangeSubscriptionArgs = {
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCheckoutSessionArgs = {
  mode?: InputMaybe<CheckoutSessionMode>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  stripePriceId: Scalars['String']['input'];
};


export type MutationCreateDuelArgs = {
  isCustomDuel?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardingDuel?: InputMaybe<Scalars['Boolean']['input']>;
  opponentId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCreateFeedbackForQuestionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  interestRate: Scalars['Int']['input'];
  questionId: Scalars['UUID']['input'];
  relevanceRate: Scalars['Int']['input'];
};


export type MutationCreateQuizDuelArgs = {
  quizSessionId: Scalars['UUID']['input'];
};


export type MutationCreateQuizDuelByOpponentArgs = {
  opponentId: Scalars['UUID']['input'];
  quizSessionId: Scalars['UUID']['input'];
};


export type MutationCreateRoundArgs = {
  duelId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCreateSetupCheckoutSessionArgs = {
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  stripePriceId: Scalars['String']['input'];
};


export type MutationDirectChangeSystemArgs = {
  actions: Array<InputMaybe<Scalars['GenericScalar']['input']>>;
};


export type MutationEarlyFinishBlendedClassRoomArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationEarlyFinishLekClassRoomArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationEarlyFinishNetworkClassRoomArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationEditFeedbackForQuestionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  interestRate?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['UUID']['input'];
  relevanceRate?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGetDeepLinkArgs = {
  hash: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInAppSubscribeArgs = {
  subscriptionObject?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationJoinToBlendedClassRoomArgs = {
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationJoinToCmeClassRoomArgs = {
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  isAfterOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  specialityGroupIcon?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJoinToLekClassRoomArgs = {
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationJoinToNetworkClassRoomArgs = {
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  isAfterOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  specialityGroupIcon?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJoinToQuizArgs = {
  code?: InputMaybe<Scalars['Int']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['UUID']['input'];
};


export type MutationLeaveClassRoomArgs = {
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationLeaveNetworkClassRoomArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationLeaveQuizArgs = {
  sessionId: Scalars['UUID']['input'];
};


export type MutationLekFinishArgs = {
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  userLekDataId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationLekStartArgs = {
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationNotificationStatusArgs = {
  notificationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationPauseBlendedClassRoomArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationQuizStartByUserArgs = {
  quizSessionId: Scalars['UUID']['input'];
};


export type MutationResetKeyCheckArgs = {
  resetPasswordKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResumeBlendedClassRoomArgs = {
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetAnswerArgs = {
  answerId?: InputMaybe<Scalars['UUID']['input']>;
  duelRoundQuestionAnswerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetDailyTipperAnswerArgs = {
  answerId?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetLekAnswerArgs = {
  answerId?: InputMaybe<Scalars['UUID']['input']>;
  answerTime?: InputMaybe<Scalars['DateTime']['input']>;
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetOnboardingAnswerArgs = {
  answerId?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetUserExpoTokenArgs = {
  expoToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSwitchPauseModeArgs = {
  pauseMode: Scalars['Boolean']['input'];
  quizSessionId: Scalars['UUID']['input'];
};


export type MutationUpdateUserClassRoomSettingsArgs = {
  dailyTipperMode?: InputMaybe<Scalars['Boolean']['input']>;
  duelMode?: InputMaybe<Scalars['Boolean']['input']>;
  isAchieved?: InputMaybe<Scalars['Boolean']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isOut?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateUserDataArgs = {
  anotherProfession?: InputMaybe<Scalars['String']['input']>;
  anotherWorkplace?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  educationLevelId?: InputMaybe<Scalars['UUID']['input']>;
  efnNumber?: InputMaybe<Scalars['String']['input']>;
  examYear?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicineStudyBegin?: InputMaybe<Scalars['Date']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  semesterId?: InputMaybe<Scalars['UUID']['input']>;
  specialityId?: InputMaybe<Scalars['UUID']['input']>;
  studyBeginId?: InputMaybe<Scalars['UUID']['input']>;
  studyYearId?: InputMaybe<Scalars['UUID']['input']>;
  universityId?: InputMaybe<Scalars['UUID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workplaceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateUserSettingsArgs = {
  dailyTipperMailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  dailyTipperMode?: InputMaybe<Scalars['Boolean']['input']>;
  duelMailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  duelMode?: InputMaybe<Scalars['Boolean']['input']>;
  goal?: InputMaybe<Scalars['Int']['input']>;
  isChromeInstallationPopupSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  isClassRoomIntroCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCookieAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyTipperRulesRead?: InputMaybe<Scalars['Boolean']['input']>;
  isDuelRulesRead?: InputMaybe<Scalars['Boolean']['input']>;
  isIntroCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isIosInstallationPopupSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  isLikeHumeoQuestionRead?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketingCookieAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isQuizDuelRulesRead?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationDailyTipperMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationDuelMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationNewChapterMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationPremiumMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationQuizTimeMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUploadPhotoArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUserConfirmArgs = {
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUserForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserRegistrationArgs = {
  anotherProfession?: InputMaybe<Scalars['String']['input']>;
  anotherWorkplace?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  educationLevelId?: InputMaybe<Scalars['UUID']['input']>;
  efnNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  examYear?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  googleAdsMetadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicineStudyBegin?: InputMaybe<Scalars['Date']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  professionId?: InputMaybe<Scalars['UUID']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  semesterId?: InputMaybe<Scalars['UUID']['input']>;
  sharingSenderId?: InputMaybe<Scalars['UUID']['input']>;
  specialityId?: InputMaybe<Scalars['UUID']['input']>;
  studyBeginId?: InputMaybe<Scalars['UUID']['input']>;
  studyYearId?: InputMaybe<Scalars['UUID']['input']>;
  subscribeToNews?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['UUID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workplaceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUserRestorePasswordArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  newPasswordConfirmation?: InputMaybe<Scalars['String']['input']>;
  resetPasswordKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserSubscribeToNewsArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUserUnsubscribeToNewsArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NetworkType = {
  __typename?: 'NetworkType';
  accessScopes: Array<AccessScopeType>;
  brevoCategoryValue?: Maybe<Scalars['Int']['output']>;
  codemodelSet: Array<CodesType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  professions: Array<ProfessionType>;
  specialities: Array<SpecialityType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  userSet: Array<UserType>;
};

export type NotificationMutation = {
  __typename?: 'NotificationMutation';
  notification?: Maybe<NotificationType>;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  created: Scalars['DateTime']['output'];
  data: Scalars['JSONString']['output'];
  id: Scalars['UUID']['output'];
  isRead: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
};

export type OnboardingSpecialityGroupType = {
  __typename?: 'OnboardingSpecialityGroupType';
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  professions: Array<ProfessionType>;
  specialityGroup: SpecialityGroupType;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type OngoingUserLearningSessionType = {
  __typename?: 'OngoingUserLearningSessionType';
  correctAnswersAmount?: Maybe<Scalars['Int']['output']>;
  correctAnswersGoal?: Maybe<Scalars['Int']['output']>;
  isSessionActive?: Maybe<Scalars['Boolean']['output']>;
  learningSession?: Maybe<ClassRoomLearningSessionType>;
  networkStartDate?: Maybe<Scalars['String']['output']>;
  outViaSubscriptionDate?: Maybe<Scalars['String']['output']>;
  questionsAmount?: Maybe<Scalars['Int']['output']>;
  specialityGroupIcon?: Maybe<Scalars['String']['output']>;
};

export type OrganizerType = {
  __typename?: 'OrganizerType';
  about?: Maybe<Scalars['String']['output']>;
  city?: Maybe<CityType>;
  classroomSet: Array<ClassRoomType>;
  created: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  linkToSite?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quizTime: Array<QuizTimeType>;
  updated: Scalars['DateTime']['output'];
};

export type PauseBlendedClassRoomSessionMutation = {
  __typename?: 'PauseBlendedClassRoomSessionMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export enum PriceInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum PriceSyncState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Error = 'ERROR',
  LocalOnly = 'LOCAL_ONLY',
  PendingCreate = 'PENDING_CREATE',
  PendingDelete = 'PENDING_DELETE',
  PendingUpdate = 'PENDING_UPDATE'
}

export type PriceType = {
  __typename?: 'PriceType';
  accessScopes?: Maybe<Array<Maybe<AccessScopeType>>>;
  amount: Scalars['Decimal']['output'];
  appleStoreId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency: CurrencyType;
  description?: Maybe<Scalars['String']['output']>;
  googlePlayId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  interval?: Maybe<PriceInterval>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  livemode: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product: ProductType;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  subscriptionSet: Array<SubscriptionType>;
  syncState: PriceSyncState;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type PrivatePolicyType = {
  __typename?: 'PrivatePolicyType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export enum ProductSyncState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Error = 'ERROR',
  LocalOnly = 'LOCAL_ONLY',
  PendingCreate = 'PENDING_CREATE',
  PendingDelete = 'PENDING_DELETE',
  PendingUpdate = 'PENDING_UPDATE'
}

export type ProductType = {
  __typename?: 'ProductType';
  accessScopes: Array<AccessScopeType>;
  description?: Maybe<Scalars['String']['output']>;
  feId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prices: Array<PriceType>;
  syncState: ProductSyncState;
};

export type ProfessionType = {
  __typename?: 'ProfessionType';
  accessScopes: Array<AccessScopeType>;
  brevoCategoryValue?: Maybe<Scalars['Int']['output']>;
  classRooms: Array<ClassRoomType>;
  codes: Array<CodesType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  lectors: Array<LectorType>;
  lectureSet: Array<LectureType>;
  lekSet: Array<LekType>;
  network: Array<NetworkType>;
  onboardingSpecialityGroups: Array<OnboardingSpecialityGroupType>;
  questionsSet: Array<QuestionType>;
  quizTime: Array<QuizTimeType>;
  specificationSet: Array<SpecificationType>;
  title: Scalars['String']['output'];
  type?: Maybe<ProfessionTypeType>;
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type ProfessionTypeType = {
  __typename?: 'ProfessionTypeType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  professions: Array<ProfessionType>;
  specialities: Array<SpecialityType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  workplaces: Array<WorkplaceType>;
};

export type Query = {
  __typename?: 'Query';
  achievementsRang?: Maybe<Array<Maybe<DailyTipperAchievementsType>>>;
  activeDuels?: Maybe<Array<Maybe<ActiveDuelsType>>>;
  activeQuizDuels?: Maybe<Array<Maybe<ActiveQuizDuelsType>>>;
  announcedQuizSessions?: Maybe<Array<Maybe<QuizTimeSessionType>>>;
  answers?: Maybe<Array<Maybe<AnswersType>>>;
  availableClassRooms?: Maybe<Array<Maybe<ClassRoomLearningSessionType>>>;
  availableSessionsBySpecialityGroup?: Maybe<Array<Maybe<ClassRoomLearningSessionType>>>;
  certificate?: Maybe<CertificateType>;
  checkoutSessionStatus?: Maybe<CheckoutSessionStatusType>;
  classRoom?: Maybe<ClassRoomType>;
  classRoomByOrganizer?: Maybe<Array<Maybe<ClassRoomLearningSessionType>>>;
  classRoomCorrectAnswersData?: Maybe<UserLearningSessionCorrectAnswersDataType>;
  classRoomLearningSession?: Maybe<ClassRoomLearningSessionType>;
  classRoomLectures?: Maybe<Array<Maybe<ClassRoomLectureType>>>;
  classRoomMembers?: Maybe<Array<Maybe<ClassRoomMemberType>>>;
  classRoomSessionLectures?: Maybe<Array<Maybe<LectureType>>>;
  code?: Maybe<CodesType>;
  codes?: Maybe<Array<Maybe<CodesType>>>;
  completedDuels?: Maybe<Array<Maybe<UsersDuelsDataType>>>;
  completedQuizDuels?: Maybe<Array<Maybe<UsersQuizDuelsDataType>>>;
  contentAvailable?: Maybe<Scalars['Boolean']['output']>;
  currentLectorLectures?: Maybe<Array<Maybe<LectureType>>>;
  dailyStatus?: Maybe<Scalars['String']['output']>;
  dailyTipperData?: Maybe<DailyTipperDataType>;
  dailyTipperWeeklyProgress?: Maybe<ActualLearnWeekType>;
  dataProtection?: Maybe<DataProtectionType>;
  discounts?: Maybe<Array<Maybe<CouponType>>>;
  duelData?: Maybe<DuelDataType>;
  educationLevels?: Maybe<Array<Maybe<EducationLevelType>>>;
  efnNumberVerify?: Maybe<Scalars['Boolean']['output']>;
  emailVerify?: Maybe<Scalars['Boolean']['output']>;
  explanation?: Maybe<ExplanationType>;
  featureFlags?: Maybe<Array<Maybe<FeatureFlagType>>>;
  findClassRooms?: Maybe<Array<Maybe<ClassRoomLearningSessionType>>>;
  finishedClassRooms?: Maybe<Array<Maybe<FinishedClassRoomLearningSessionType>>>;
  finishedQuizSessions?: Maybe<Array<Maybe<FinishedUserQuizSessionType>>>;
  getFeedbackForQuestion?: Maybe<FeedbackForQuestionType>;
  homeQuizSessions?: Maybe<Array<Maybe<HomeQuizTimeSessionsType>>>;
  impressum?: Maybe<ImpressumType>;
  inProgressUserQuizSession?: Maybe<QuizTimeSessionType>;
  joinedClassRooms?: Maybe<Scalars['Int']['output']>;
  lastNotification?: Maybe<NotificationType>;
  lector?: Maybe<LectorType>;
  lecture?: Maybe<LectureType>;
  lekSession?: Maybe<LekSessionType>;
  lekSessionsData?: Maybe<Array<Maybe<UserLekDatasType>>>;
  me?: Maybe<UserType>;
  monthlyScore?: Maybe<MonthlyScoreType>;
  notifications?: Maybe<Array<Maybe<NotificationType>>>;
  onboardingQuestions?: Maybe<Array<Maybe<QuestionType>>>;
  onboardingSession?: Maybe<ClassRoomLearningSessionType>;
  ongoingClassRooms?: Maybe<Array<Maybe<OngoingUserLearningSessionType>>>;
  ongoingQuizSessions?: Maybe<Array<Maybe<QuizTimeSessionType>>>;
  organizer?: Maybe<OrganizerType>;
  ping: Scalars['String']['output'];
  plans?: Maybe<Array<Maybe<ProductType>>>;
  privatePolicy?: Maybe<PrivatePolicyType>;
  professions?: Maybe<Array<Maybe<ProfessionType>>>;
  professionsByType?: Maybe<Array<Maybe<ProfessionType>>>;
  questions?: Maybe<Array<Maybe<QuestionType>>>;
  quizDuelScore?: Maybe<QuizDuelScoreType>;
  quizSessionMembers?: Maybe<Array<Maybe<QuizSessionMemberType>>>;
  quizSessionPrize?: Maybe<QuizSessionPrizeListType>;
  quizTime?: Maybe<QuizTimeType>;
  quizTimeSession?: Maybe<QuizTimeSessionType>;
  quizUsers?: Maybe<Array<Maybe<UserType>>>;
  ranking?: Maybe<Array<Maybe<MonthlyScoreType>>>;
  searchNetworkClassRoomSessions?: Maybe<Array<Maybe<ClassRoomLearningSessionType>>>;
  semesters?: Maybe<Array<Maybe<SemesterType>>>;
  specialities?: Maybe<Array<Maybe<SpecialityType>>>;
  specialitiesByType?: Maybe<Array<Maybe<SpecialityType>>>;
  specialityGroup?: Maybe<SpecialityGroupType>;
  specialityGroupByType?: Maybe<SpecialityGroupType>;
  specifications?: Maybe<Array<Maybe<SpecificationType>>>;
  sponsor?: Maybe<SponsorType>;
  startedDuelsToday?: Maybe<Scalars['Int']['output']>;
  studySemesters?: Maybe<Array<Maybe<StudyBeginType>>>;
  studyYears?: Maybe<Array<Maybe<StudyYearType>>>;
  subscription?: Maybe<UserSubscriptionType>;
  topUsers?: Maybe<Array<Maybe<MonthlyScoreType>>>;
  types?: Maybe<Array<Maybe<ProfessionTypeType>>>;
  universities?: Maybe<Array<Maybe<UniversityType>>>;
  userClassRoomSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
  userDailyStats?: Maybe<Array<Maybe<UserDailyStatType>>>;
  userDuelsInfo?: Maybe<Array<Maybe<DuelResultUserDataType>>>;
  userLearningProgress?: Maybe<UserLearningProgressType>;
  userLectureCorrectAnswersData?: Maybe<UserLectureCorrectAnswersDataType>;
  userLekData?: Maybe<UserLekDataType>;
  userOnboardingSpecialityGroups?: Maybe<Scalars['GenericScalar']['output']>;
  userQuestionsCountData?: Maybe<UserLearningSessionQuestionsDataType>;
  userQuizSessionSettings?: Maybe<UserQuizSessionSettingsType>;
  userSettings?: Maybe<SettingsType>;
  userSpecialityGroupList?: Maybe<Array<Maybe<UserSpecialityGroupType>>>;
  usernameVerify?: Maybe<Scalars['Boolean']['output']>;
  usersDuels?: Maybe<Array<Maybe<DuelResultUserDataType>>>;
  workplaces?: Maybe<Array<Maybe<WorkplaceType>>>;
};


export type QueryAchievementsRangArgs = {
  showedInRankUsers?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActiveQuizDuelsArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAvailableClassRoomsArgs = {
  isNetworkType?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAvailableSessionsBySpecialityGroupArgs = {
  specialityGroupId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCertificateArgs = {
  certificateId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCheckoutSessionStatusArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryClassRoomArgs = {
  classRoomId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryClassRoomByOrganizerArgs = {
  organizerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryClassRoomCorrectAnswersDataArgs = {
  classRoomSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryClassRoomLearningSessionArgs = {
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryClassRoomLecturesArgs = {
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryClassRoomMembersArgs = {
  classRoomSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryClassRoomSessionLecturesArgs = {
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCompletedQuizDuelsArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCurrentLectorLecturesArgs = {
  lectorId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryDuelDataArgs = {
  duelId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEfnNumberVerifyArgs = {
  efnNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailVerifyArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExplanationArgs = {
  explanationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryFindClassRoomsArgs = {
  searchPointer?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFeedbackForQuestionArgs = {
  questionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryHomeQuizSessionsArgs = {
  startLess24Hours?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLectorArgs = {
  lectorId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLectureArgs = {
  lectureId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLekSessionArgs = {
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLekSessionsDataArgs = {
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryOngoingQuizSessionsArgs = {
  startLess24Hours?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizerArgs = {
  organizerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProfessionsByTypeArgs = {
  professionType?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQuizDuelScoreArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuizSessionMembersArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuizSessionPrizeArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuizTimeArgs = {
  quizTimeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuizTimeSessionArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuizUsersArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySearchNetworkClassRoomSessionsArgs = {
  searchPointer?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpecialitiesByTypeArgs = {
  professionType?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpecialityGroupArgs = {
  specialityGroupId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySpecialityGroupByTypeArgs = {
  groupType: SpecialityGroupTypeEnum;
};


export type QuerySpecificationsArgs = {
  duelId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserClassRoomSettingsArgs = {
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserLectureCorrectAnswersDataArgs = {
  classRoomSessionId?: InputMaybe<Scalars['UUID']['input']>;
  lectureId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserLekDataArgs = {
  attemptNumber?: InputMaybe<Scalars['Int']['input']>;
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserQuestionsCountDataArgs = {
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserQuizSessionSettingsArgs = {
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUsernameVerifyArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkplacesArgs = {
  professionType?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionLinkType = {
  __typename?: 'QuestionLinkType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  link: LinkType;
  question: QuestionType;
  updated: Scalars['DateTime']['output'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  answers: Array<AnswersType>;
  author?: Maybe<UserType>;
  created: Scalars['DateTime']['output'];
  dailytipperquestionanswerSet: Array<DailyTipperQuestionAnswerType>;
  dateOfManualUpdate?: Maybe<Scalars['Date']['output']>;
  diseases: Array<DiseaseType>;
  explanation?: Maybe<Scalars['String']['output']>;
  feedbackForQuestion: Array<FeedbackForQuestionType>;
  freeTags: Array<FreeTagType>;
  icd10Tags: Array<Icd10TagType>;
  id: Scalars['UUID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isUpdated: Scalars['Boolean']['output'];
  lecture: Array<LectureType>;
  lek: Array<LekType>;
  lekQuestions: Array<LekQuestionsType>;
  links: Array<LinkType>;
  professions: Array<ProfessionType>;
  questionImage?: Maybe<Scalars['String']['output']>;
  questionLink: Array<QuestionLinkType>;
  quizTimes: Array<QuizTimeType>;
  sortedLinks?: Maybe<Array<Maybe<LinkType>>>;
  specialities: Array<SpecialityType>;
  specifications: Array<SpecificationType>;
  updated: Scalars['DateTime']['output'];
  useInClassRoom: Scalars['Boolean']['output'];
  useInLek: Scalars['Boolean']['output'];
  useInNetwork: Scalars['Boolean']['output'];
  useInOnboarding: Scalars['Boolean']['output'];
  useInQuizTime: Scalars['Boolean']['output'];
  userLekQuestionAnswerData: Array<UserLekQuestionAnswerDataType>;
  userQuestions: Array<DuelRoundQuestionAnswerType>;
  useronboardingquestionanswerdataSet: Array<UserOnboardingQuestionAnswerDataType>;
  value: Scalars['String']['output'];
};

export type QuizDuelScoreType = {
  __typename?: 'QuizDuelScoreType';
  created: Scalars['DateTime']['output'];
  duels: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  loss: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  quizSession: QuizTimeSessionType;
  rank?: Maybe<Scalars['Int']['output']>;
  ties: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  wins: Scalars['Int']['output'];
};

export enum QuizSessionLabelStatusesEnum {
  Active = 'ACTIVE',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED'
}

export type QuizSessionMemberType = {
  __typename?: 'QuizSessionMemberType';
  id?: Maybe<Scalars['UUID']['output']>;
  isAvailableForQuizDuel?: Maybe<Scalars['Boolean']['output']>;
  userData?: Maybe<QuizDuelScoreType>;
};

export type QuizSessionPrizeListType = {
  __typename?: 'QuizSessionPrizeListType';
  lotteryList?: Maybe<Array<Maybe<QuizSessionPrizeType>>>;
  participationList?: Maybe<Array<Maybe<QuizSessionPrizeType>>>;
  placeList?: Maybe<Array<Maybe<QuizSessionPrizeType>>>;
};

export enum QuizSessionPrizePrizeType {
  Lottery = 'LOTTERY',
  Participation = 'PARTICIPATION',
  Place = 'PLACE'
}

export type QuizSessionPrizeType = {
  __typename?: 'QuizSessionPrizeType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isVisible: Scalars['Boolean']['output'];
  placeNumber?: Maybe<Scalars['Int']['output']>;
  prizeType?: Maybe<QuizSessionPrizePrizeType>;
  quizSession: QuizTimeSessionType;
  quizTimePrize: QuizTimePrizeType;
  roles?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type QuizStartByUserMutation = {
  __typename?: 'QuizStartByUserMutation';
  quizSession?: Maybe<QuizTimeSessionType>;
};

export type QuizTimePrizeType = {
  __typename?: 'QuizTimePrizeType';
  author?: Maybe<UserType>;
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  prizeImage?: Maybe<Scalars['String']['output']>;
  quizSession: Array<QuizTimeSessionType>;
  quizSessionPrize: Array<QuizSessionPrizeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export enum QuizTimeSessionAnnouncementPeriod {
  A_2 = 'A_2',
  A_7 = 'A_7',
  A_14 = 'A_14'
}

export enum QuizTimeSessionStartTime {
  A_00_00_00 = 'A_00_00_00',
  A_00_15_00 = 'A_00_15_00',
  A_00_30_00 = 'A_00_30_00',
  A_00_45_00 = 'A_00_45_00',
  A_01_00_00 = 'A_01_00_00',
  A_01_15_00 = 'A_01_15_00',
  A_01_30_00 = 'A_01_30_00',
  A_01_45_00 = 'A_01_45_00',
  A_02_00_00 = 'A_02_00_00',
  A_02_15_00 = 'A_02_15_00',
  A_02_30_00 = 'A_02_30_00',
  A_02_45_00 = 'A_02_45_00',
  A_03_00_00 = 'A_03_00_00',
  A_03_15_00 = 'A_03_15_00',
  A_03_30_00 = 'A_03_30_00',
  A_03_45_00 = 'A_03_45_00',
  A_04_00_00 = 'A_04_00_00',
  A_04_15_00 = 'A_04_15_00',
  A_04_30_00 = 'A_04_30_00',
  A_04_45_00 = 'A_04_45_00',
  A_05_00_00 = 'A_05_00_00',
  A_05_15_00 = 'A_05_15_00',
  A_05_30_00 = 'A_05_30_00',
  A_05_45_00 = 'A_05_45_00',
  A_06_00_00 = 'A_06_00_00',
  A_06_15_00 = 'A_06_15_00',
  A_06_30_00 = 'A_06_30_00',
  A_06_45_00 = 'A_06_45_00',
  A_07_00_00 = 'A_07_00_00',
  A_07_15_00 = 'A_07_15_00',
  A_07_30_00 = 'A_07_30_00',
  A_07_45_00 = 'A_07_45_00',
  A_08_00_00 = 'A_08_00_00',
  A_08_15_00 = 'A_08_15_00',
  A_08_30_00 = 'A_08_30_00',
  A_08_45_00 = 'A_08_45_00',
  A_09_00_00 = 'A_09_00_00',
  A_09_15_00 = 'A_09_15_00',
  A_09_30_00 = 'A_09_30_00',
  A_09_45_00 = 'A_09_45_00',
  A_10_00_00 = 'A_10_00_00',
  A_10_15_00 = 'A_10_15_00',
  A_10_30_00 = 'A_10_30_00',
  A_10_45_00 = 'A_10_45_00',
  A_11_00_00 = 'A_11_00_00',
  A_11_15_00 = 'A_11_15_00',
  A_11_30_00 = 'A_11_30_00',
  A_11_45_00 = 'A_11_45_00',
  A_12_00_00 = 'A_12_00_00',
  A_12_15_00 = 'A_12_15_00',
  A_12_30_00 = 'A_12_30_00',
  A_12_45_00 = 'A_12_45_00',
  A_13_00_00 = 'A_13_00_00',
  A_13_15_00 = 'A_13_15_00',
  A_13_30_00 = 'A_13_30_00',
  A_13_45_00 = 'A_13_45_00',
  A_14_00_00 = 'A_14_00_00',
  A_14_15_00 = 'A_14_15_00',
  A_14_30_00 = 'A_14_30_00',
  A_14_45_00 = 'A_14_45_00',
  A_15_00_00 = 'A_15_00_00',
  A_15_15_00 = 'A_15_15_00',
  A_15_30_00 = 'A_15_30_00',
  A_15_45_00 = 'A_15_45_00',
  A_16_00_00 = 'A_16_00_00',
  A_16_15_00 = 'A_16_15_00',
  A_16_30_00 = 'A_16_30_00',
  A_16_45_00 = 'A_16_45_00',
  A_17_00_00 = 'A_17_00_00',
  A_17_15_00 = 'A_17_15_00',
  A_17_30_00 = 'A_17_30_00',
  A_17_45_00 = 'A_17_45_00',
  A_18_00_00 = 'A_18_00_00',
  A_18_15_00 = 'A_18_15_00',
  A_18_30_00 = 'A_18_30_00',
  A_18_45_00 = 'A_18_45_00',
  A_19_00_00 = 'A_19_00_00',
  A_19_15_00 = 'A_19_15_00',
  A_19_30_00 = 'A_19_30_00',
  A_19_45_00 = 'A_19_45_00',
  A_20_00_00 = 'A_20_00_00',
  A_20_15_00 = 'A_20_15_00',
  A_20_30_00 = 'A_20_30_00',
  A_20_45_00 = 'A_20_45_00',
  A_21_00_00 = 'A_21_00_00',
  A_21_15_00 = 'A_21_15_00',
  A_21_30_00 = 'A_21_30_00',
  A_21_45_00 = 'A_21_45_00',
  A_22_00_00 = 'A_22_00_00',
  A_22_15_00 = 'A_22_15_00',
  A_22_30_00 = 'A_22_30_00',
  A_22_45_00 = 'A_22_45_00',
  A_23_00_00 = 'A_23_00_00',
  A_23_15_00 = 'A_23_15_00',
  A_23_30_00 = 'A_23_30_00',
  A_23_45_00 = 'A_23_45_00'
}

export enum QuizTimeSessionStatus {
  Announced = 'ANNOUNCED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  WaitingForFinish = 'WAITING_FOR_FINISH'
}

export type QuizTimeSessionType = {
  __typename?: 'QuizTimeSessionType';
  announcementPeriod?: Maybe<QuizTimeSessionAnnouncementPeriod>;
  code?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  duelDuration?: Maybe<Scalars['Int']['output']>;
  duelResultUserData: Array<DuelResultUserDataType>;
  finishDateTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isForPremiumOnly: Scalars['Boolean']['output'];
  isForTest: Scalars['Boolean']['output'];
  isUseCode: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  maxUserCapacity?: Maybe<Scalars['Int']['output']>;
  quizDuelScore: Array<QuizDuelScoreType>;
  quizSessionPrize: Array<QuizSessionPrizeType>;
  quizTime: QuizTimeType;
  quizTimeDuration?: Maybe<Scalars['Int']['output']>;
  quiztimeprizeSet: Array<QuizTimePrizeType>;
  settingsSet: Array<SettingsType>;
  startDate: Scalars['Date']['output'];
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<QuizTimeSessionStartTime>;
  status?: Maybe<QuizTimeSessionStatus>;
  updated: Scalars['DateTime']['output'];
  userQuizSessionSetting?: Maybe<UserQuizSessionSettingsType>;
  userQuizSessionSettings: Array<UserQuizSessionSettingsType>;
  users: Array<UserType>;
  usersCount?: Maybe<Scalars['Int']['output']>;
};

export type QuizTimeType = {
  __typename?: 'QuizTimeType';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  diseases: Array<DiseaseType>;
  freeTags: Array<FreeTagType>;
  icd10tags: Array<Icd10TagType>;
  id: Scalars['UUID']['output'];
  organizer: OrganizerType;
  participationConditions?: Maybe<Scalars['String']['output']>;
  professions: Array<ProfessionType>;
  questions: Array<QuestionType>;
  quizTimeImage?: Maybe<Scalars['String']['output']>;
  quizTimeSession: Array<QuizTimeSessionType>;
  specialities: Array<SpecialityType>;
  specifications: Array<SpecificationType>;
  sponsor: Array<SponsorType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type RemoveDefaultPaymentMethodMutation = {
  __typename?: 'RemoveDefaultPaymentMethodMutation';
  customer?: Maybe<CustomerType>;
};

export type RenewSubscriptionMutation = {
  __typename?: 'RenewSubscriptionMutation';
  subscription?: Maybe<SubscriptionType>;
};

export type ResetPasswordKeyCheckMutation = {
  __typename?: 'ResetPasswordKeyCheckMutation';
  user?: Maybe<UserType>;
};

export type ResumeBlendedClassRoomSessionMutation = {
  __typename?: 'ResumeBlendedClassRoomSessionMutation';
  learningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type SemesterType = {
  __typename?: 'SemesterType';
  brevoCategoryValue?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  itemNumber?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type SetAnswerMutation = {
  __typename?: 'SetAnswerMutation';
  duelRoundQuestionAnswer?: Maybe<DuelRoundQuestionAnswerType>;
};

export type SetDailyTipperAnswerMutation = {
  __typename?: 'SetDailyTipperAnswerMutation';
  dailyTipperQuestionAnswerStatus?: Maybe<DailyTipperQuestionAnswerDailyStatusType>;
};

export type SetLekAnswerMutation = {
  __typename?: 'SetLEKAnswerMutation';
  userLekQuestionAnswerData?: Maybe<UserLekQuestionAnswerDataType>;
};

export type SetOnboardingAnswerMutation = {
  __typename?: 'SetOnboardingAnswerMutation';
  userOnboardingQuestionAnswerData?: Maybe<UserOnboardingQuestionAnswerDataType>;
};

export type SetUserExpoTokenMutation = {
  __typename?: 'SetUserExpoTokenMutation';
  result?: Maybe<Scalars['String']['output']>;
};

export enum SettingsDaysOfIgnoring {
  A_0 = 'A_0',
  A_7 = 'A_7',
  A_30 = 'A_30',
  A_90 = 'A_90'
}

export enum SettingsGoal {
  A_4 = 'A_4',
  A_5 = 'A_5',
  A_6 = 'A_6',
  A_7 = 'A_7'
}

export type SettingsType = {
  __typename?: 'SettingsType';
  activeQuizTime?: Maybe<QuizTimeSessionType>;
  created: Scalars['DateTime']['output'];
  dailyTipperMailNotification: Scalars['Boolean']['output'];
  dailyTipperMode: Scalars['Boolean']['output'];
  dailyTipperModeUpdated?: Maybe<Scalars['Date']['output']>;
  daysOfIgnoring: SettingsDaysOfIgnoring;
  duelMailNotification: Scalars['Boolean']['output'];
  duelMode: Scalars['Boolean']['output'];
  goal: SettingsGoal;
  id: Scalars['UUID']['output'];
  isChromeInstallationPopupSkipped: Scalars['Boolean']['output'];
  isClassRoomIntroCompleted: Scalars['Boolean']['output'];
  isCookieAccepted: Scalars['Boolean']['output'];
  isDailyTipperRulesRead: Scalars['Boolean']['output'];
  isDuelRulesRead: Scalars['Boolean']['output'];
  isIntroCompleted: Scalars['Boolean']['output'];
  isIosInstallationPopupSkipped: Scalars['Boolean']['output'];
  isLikeHumeoQuestionRead: Scalars['Boolean']['output'];
  isMarketingCookieAccepted: Scalars['Boolean']['output'];
  isQuizDuelRulesRead: Scalars['Boolean']['output'];
  pushNotificationDailyTipperMode: Scalars['Boolean']['output'];
  pushNotificationDuelMode: Scalars['Boolean']['output'];
  pushNotificationMode: Scalars['Boolean']['output'];
  pushNotificationNewChapterMode: Scalars['Boolean']['output'];
  pushNotificationPremiumMode: Scalars['Boolean']['output'];
  pushNotificationQuizTimeMode: Scalars['Boolean']['output'];
  temp: Scalars['JSONString']['output'];
  updated: Scalars['DateTime']['output'];
  user: UserType;
};

export type SpecialityGroupType = {
  __typename?: 'SpecialityGroupType';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export enum SpecialityGroupTypeEnum {
  Cme = 'CME',
  Exam = 'EXAM'
}

export type SpecialityType = {
  __typename?: 'SpecialityType';
  accessScopes: Array<AccessScopeType>;
  brevoCategoryValue?: Maybe<Scalars['Int']['output']>;
  classRooms: Array<ClassRoomType>;
  codes: Array<CodesType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  lectors: Array<LectorType>;
  lecture: Array<LectureType>;
  lekSet: Array<LekType>;
  network: Array<NetworkType>;
  professionType: Array<ProfessionTypeType>;
  questionsSet: Array<QuestionType>;
  quizTime: Array<QuizTimeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type SpecificationType = {
  __typename?: 'SpecificationType';
  created: Scalars['DateTime']['output'];
  duelRound: Array<DuelRoundType>;
  id: Scalars['UUID']['output'];
  lectureSet: Array<LectureType>;
  lekSet: Array<LekType>;
  profession: Array<ProfessionType>;
  questionsCount: Scalars['Int']['output'];
  questionsSet: Array<QuestionType>;
  quiztimeSet: Array<QuizTimeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type SponsorType = {
  __typename?: 'SponsorType';
  classRooms: Array<ClassRoomType>;
  codes: Array<CodesType>;
  created: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  quizTime: Array<QuizTimeType>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type StudyBeginType = {
  __typename?: 'StudyBeginType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type StudyYearType = {
  __typename?: 'StudyYearType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type Subscription = {
  __typename?: 'Subscription';
  notificationCreated?: Maybe<NotificationType>;
};

export enum SubscriptionNewPlanPaymentStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  MovedToBalance = 'MOVED_TO_BALANCE',
  NoTransaction = 'NO_TRANSACTION',
  Pending = 'PENDING',
  Void = 'VOID'
}

export enum SubscriptionSyncState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Error = 'ERROR',
  LocalOnly = 'LOCAL_ONLY',
  PendingCreate = 'PENDING_CREATE',
  PendingDelete = 'PENDING_DELETE',
  PendingUpdate = 'PENDING_UPDATE'
}

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  autoRenewal: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  customer: CustomerType;
  customerStripeId?: Maybe<Scalars['String']['output']>;
  firstPaymentSent: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isUpgradePaymentSucceeded: Scalars['Boolean']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastErrorCode?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  newPlanPaymentStatus: SubscriptionNewPlanPaymentStatus;
  paymentSubscriptionType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<PriceType>;
  priceStripeId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductType>;
  productStripeId?: Maybe<Scalars['String']['output']>;
  requestCancel?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionType?: Maybe<Scalars['String']['output']>;
  syncState: SubscriptionSyncState;
  updated: Scalars['DateTime']['output'];
  upgradePriceStripeId?: Maybe<Scalars['String']['output']>;
  upgradeProductStripeId?: Maybe<Scalars['String']['output']>;
  upgradeStatus?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  webhookErrors?: Maybe<Scalars['JSONString']['output']>;
  webhookEvents?: Maybe<Scalars['JSONString']['output']>;
};

export type SwitchPauseModeMutation = {
  __typename?: 'SwitchPauseModeMutation';
  userQuizSessionSettings?: Maybe<UserQuizSessionSettingsType>;
};

export type UniversityType = {
  __typename?: 'UniversityType';
  accessScopes: Array<AccessScopeType>;
  brevoCategoryValue?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  classroomSet: Array<ClassRoomType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type UpdateFeedbackForQuestionMutation = {
  __typename?: 'UpdateFeedbackForQuestionMutation';
  feedbackForQuestion?: Maybe<FeedbackForQuestionType>;
};

export type UserClassRoomLearningSessionSettingsMutation = {
  __typename?: 'UserClassRoomLearningSessionSettingsMutation';
  userClassRoomSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type UserClassRoomLearningSessionSettingsType = {
  __typename?: 'UserClassRoomLearningSessionSettingsType';
  classRoomLearningSession: ClassRoomLearningSessionType;
  created: Scalars['DateTime']['output'];
  duelResultUserData: Array<DuelResultUserDataType>;
  id: Scalars['UUID']['output'];
  isAchieved: Scalars['Boolean']['output'];
  isClosed: Scalars['Boolean']['output'];
  isDailyTipperModeEnabled: Scalars['Boolean']['output'];
  isDuelModeEnabled: Scalars['Boolean']['output'];
  isFirstBlendedClassRoom: Scalars['Boolean']['output'];
  isOnboardingSession: Scalars['Boolean']['output'];
  isOut: Scalars['Boolean']['output'];
  lecturesGoal: Scalars['JSONString']['output'];
  specialityGroupIcon?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  user: UserType;
  userClassRoomCorrectAnswersData: Array<UserLearningSessionCorrectAnswersDataType>;
  userLectureCorrectAnswersData: Array<UserLectureCorrectAnswersDataType>;
};

export type UserConfirmMutation = {
  __typename?: 'UserConfirmMutation';
  user?: Maybe<UserType>;
};

export type UserDailyStatType = {
  __typename?: 'UserDailyStatType';
  correct?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  incorrect?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UserForgotPasswordMutation = {
  __typename?: 'UserForgotPasswordMutation';
  user?: Maybe<UserType>;
};

export enum UserLekDataStatus {
  Finished = 'FINISHED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS'
}

export type UserLekDataType = {
  __typename?: 'UserLEKDataType';
  attemptNumber: Scalars['Int']['output'];
  correctAnswerCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  elapsedTime?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  isPassed: Scalars['Boolean']['output'];
  lekSession: LekSessionType;
  status?: Maybe<UserLekDataStatus>;
  updated: Scalars['DateTime']['output'];
  user: UserType;
  userLekQuestionAnswerData: Array<UserLekQuestionAnswerDataType>;
};

export type UserLekDatasType = {
  __typename?: 'UserLEKDatasType';
  id?: Maybe<Scalars['UUID']['output']>;
  lekSession?: Maybe<LekSessionType>;
  userLekData?: Maybe<UserLekDataType>;
};

export type UserLekQuestionAnswerDataType = {
  __typename?: 'UserLEKQuestionAnswerDataType';
  correctAnswer?: Maybe<AnswersType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  question: QuestionType;
  updated: Scalars['DateTime']['output'];
  user: UserType;
  userAnswer: AnswersType;
  userLekData: UserLekDataType;
};

export enum UserLearningProgressProgressStatus {
  Progress = 'PROGRESS',
  Regress = 'REGRESS',
  Unchanged = 'UNCHANGED'
}

export type UserLearningProgressType = {
  __typename?: 'UserLearningProgressType';
  answeredQuestionsCount?: Maybe<Scalars['Int']['output']>;
  correctAnsweredQuestionCount?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  duelsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  incorrectAnsweredQuestionCount?: Maybe<Scalars['Int']['output']>;
  loseDuelsCount?: Maybe<Scalars['Int']['output']>;
  percentageOfAnswers: Scalars['Decimal']['output'];
  percentageOfCorrectAnswers: Scalars['Decimal']['output'];
  percentageOfIncorrectAnswers: Scalars['Decimal']['output'];
  progressStatus?: Maybe<UserLearningProgressProgressStatus>;
  sessionStats?: Maybe<UserSessionStatsType>;
  tiedDuelsCount?: Maybe<Scalars['Int']['output']>;
  totalQuestionCount?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  user: UserType;
  wonDuelsCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLearningSessionCorrectAnswersDataType = {
  __typename?: 'UserLearningSessionCorrectAnswersDataType';
  classRoomCorrectAnswersCount: Scalars['Int']['output'];
  classRoomLearningSession: ClassRoomLearningSessionType;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  user: UserType;
  userClassRoomLearningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type UserLearningSessionQuestionsDataType = {
  __typename?: 'UserLearningSessionQuestionsDataType';
  correctAnswerCount?: Maybe<Scalars['Int']['output']>;
  correctAnswerCountRepeat?: Maybe<Scalars['Int']['output']>;
  generalQuestionCount?: Maybe<Scalars['Int']['output']>;
  questionCount?: Maybe<Scalars['Int']['output']>;
  questionCountRepeat?: Maybe<Scalars['Int']['output']>;
  questionCountTotal?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<ClassRoomLearningSessionType>;
  user?: Maybe<UserType>;
  wrongAnswerCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLectureCorrectAnswersDataType = {
  __typename?: 'UserLectureCorrectAnswersDataType';
  classRoomLearningSession: ClassRoomLearningSessionType;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lecture: LectureType;
  lectureCorrectAnswersCount: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  user: UserType;
  userClassRoomLearningSessionSettings?: Maybe<UserClassRoomLearningSessionSettingsType>;
};

export type UserLoginMutation = {
  __typename?: 'UserLoginMutation';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export type UserOnboardingQuestionAnswerDataType = {
  __typename?: 'UserOnboardingQuestionAnswerDataType';
  answerIsCorrect?: Maybe<Scalars['Boolean']['output']>;
  correctAnswer?: Maybe<AnswersType>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionType>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<UserType>;
  userAnswer?: Maybe<AnswersType>;
};

export type UserPhotoMutations = {
  __typename?: 'UserPhotoMutations';
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserType>;
};

export type UserQuizSessionSettingsType = {
  __typename?: 'UserQuizSessionSettingsType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isQuizSessionAvailableToStart?: Maybe<Scalars['Boolean']['output']>;
  quizSession: QuizTimeSessionType;
  quizSessionLabelStatus?: Maybe<QuizSessionLabelStatusesEnum>;
  updated: Scalars['DateTime']['output'];
  user: UserType;
  userStatus?: Maybe<UserQuizSessionSettingsUserStatus>;
};

export enum UserQuizSessionSettingsUserStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Joined = 'JOINED',
  Left = 'LEFT',
  Out = 'OUT',
  Paused = 'PAUSED',
  WaitingForJoining = 'WAITING_FOR_JOINING'
}

export type UserRegistrationMutation = {
  __typename?: 'UserRegistrationMutation';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export type UserRestorePasswordMutation = {
  __typename?: 'UserRestorePasswordMutation';
  user?: Maybe<UserType>;
};

export type UserSessionStatsType = {
  __typename?: 'UserSessionStatsType';
  achievedCount?: Maybe<Scalars['Int']['output']>;
  activeSessions?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
};

export type UserSettingsUpdateMutation = {
  __typename?: 'UserSettingsUpdateMutation';
  userSettings?: Maybe<SettingsType>;
};

export type UserSpecialityGroupType = {
  __typename?: 'UserSpecialityGroupType';
  classRoomSessionCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  specialityGroup?: Maybe<SpecialityGroupType>;
};

export type UserSubscribeToNewsMutation = {
  __typename?: 'UserSubscribeToNewsMutation';
  user?: Maybe<UserType>;
};

export type UserSubscriptionType = {
  __typename?: 'UserSubscriptionType';
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  defaultCard?: Maybe<DefaultCardType>;
  feId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastErrorCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceAmount?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  priceInterval?: Maybe<Scalars['String']['output']>;
  priceIntervalCount?: Maybe<Scalars['Int']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['UUID']['output']>;
  requestCancel?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store?: Maybe<Scalars['String']['output']>;
  upgradeStatus?: Maybe<Scalars['String']['output']>;
};

export type UserType = {
  __typename?: 'UserType';
  address?: Maybe<Scalars['String']['output']>;
  anotherProfession?: Maybe<Scalars['String']['output']>;
  anotherWorkplace?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  classRoomLearningSession: Array<ClassRoomLearningSessionType>;
  confirmationToken?: Maybe<Scalars['UUID']['output']>;
  customer?: Maybe<CustomerType>;
  dailytipper?: Maybe<DailyTipperType>;
  dailytipperquestionanswerSet: Array<DailyTipperQuestionAnswerType>;
  dateJoined: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  duelResultUserData: Array<DuelResultUserDataType>;
  educationLevel?: Maybe<EducationLevelType>;
  educationLevelId?: Maybe<Scalars['UUID']['output']>;
  efnNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  examYear?: Maybe<Scalars['Int']['output']>;
  feedbackForQuestion: Array<FeedbackForQuestionType>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  googleAdsMetadata: Scalars['JSONString']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  inAppSubscription?: Maybe<InAppSubscriptionType>;
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isAvailableForDuel: Scalars['Boolean']['output'];
  isBot: Scalars['Boolean']['output'];
  isInAppPremium?: Maybe<Scalars['Boolean']['output']>;
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  isPromotionPremium?: Maybe<Scalars['Boolean']['output']>;
  isStaff: Scalars['Boolean']['output'];
  isStripePremium?: Maybe<Scalars['Boolean']['output']>;
  isSuperuser: Scalars['Boolean']['output'];
  isUserForTest: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maxDuelCount?: Maybe<Scalars['Int']['output']>;
  medicineStudyBegin?: Maybe<Scalars['Date']['output']>;
  monthlyscore: Array<MonthlyScoreType>;
  network?: Maybe<NetworkType>;
  networkAccessCode: Array<CodesType>;
  notifications: Array<NotificationType>;
  postcode?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<ProfessionType>;
  professionId?: Maybe<Scalars['UUID']['output']>;
  promotionFinishDate?: Maybe<Scalars['DateTime']['output']>;
  questionsSet: Array<QuestionType>;
  quizTimeSession: Array<QuizTimeSessionType>;
  quizduelscore: Array<QuizDuelScoreType>;
  quiztimeprizeSet: Array<QuizTimePrizeType>;
  referralCount?: Maybe<Scalars['Int']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  resetPasswordKey?: Maybe<Scalars['String']['output']>;
  semester?: Maybe<SemesterType>;
  semesterId?: Maybe<Scalars['UUID']['output']>;
  settings?: Maybe<SettingsType>;
  speciality?: Maybe<SpecialityType>;
  specialityId?: Maybe<Scalars['UUID']['output']>;
  studyBegin?: Maybe<StudyBeginType>;
  studyBeginId?: Maybe<Scalars['UUID']['output']>;
  studyYear?: Maybe<StudyYearType>;
  studyYearId?: Maybe<Scalars['UUID']['output']>;
  subscribeToNews?: Maybe<Scalars['Boolean']['output']>;
  tokenSent: Scalars['Boolean']['output'];
  university?: Maybe<UniversityType>;
  universityId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userClassRoomCorrectAnswersData: Array<UserLearningSessionCorrectAnswersDataType>;
  userClassRoomLearningSessionSettings: Array<UserClassRoomLearningSessionSettingsType>;
  userLearningProgress?: Maybe<UserLearningProgressType>;
  userLectureCorrectAnswersData: Array<UserLectureCorrectAnswersDataType>;
  userLekData: Array<UserLekDataType>;
  userLekQuestionAnswerData: Array<UserLekQuestionAnswerDataType>;
  userQuestions: Array<DuelRoundQuestionAnswerType>;
  userQuizSessionSettings: Array<UserQuizSessionSettingsType>;
  username?: Maybe<Scalars['String']['output']>;
  useronboardingquestionanswerdataSet: Array<UserOnboardingQuestionAnswerDataType>;
  workplace?: Maybe<WorkplaceType>;
  workplaceId?: Maybe<Scalars['UUID']['output']>;
};

export type UserUnsubscribeToNewsMutation = {
  __typename?: 'UserUnsubscribeToNewsMutation';
  user?: Maybe<UserType>;
};

export type UserUpdateProfileMutation = {
  __typename?: 'UserUpdateProfileMutation';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserType>;
};

export type UsersDuelsDataType = {
  __typename?: 'UsersDuelsDataType';
  id?: Maybe<Scalars['UUID']['output']>;
  opponentDuelsData?: Maybe<DuelResultUserDataType>;
  session?: Maybe<ClassRoomLearningSessionType>;
  userDuelsData?: Maybe<DuelResultUserDataType>;
};

export type UsersQuizDuelsDataType = {
  __typename?: 'UsersQuizDuelsDataType';
  id?: Maybe<Scalars['UUID']['output']>;
  opponentDuelsData?: Maybe<DuelResultUserDataType>;
  session?: Maybe<QuizTimeSessionType>;
  userDuelsData?: Maybe<DuelResultUserDataType>;
};

export type WorkplaceType = {
  __typename?: 'WorkplaceType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  professionType: Array<ProfessionTypeType>;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  users: Array<UserType>;
};

export type YearAchievementType = {
  __typename?: 'YearAchievementType';
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  yearAchievement: Array<DailyTipperType>;
  yearNumber: Scalars['Int']['output'];
};

export type User_FragmentFragment = { __typename?: 'UserType', id?: any | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, dateOfBirth?: any | null, gender?: number | null, postcode?: string | null, dateJoined: any, confirmationToken?: any | null, anotherProfession?: string | null, anotherWorkplace?: string | null, efnNumber?: string | null, registrationNumber?: string | null, medicineStudyBegin?: any | null, examYear?: number | null, professionId?: any | null, specialityId?: any | null, workplaceId?: any | null, educationLevelId?: any | null, universityId?: any | null, semesterId?: any | null, studyBeginId?: any | null, studyYearId?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null, isUserForTest: boolean, referralCount?: number | null, subscribeToNews?: boolean | null, profession?: { __typename?: 'ProfessionType', id: any, title: string, type?: { __typename?: 'ProfessionTypeType', id: any, title?: string | null, type?: number | null } | null } | null, speciality?: { __typename?: 'SpecialityType', id: any, title: string } | null, workplace?: { __typename?: 'WorkplaceType', id: any, title: string } | null, educationLevel?: { __typename?: 'EducationLevelType', id: any, title: string } | null, university?: { __typename?: 'UniversityType', id: any, title?: string | null } | null, semester?: { __typename?: 'SemesterType', id: any, title: string } | null, studyBegin?: { __typename?: 'StudyBeginType', id: any, title: string } | null, studyYear?: { __typename?: 'StudyYearType', id: any, title?: string | null } | null, classRoomLearningSession: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any }>, network?: { __typename?: 'NetworkType', title: string } | null };

export type User_Settings_FragmentFragment = { __typename?: 'SettingsType', id: any, duelMode: boolean, goal: SettingsGoal, dailyTipperMode: boolean, pushNotificationMode: boolean, pushNotificationDailyTipperMode: boolean, pushNotificationDuelMode: boolean, pushNotificationNewChapterMode: boolean, pushNotificationPremiumMode: boolean, pushNotificationQuizTimeMode: boolean, isDailyTipperRulesRead: boolean, isDuelRulesRead: boolean, isQuizDuelRulesRead: boolean, isLikeHumeoQuestionRead: boolean, isIntroCompleted: boolean, isClassRoomIntroCompleted: boolean, isCookieAccepted: boolean, isMarketingCookieAccepted: boolean, isIosInstallationPopupSkipped: boolean, isChromeInstallationPopupSkipped: boolean, activeQuizTime?: { __typename?: 'QuizTimeSessionType', id: any } | null };

export type Lecture_FragmentFragment = { __typename?: 'LectureType', id: any, title: string, description: string, lectureLink?: string | null, correctAnswersGoal?: number | null, questions: Array<{ __typename?: 'QuestionType', id: any }>, lectors: Array<{ __typename?: 'LectorType', id: any, firstName: string, lastName: string, photo?: string | null, professions: Array<{ __typename?: 'ProfessionType', id: any, title: string }>, specialities: Array<{ __typename?: 'SpecialityType', id: any, title: string }> }> };

export type Classroom_Ls_FragmentFragment = { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } };

export type User_Question_FragmentFragment = { __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null };

export type Daily_Tipper_Question_FragmentFragment = { __typename?: 'DailyTipperQuestionAnswerType', id: any, questionNumber?: number | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, actualLearningWeek?: { __typename?: 'ActualLearnWeekType', id: any, weekProgress: any } | null };

export type User_Score_FragmentFragment = { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null };

export type Quiztime_List_FragmentFragment = { __typename?: 'QuizTimeSessionType', id: any, status?: QuizTimeSessionStatus | null, startDate: any, quizTimeDuration?: number | null, startDateTime?: any | null, finishDateTime?: any | null, isForPremiumOnly: boolean, userQuizSessionSetting?: { __typename?: 'UserQuizSessionSettingsType', id: any, userStatus?: UserQuizSessionSettingsUserStatus | null, quizSessionLabelStatus?: QuizSessionLabelStatusesEnum | null } | null, quizTime: { __typename?: 'QuizTimeType', id: any, quizTimeImage?: string | null, title: string, organizer: { __typename?: 'OrganizerType', id: any, name?: string | null } } };

export type Quiztime_Homelist_FragmentFragment = { __typename?: 'QuizTimeSessionType', id: any, startDate: any, startDateTime?: any | null, finishDateTime?: any | null, status?: QuizTimeSessionStatus | null, quizTimeDuration?: number | null, duelDuration?: number | null, quizTime: { __typename?: 'QuizTimeType', id: any, title: string, quizTimeImage?: string | null } };

export type Quiz_Prize_ItemFragment = { __typename?: 'QuizSessionPrizeType', id: any, placeNumber?: number | null, prizeType?: QuizSessionPrizePrizeType | null, roles?: string | null, quizTimePrize: { __typename?: 'QuizTimePrizeType', id: any, title: string, description?: string | null, prizeImage?: string | null } };

export type Subscription_FragmentFragment = { __typename?: 'UserSubscriptionType', id?: any | null, store?: string | null, currentPeriodEnd?: any | null, lastError?: string | null, lastErrorCode?: string | null, priceId?: string | null, priceAmount?: string | null, currencyCode?: string | null, currencySymbol?: string | null, status?: string | null, priceType?: string | null, priceInterval?: string | null, priceIntervalCount?: number | null, feId?: string | null, name?: string | null, productId?: any | null, requestCancel?: boolean | null, upgradeStatus?: string | null, defaultCard?: { __typename?: 'DefaultCardType', brand?: string | null, last4?: string | null } | null };

export type SignInMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', userLogin?: { __typename?: 'UserLoginMutation', token?: string | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, dateOfBirth?: any | null, gender?: number | null, postcode?: string | null, dateJoined: any, confirmationToken?: any | null, anotherProfession?: string | null, anotherWorkplace?: string | null, efnNumber?: string | null, registrationNumber?: string | null, medicineStudyBegin?: any | null, examYear?: number | null, professionId?: any | null, specialityId?: any | null, workplaceId?: any | null, educationLevelId?: any | null, universityId?: any | null, semesterId?: any | null, studyBeginId?: any | null, studyYearId?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null, isUserForTest: boolean, referralCount?: number | null, subscribeToNews?: boolean | null, profession?: { __typename?: 'ProfessionType', id: any, title: string, type?: { __typename?: 'ProfessionTypeType', id: any, title?: string | null, type?: number | null } | null } | null, speciality?: { __typename?: 'SpecialityType', id: any, title: string } | null, workplace?: { __typename?: 'WorkplaceType', id: any, title: string } | null, educationLevel?: { __typename?: 'EducationLevelType', id: any, title: string } | null, university?: { __typename?: 'UniversityType', id: any, title?: string | null } | null, semester?: { __typename?: 'SemesterType', id: any, title: string } | null, studyBegin?: { __typename?: 'StudyBeginType', id: any, title: string } | null, studyYear?: { __typename?: 'StudyYearType', id: any, title?: string | null } | null, classRoomLearningSession: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any }>, network?: { __typename?: 'NetworkType', title: string } | null } | null } | null };

export type SignUpMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  specialityId?: InputMaybe<Scalars['UUID']['input']>;
  anotherWorkplace?: InputMaybe<Scalars['String']['input']>;
  anotherProfession?: InputMaybe<Scalars['String']['input']>;
  efnNumber?: InputMaybe<Scalars['String']['input']>;
  examYear?: InputMaybe<Scalars['Int']['input']>;
  subscribeToNews?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  studyBeginId?: InputMaybe<Scalars['UUID']['input']>;
  educationLevelId?: InputMaybe<Scalars['UUID']['input']>;
  universityId?: InputMaybe<Scalars['UUID']['input']>;
  semesterId?: InputMaybe<Scalars['UUID']['input']>;
  sharingSenderId?: InputMaybe<Scalars['UUID']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  medicineStudyBegin?: InputMaybe<Scalars['Date']['input']>;
  workplaceId?: InputMaybe<Scalars['UUID']['input']>;
  professionId?: InputMaybe<Scalars['UUID']['input']>;
  studyYearId?: InputMaybe<Scalars['UUID']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  googleAdsMetadata?: InputMaybe<Scalars['GenericScalar']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', userRegistration?: { __typename?: 'UserRegistrationMutation', token?: string | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, dateOfBirth?: any | null, gender?: number | null, postcode?: string | null, dateJoined: any, confirmationToken?: any | null, anotherProfession?: string | null, anotherWorkplace?: string | null, efnNumber?: string | null, registrationNumber?: string | null, medicineStudyBegin?: any | null, examYear?: number | null, professionId?: any | null, specialityId?: any | null, workplaceId?: any | null, educationLevelId?: any | null, universityId?: any | null, semesterId?: any | null, studyBeginId?: any | null, studyYearId?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null, isUserForTest: boolean, referralCount?: number | null, subscribeToNews?: boolean | null, profession?: { __typename?: 'ProfessionType', id: any, title: string, type?: { __typename?: 'ProfessionTypeType', id: any, title?: string | null, type?: number | null } | null } | null, speciality?: { __typename?: 'SpecialityType', id: any, title: string } | null, workplace?: { __typename?: 'WorkplaceType', id: any, title: string } | null, educationLevel?: { __typename?: 'EducationLevelType', id: any, title: string } | null, university?: { __typename?: 'UniversityType', id: any, title?: string | null } | null, semester?: { __typename?: 'SemesterType', id: any, title: string } | null, studyBegin?: { __typename?: 'StudyBeginType', id: any, title: string } | null, studyYear?: { __typename?: 'StudyYearType', id: any, title?: string | null } | null, classRoomLearningSession: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any }>, network?: { __typename?: 'NetworkType', title: string } | null } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  anotherWorkplace?: InputMaybe<Scalars['String']['input']>;
  anotherProfession?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  educationLevelId?: InputMaybe<Scalars['UUID']['input']>;
  examYear?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicineStudyBegin?: InputMaybe<Scalars['Date']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  efnNumber?: InputMaybe<Scalars['String']['input']>;
  semesterId?: InputMaybe<Scalars['UUID']['input']>;
  specialityId?: InputMaybe<Scalars['UUID']['input']>;
  studyBeginId?: InputMaybe<Scalars['UUID']['input']>;
  studyYearId?: InputMaybe<Scalars['UUID']['input']>;
  universityId?: InputMaybe<Scalars['UUID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workplaceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserData?: { __typename?: 'UserUpdateProfileMutation', token?: string | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, dateOfBirth?: any | null, gender?: number | null, postcode?: string | null, dateJoined: any, confirmationToken?: any | null, anotherProfession?: string | null, anotherWorkplace?: string | null, efnNumber?: string | null, registrationNumber?: string | null, medicineStudyBegin?: any | null, examYear?: number | null, professionId?: any | null, specialityId?: any | null, workplaceId?: any | null, educationLevelId?: any | null, universityId?: any | null, semesterId?: any | null, studyBeginId?: any | null, studyYearId?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null, isUserForTest: boolean, referralCount?: number | null, subscribeToNews?: boolean | null, profession?: { __typename?: 'ProfessionType', id: any, title: string, type?: { __typename?: 'ProfessionTypeType', id: any, title?: string | null, type?: number | null } | null } | null, speciality?: { __typename?: 'SpecialityType', id: any, title: string } | null, workplace?: { __typename?: 'WorkplaceType', id: any, title: string } | null, educationLevel?: { __typename?: 'EducationLevelType', id: any, title: string } | null, university?: { __typename?: 'UniversityType', id: any, title?: string | null } | null, semester?: { __typename?: 'SemesterType', id: any, title: string } | null, studyBegin?: { __typename?: 'StudyBeginType', id: any, title: string } | null, studyYear?: { __typename?: 'StudyYearType', id: any, title?: string | null } | null, classRoomLearningSession: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any }>, network?: { __typename?: 'NetworkType', title: string } | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  newPassword?: InputMaybe<Scalars['String']['input']>;
  newPasswordConfirmation?: InputMaybe<Scalars['String']['input']>;
  resetPasswordKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', userRestorePassword?: { __typename?: 'UserRestorePasswordMutation', user?: { __typename?: 'UserType', id?: any | null } | null } | null };

export type ConfirmTokenMutationVariables = Exact<{
  token?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ConfirmTokenMutation = { __typename?: 'Mutation', userConfirm?: { __typename?: 'UserConfirmMutation', user?: { __typename?: 'UserType', id?: any | null, email?: string | null } | null } | null };

export type UploadPhotoMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadPhotoMutation = { __typename?: 'Mutation', uploadPhoto?: { __typename?: 'UserPhotoMutations', user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null } | null } | null };

export type ApplyNetworkCodeMutationVariables = Exact<{
  code?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApplyNetworkCodeMutation = { __typename?: 'Mutation', applyNetworkCodeForUser?: { __typename?: 'ApplyNetworkCodeForUserMutation', codes?: Array<{ __typename?: 'CodesType', code: number } | null> | null } | null };

export type ApplyClassroomCodeMutationVariables = Exact<{
  code?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  isNetworkType?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableTab?: InputMaybe<Scalars['Boolean']['input']>;
  specialityGroupIcon?: InputMaybe<Scalars['String']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApplyClassroomCodeMutation = { __typename?: 'Mutation', applyClassRoomCode?: { __typename?: 'ApplyClassRoomCodeMutation', classRoom?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null };

export type JoinNetworkClassRoomMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  specialityGroupIcon?: InputMaybe<Scalars['String']['input']>;
  isAfterOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type JoinNetworkClassRoomMutation = { __typename?: 'Mutation', joinToNetworkClassRoom?: { __typename?: 'JoinToNetworkClassRoomMutation', classRoomSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null };

export type JoinBlendedClassRoomMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
}>;


export type JoinBlendedClassRoomMutation = { __typename?: 'Mutation', joinToBlendedClassRoom?: { __typename?: 'JoinToBlendedClassRoomMutation', classRoomSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null };

export type JoinLekClassRoomMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
}>;


export type JoinLekClassRoomMutation = { __typename?: 'Mutation', joinToLekClassRoom?: { __typename?: 'JoinToLEKClassRoomMutation', classRoomSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null };

export type JoinCmeClassRoomMutationVariables = Exact<{
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
  isAfterOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  specialityGroupIcon?: InputMaybe<Scalars['String']['input']>;
}>;


export type JoinCmeClassRoomMutation = { __typename?: 'Mutation', joinToCmeClassRoom?: { __typename?: 'JoinToCMEClassRoomMutation', classRoomSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null };

export type CreateUserDuelMutationVariables = Exact<{
  opponentId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  isCustomDuel?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardingDuel?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserDuelMutation = { __typename?: 'Mutation', createDuel?: { __typename?: 'CreateDuelMutation', errors?: Array<string | null> | null, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null, duelRound: Array<{ __typename?: 'DuelRoundType', id: any, roundNumber: number, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> }> } | null } | null };

export type CreateUserRoundMutationVariables = Exact<{
  duelId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateUserRoundMutation = { __typename?: 'Mutation', createRound?: { __typename?: 'CreateRoundMutation', round?: { __typename?: 'DuelRoundType', id: any, roundNumber: number, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null, duelRound: Array<{ __typename?: 'DuelRoundType', id: any, roundNumber: number, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> }> } | null, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null } | null };

export type SetUserAnswerMutationVariables = Exact<{
  duelRoundQuestionAnswerId?: InputMaybe<Scalars['UUID']['input']>;
  answerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetUserAnswerMutation = { __typename?: 'Mutation', setAnswer?: { __typename?: 'SetAnswerMutation', duelRoundQuestionAnswer?: { __typename?: 'DuelRoundQuestionAnswerType', duelRound?: { __typename?: 'DuelRoundType', id: any, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null, result?: { __typename?: 'DuelResultType', currentUserData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, opponentData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null } | null } | null, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null } | null } | null };

export type SetUserDailyTipperAnswerMutationVariables = Exact<{
  questionId?: InputMaybe<Scalars['UUID']['input']>;
  answerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetUserDailyTipperAnswerMutation = { __typename?: 'Mutation', setDailyTipperAnswer?: { __typename?: 'SetDailyTipperAnswerMutation', dailyTipperQuestionAnswerStatus?: { __typename?: 'DailyTipperQuestionAnswerDailyStatusType', dailyStatus?: DailyStatusType | null, dailyTipperQuestionAnswer?: { __typename?: 'DailyTipperQuestionAnswerType', id: any, questionNumber?: number | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, actualLearningWeek?: { __typename?: 'ActualLearnWeekType', id: any, weekProgress: any } | null } | null } | null } | null };

export type SetOnboardingAnswerMutationVariables = Exact<{
  questionId?: InputMaybe<Scalars['UUID']['input']>;
  answerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetOnboardingAnswerMutation = { __typename?: 'Mutation', setOnboardingAnswer?: { __typename?: 'SetOnboardingAnswerMutation', userOnboardingQuestionAnswerData?: { __typename?: 'UserOnboardingQuestionAnswerDataType', answerIsCorrect?: boolean | null, question?: { __typename?: 'QuestionType', id: any } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null } | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', notificationStatus?: { __typename?: 'NotificationMutation', notification?: { __typename?: 'NotificationType', id: any, isRead: boolean } | null } | null };

export type UnsubscribeToNewsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UnsubscribeToNewsMutation = { __typename?: 'Mutation', userUnsubscribeToNews?: { __typename?: 'UserUnsubscribeToNewsMutation', user?: { __typename?: 'UserType', id?: any | null } | null } | null };

export type SubscribeToNewsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SubscribeToNewsMutation = { __typename?: 'Mutation', userSubscribeToNews?: { __typename?: 'UserSubscribeToNewsMutation', user?: { __typename?: 'UserType', id?: any | null } | null } | null };

export type UpdateDtSettingsMutationVariables = Exact<{
  goal?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateDtSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, goal: SettingsGoal, dailyTipperMode: boolean } | null } | null };

export type UpdateDuelsSettingsMutationVariables = Exact<{
  mode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateDuelsSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, duelMode: boolean } | null } | null };

export type UpdatePushNotificationsSettingsMutationVariables = Exact<{
  pushNotificationMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationDailyTipperMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationDuelMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationNewChapterMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationPremiumMode?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationQuizTimeMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePushNotificationsSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, pushNotificationMode: boolean, pushNotificationDailyTipperMode: boolean, pushNotificationDuelMode: boolean, pushNotificationNewChapterMode: boolean, pushNotificationPremiumMode: boolean, pushNotificationQuizTimeMode: boolean } | null } | null };

export type UpdateRulesSettingsMutationVariables = Exact<{
  isDailyTipperRulesRead?: InputMaybe<Scalars['Boolean']['input']>;
  isDuelRulesRead?: InputMaybe<Scalars['Boolean']['input']>;
  isQuizDuelRulesRead?: InputMaybe<Scalars['Boolean']['input']>;
  isIntroCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRulesSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, isDailyTipperRulesRead: boolean, isDuelRulesRead: boolean, isQuizDuelRulesRead: boolean, isIntroCompleted: boolean } | null } | null };

export type UpdateClassroomSettingsMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  dailyTipperMode?: InputMaybe<Scalars['Boolean']['input']>;
  duelMode?: InputMaybe<Scalars['Boolean']['input']>;
  isAchieved?: InputMaybe<Scalars['Boolean']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isOut?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateClassroomSettingsMutation = { __typename?: 'Mutation', updateUserClassRoomSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsMutation', userClassRoomSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any, isDuelModeEnabled: boolean, isDailyTipperModeEnabled: boolean, isAchieved: boolean, isClosed: boolean, isOut: boolean } | null } | null };

export type UpdateIsIntroCompletedSettingsMutationVariables = Exact<{
  isIntroCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateIsIntroCompletedSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, isIntroCompleted: boolean } | null } | null };

export type UpdateIsClassRoomIntroCompletedSettingsMutationVariables = Exact<{
  isClassRoomIntroCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateIsClassRoomIntroCompletedSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, isClassRoomIntroCompleted: boolean } | null } | null };

export type UpdateCookieAcceptedSettingsMutationVariables = Exact<{
  isCookieAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketingCookieAccepted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCookieAcceptedSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, isCookieAccepted: boolean, isMarketingCookieAccepted: boolean } | null } | null };

export type LeaveClassroomMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type LeaveClassroomMutation = { __typename?: 'Mutation', leaveClassRoom?: { __typename?: 'LeaveClassRoomMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any } | null } | null };

export type LeaveNetworkClassroomMutationVariables = Exact<{
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type LeaveNetworkClassroomMutation = { __typename?: 'Mutation', leaveNetworkClassRoom?: { __typename?: 'LeaveNetworkClassRoomMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any } | null } | null };

export type EarlyFinishNetworkClassroomMutationVariables = Exact<{
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EarlyFinishNetworkClassroomMutation = { __typename?: 'Mutation', earlyFinishNetworkClassRoom?: { __typename?: 'EarlyFinishNetworkClassRoomMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any } | null } | null };

export type EarlyFinishBlendedClassroomMutationVariables = Exact<{
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EarlyFinishBlendedClassroomMutation = { __typename?: 'Mutation', earlyFinishBlendedClassRoom?: { __typename?: 'EarlyFinishBlendedClassRoomMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any } | null } | null };

export type EarlyFinishLekClassroomMutationVariables = Exact<{
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EarlyFinishLekClassroomMutation = { __typename?: 'Mutation', earlyFinishLekClassRoom?: { __typename?: 'EarlyFinishLEKClassRoomMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any } | null } | null };

export type ResumeBlendedClassroomMutationVariables = Exact<{
  userSessionSettingsId: Scalars['UUID']['input'];
}>;


export type ResumeBlendedClassroomMutation = { __typename?: 'Mutation', resumeBlendedClassRoom?: { __typename?: 'ResumeBlendedClassRoomSessionMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any, classRoomLearningSession: { __typename?: 'ClassRoomLearningSessionType', id: any } } | null } | null };

export type PauseBlendedClassroomMutationVariables = Exact<{
  userSessionSettingsId: Scalars['UUID']['input'];
}>;


export type PauseBlendedClassroomMutation = { __typename?: 'Mutation', pauseBlendedClassRoom?: { __typename?: 'PauseBlendedClassRoomSessionMutation', learningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any, classRoomLearningSession: { __typename?: 'ClassRoomLearningSessionType', id: any } } | null } | null };

export type UserLekStartMutationVariables = Exact<{
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UserLekStartMutation = { __typename?: 'Mutation', lekStart?: { __typename?: 'LEKStartMutation', userLekData?: { __typename?: 'UserLEKDataType', id: any, created: any, status?: UserLekDataStatus | null, elapsedTime?: number | null, lekSession: { __typename?: 'LEKSessionType', id: any }, userLekQuestionAnswerData: Array<{ __typename?: 'UserLEKQuestionAnswerDataType', id: any, question: { __typename?: 'QuestionType', id: any }, userAnswer: { __typename?: 'AnswersType', id: any } }> } | null } | null };

export type UpdateIsChromeInstallationPopupSkippedSettingsMutationVariables = Exact<{
  isChromeInstallationPopupSkipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateIsChromeInstallationPopupSkippedSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, isChromeInstallationPopupSkipped: boolean } | null } | null };

export type UserLekFinishMutationVariables = Exact<{
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  userLekDataId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UserLekFinishMutation = { __typename?: 'Mutation', lekFinish?: { __typename?: 'LEKFinishMutation', userLekData?: { __typename?: 'UserLEKDataType', id: any, status?: UserLekDataStatus | null, elapsedTime?: number | null, isPassed: boolean, correctAnswerCount: number } | null } | null };

export type SetUserLekAnswerMutationVariables = Exact<{
  answerId?: InputMaybe<Scalars['UUID']['input']>;
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['UUID']['input']>;
  answerTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SetUserLekAnswerMutation = { __typename?: 'Mutation', setLekAnswer?: { __typename?: 'SetLEKAnswerMutation', userLekQuestionAnswerData?: { __typename?: 'UserLEKQuestionAnswerDataType', id: any, userLekData: { __typename?: 'UserLEKDataType', id: any, status?: UserLekDataStatus | null } } | null } | null };

export type DeleteUserAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'DeleteAccountMutation', isDeleted?: boolean | null } | null };

export type CreateStripeCheckoutSessionMutationVariables = Exact<{
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  stripePriceId: Scalars['String']['input'];
}>;


export type CreateStripeCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CreateCheckoutSessionMutation', session?: any | null } | null };

export type ChangeStripeSubscriptionMutationVariables = Exact<{
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeStripeSubscriptionMutation = { __typename?: 'Mutation', changeSubscription?: { __typename?: 'ChangeSubscriptionMutation', subscription?: { __typename?: 'SubscriptionType', id: any, status?: string | null, currentPeriodEnd?: any | null, requestCancel?: boolean | null, upgradeStatus?: string | null, product?: { __typename?: 'ProductType', id: any, feId: string, name: string } | null, price?: { __typename?: 'PriceType', id: any, type?: string | null, amount: any, interval?: PriceInterval | null, intervalCount?: number | null, trialPeriodDays?: number | null, stripeProductId?: string | null, appleStoreId?: string | null, googlePlayId?: string | null } | null } | null } | null };

export type DeleteStripePaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteStripePaymentMethodMutation = { __typename?: 'Mutation', deleteDefaultPaymentMethod?: { __typename?: 'RemoveDefaultPaymentMethodMutation', customer?: { __typename?: 'CustomerType', id: any, defaultCard?: { __typename?: 'DefaultCardType', brand?: string | null, last4?: string | null } | null } | null } | null };

export type CreateStripeSetupCheckoutSessionMutationVariables = Exact<{
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  stripePriceId: Scalars['String']['input'];
}>;


export type CreateStripeSetupCheckoutSessionMutation = { __typename?: 'Mutation', createSetupCheckoutSession?: { __typename?: 'CreateSetupCheckoutSessionMutation', session?: any | null } | null };

export type CancelUserSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelUserSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'CancelSubscriptionMutation', subscription?: { __typename?: 'SubscriptionType', id: any, status?: string | null, currentPeriodEnd?: any | null, requestCancel?: boolean | null, product?: { __typename?: 'ProductType', id: any, feId: string, name: string } | null, price?: { __typename?: 'PriceType', id: any, type?: string | null, amount: any, interval?: PriceInterval | null, intervalCount?: number | null, trialPeriodDays?: number | null, stripeProductId?: string | null, appleStoreId?: string | null, googlePlayId?: string | null } | null } | null } | null };

export type RenewPlanMutationVariables = Exact<{ [key: string]: never; }>;


export type RenewPlanMutation = { __typename?: 'Mutation', renewSubscription?: { __typename?: 'RenewSubscriptionMutation', subscription?: { __typename?: 'SubscriptionType', id: any, status?: string | null, currentPeriodEnd?: any | null, requestCancel?: boolean | null, product?: { __typename?: 'ProductType', id: any, feId: string, name: string } | null, price?: { __typename?: 'PriceType', id: any, type?: string | null, amount: any, interval?: PriceInterval | null, intervalCount?: number | null, trialPeriodDays?: number | null, stripeProductId?: string | null, appleStoreId?: string | null, googlePlayId?: string | null } | null } | null } | null };

export type InAppUserSubscribeMutationVariables = Exact<{
  subscriptionObject?: InputMaybe<Scalars['GenericScalar']['input']>;
}>;


export type InAppUserSubscribeMutation = { __typename?: 'Mutation', inAppSubscribe?: { __typename?: 'InAppSubscribeMutation', inAppSubscription?: { __typename?: 'InAppSubscriptionType', id: any, me?: { __typename?: 'UserType', id?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null } | null, subscription?: { __typename?: 'UserSubscriptionType', id?: any | null, store?: string | null, currentPeriodEnd?: any | null, lastError?: string | null, lastErrorCode?: string | null, priceId?: string | null, priceAmount?: string | null, currencyCode?: string | null, currencySymbol?: string | null, status?: string | null, priceType?: string | null, priceInterval?: string | null, priceIntervalCount?: number | null, feId?: string | null, name?: string | null, productId?: any | null, requestCancel?: boolean | null, upgradeStatus?: string | null, defaultCard?: { __typename?: 'DefaultCardType', brand?: string | null, last4?: string | null } | null } | null } | null } | null };

export type UpgradeInAppSubscriptionMutationVariables = Exact<{
  subscriptionObject?: InputMaybe<Scalars['GenericScalar']['input']>;
}>;


export type UpgradeInAppSubscriptionMutation = { __typename?: 'Mutation', changeInAppSubscription?: { __typename?: 'ChangeInAppSubscribeMutation', inAppSubscription?: { __typename?: 'InAppSubscriptionType', id: any, me?: { __typename?: 'UserType', id?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null } | null, subscription?: { __typename?: 'UserSubscriptionType', id?: any | null, store?: string | null, currentPeriodEnd?: any | null, lastError?: string | null, lastErrorCode?: string | null, priceId?: string | null, priceAmount?: string | null, currencyCode?: string | null, currencySymbol?: string | null, status?: string | null, priceType?: string | null, priceInterval?: string | null, priceIntervalCount?: number | null, feId?: string | null, name?: string | null, productId?: any | null, requestCancel?: boolean | null, upgradeStatus?: string | null, defaultCard?: { __typename?: 'DefaultCardType', brand?: string | null, last4?: string | null } | null } | null } | null } | null };

export type UpdateIsIosInstallationPopupSkippedSettingsMutationVariables = Exact<{
  isIosInstallationPopupSkipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateIsIosInstallationPopupSkippedSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'UserSettingsUpdateMutation', userSettings?: { __typename?: 'SettingsType', id: any, isIosInstallationPopupSkipped: boolean } | null } | null };

export type ApplyQuizTimeCodeMutationVariables = Exact<{
  code?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['UUID']['input'];
  deepLinkHash?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApplyQuizTimeCodeMutation = { __typename?: 'Mutation', joinToQuiz?: { __typename?: 'JoinToQuizMutation', quizSession?: { __typename?: 'QuizTimeSessionType', id: any, quizTime: { __typename?: 'QuizTimeType', id: any } } | null } | null };

export type LeaveQuizTimeMutationVariables = Exact<{
  sessionId: Scalars['UUID']['input'];
}>;


export type LeaveQuizTimeMutation = { __typename?: 'Mutation', leaveQuiz?: { __typename?: 'LeaveQuizMutation', session?: { __typename?: 'QuizTimeSessionType', id: any } | null } | null };

export type StartQuizMutationVariables = Exact<{
  quizSessionId: Scalars['UUID']['input'];
}>;


export type StartQuizMutation = { __typename?: 'Mutation', quizStartByUser?: { __typename?: 'QuizStartByUserMutation', quizSession?: { __typename?: 'QuizTimeSessionType', id: any, status?: QuizTimeSessionStatus | null } | null } | null };

export type PauseQuizMutationVariables = Exact<{
  pauseMode: Scalars['Boolean']['input'];
  quizSessionId: Scalars['UUID']['input'];
}>;


export type PauseQuizMutation = { __typename?: 'Mutation', switchPauseMode?: { __typename?: 'SwitchPauseModeMutation', userQuizSessionSettings?: { __typename?: 'UserQuizSessionSettingsType', id: any, userStatus?: UserQuizSessionSettingsUserStatus | null } | null } | null };

export type CreateQuiztimeDuelMutationVariables = Exact<{
  quizSessionId: Scalars['UUID']['input'];
}>;


export type CreateQuiztimeDuelMutation = { __typename?: 'Mutation', createQuizDuel?: { __typename?: 'CreateQuizDuelMutation', duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null, duelRound: Array<{ __typename?: 'DuelRoundType', id: any, roundNumber: number, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> }> } | null } | null };

export type CreateQuiztimeDuelByOpponentMutationVariables = Exact<{
  opponentId: Scalars['UUID']['input'];
  quizSessionId: Scalars['UUID']['input'];
}>;


export type CreateQuiztimeDuelByOpponentMutation = { __typename?: 'Mutation', createQuizDuelByOpponent?: { __typename?: 'CreateQuizDuelByOpponentMutation', duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null, duelRound: Array<{ __typename?: 'DuelRoundType', id: any, roundNumber: number, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> }> } | null } | null };

export type AddWaitingUserNotificationMutationVariables = Exact<{
  sessionId: Scalars['UUID']['input'];
}>;


export type AddWaitingUserNotificationMutation = { __typename?: 'Mutation', addWaitingUser?: { __typename?: 'AddWaitingUser', waitingUser?: { __typename?: 'UserQuizSessionSettingsType', id: any, quizSession: { __typename?: 'QuizTimeSessionType', id: any, usersCount?: number | null } } | null } | null };

export type GetDeepLinkMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDeepLinkMutation = { __typename?: 'Mutation', getDeepLink?: { __typename?: 'GetDeepLink', deepLink?: { __typename?: 'DeepLinkType', targetObjectId: any, targetType?: string | null } | null } | null };

export type CreateFeedbackQuestionMutationVariables = Exact<{
  questionId: Scalars['UUID']['input'];
  interestRate: Scalars['Int']['input'];
  relevanceRate: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedbackQuestionMutation = { __typename?: 'Mutation', createFeedbackForQuestion?: { __typename?: 'CreateFeedbackForQuestionMutation', feedbackForQuestion?: { __typename?: 'FeedbackForQuestionType', id: any, relevanceRate?: number | null, interestRate?: number | null, comment?: string | null, question: { __typename?: 'QuestionType', id: any, value: string } } | null } | null };

export type EditFeedbackQuestionMutationVariables = Exact<{
  questionId: Scalars['UUID']['input'];
  interestRate?: InputMaybe<Scalars['Int']['input']>;
  relevanceRate?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditFeedbackQuestionMutation = { __typename?: 'Mutation', editFeedbackForQuestion?: { __typename?: 'UpdateFeedbackForQuestionMutation', feedbackForQuestion?: { __typename?: 'FeedbackForQuestionType', id: any, relevanceRate?: number | null, interestRate?: number | null, comment?: string | null, question: { __typename?: 'QuestionType', id: any, value: string } } | null } | null };

export type SetExpoTokenMutationVariables = Exact<{
  expoToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetExpoTokenMutation = { __typename?: 'Mutation', setUserExpoToken?: { __typename?: 'SetUserExpoTokenMutation', result?: string | null } | null };

export type UserSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSubscriptionQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id?: any | null, isPremium?: boolean | null, isPromotionPremium?: boolean | null, isInAppPremium?: boolean | null, promotionFinishDate?: any | null } | null, subscription?: { __typename?: 'UserSubscriptionType', id?: any | null, store?: string | null, currentPeriodEnd?: any | null, lastError?: string | null, lastErrorCode?: string | null, priceId?: string | null, priceAmount?: string | null, currencyCode?: string | null, currencySymbol?: string | null, status?: string | null, priceType?: string | null, priceInterval?: string | null, priceIntervalCount?: number | null, feId?: string | null, name?: string | null, productId?: any | null, requestCancel?: boolean | null, upgradeStatus?: string | null, defaultCard?: { __typename?: 'DefaultCardType', brand?: string | null, last4?: string | null } | null } | null };

export type UserDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDiscountsQuery = { __typename?: 'Query', discounts?: Array<{ __typename?: 'CouponType', id: any, couponName?: string | null, status: CouponStatus, discount?: string | null, startActiveDatetime?: any | null, finishActiveDatetime?: any | null } | null> | null };

export type UserPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPlansQuery = { __typename?: 'Query', plans?: Array<{ __typename?: 'ProductType', id: any, isActive: boolean, feId: string, name: string, prices: Array<{ __typename?: 'PriceType', id: any, stripeId?: string | null, isActive: boolean, amount: any, interval?: PriceInterval | null, intervalCount?: number | null, name?: string | null, trialPeriodDays?: number | null, type?: string | null, googlePlayId?: string | null, appleStoreId?: string | null, currency: { __typename?: 'CurrencyType', id: any, symbol?: string | null } }> } | null> | null };

export type StripeCheckoutSessionStatusQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type StripeCheckoutSessionStatusQuery = { __typename?: 'Query', checkoutSessionStatus?: { __typename?: 'CheckoutSessionStatusType', status: string, session?: any | null } | null };

export type UserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMeQuery = { __typename?: 'Query', contentAvailable?: boolean | null, joinedClassRooms?: number | null, me?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, dateOfBirth?: any | null, gender?: number | null, postcode?: string | null, dateJoined: any, confirmationToken?: any | null, anotherProfession?: string | null, anotherWorkplace?: string | null, efnNumber?: string | null, registrationNumber?: string | null, medicineStudyBegin?: any | null, examYear?: number | null, professionId?: any | null, specialityId?: any | null, workplaceId?: any | null, educationLevelId?: any | null, universityId?: any | null, semesterId?: any | null, studyBeginId?: any | null, studyYearId?: any | null, isPremium?: boolean | null, isInAppPremium?: boolean | null, isPromotionPremium?: boolean | null, isUserForTest: boolean, referralCount?: number | null, subscribeToNews?: boolean | null, settings?: { __typename?: 'SettingsType', id: any, duelMode: boolean, goal: SettingsGoal, dailyTipperMode: boolean, pushNotificationMode: boolean, pushNotificationDailyTipperMode: boolean, pushNotificationDuelMode: boolean, pushNotificationNewChapterMode: boolean, pushNotificationPremiumMode: boolean, pushNotificationQuizTimeMode: boolean, isDailyTipperRulesRead: boolean, isDuelRulesRead: boolean, isQuizDuelRulesRead: boolean, isLikeHumeoQuestionRead: boolean, isIntroCompleted: boolean, isClassRoomIntroCompleted: boolean, isCookieAccepted: boolean, isMarketingCookieAccepted: boolean, isIosInstallationPopupSkipped: boolean, isChromeInstallationPopupSkipped: boolean, activeQuizTime?: { __typename?: 'QuizTimeSessionType', id: any } | null } | null, profession?: { __typename?: 'ProfessionType', id: any, title: string, type?: { __typename?: 'ProfessionTypeType', id: any, title?: string | null, type?: number | null } | null } | null, speciality?: { __typename?: 'SpecialityType', id: any, title: string } | null, workplace?: { __typename?: 'WorkplaceType', id: any, title: string } | null, educationLevel?: { __typename?: 'EducationLevelType', id: any, title: string } | null, university?: { __typename?: 'UniversityType', id: any, title?: string | null } | null, semester?: { __typename?: 'SemesterType', id: any, title: string } | null, studyBegin?: { __typename?: 'StudyBeginType', id: any, title: string } | null, studyYear?: { __typename?: 'StudyYearType', id: any, title?: string | null } | null, classRoomLearningSession: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any }>, network?: { __typename?: 'NetworkType', title: string } | null } | null, monthlyScore?: { __typename?: 'MonthlyScoreType', id: any, points: number } | null, featureFlags?: Array<{ __typename?: 'FeatureFlagType', id: any, name: string, enabled: boolean } | null> | null };

export type DtWeeklyProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type DtWeeklyProgressQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id?: any | null, dailytipper?: { __typename?: 'DailyTipperType', id: any, dailyStatus?: DailyTipperStatusType | null, totalProgress?: number | null, nextAchievement?: { __typename?: 'AchievementType', id: any, learningDays: number } | null, currentAchievement?: { __typename?: 'AchievementType', id: any, learningDays: number } | null, yearAchievement?: { __typename?: 'YearAchievementType', id: any, yearNumber: number } | null } | null } | null, dailyTipperWeeklyProgress?: { __typename?: 'ActualLearnWeekType', id: any, weeklyGoal: ActualLearnWeekWeeklyGoal, completedDays: number, correctAnswersCount: number, wrongAnswersCount: number, weekNumber: number } | null };

export type GetActiveDuelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveDuelsQuery = { __typename?: 'Query', startedDuelsToday?: number | null, activeDuels?: Array<{ __typename?: 'ActiveDuelsType', id?: any | null, youTurn?: boolean | null, isInitiator?: boolean | null, opponent?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, round?: { __typename?: 'DuelRoundType', id: any, roundNumber: number, created: any, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null } | null, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null, session?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null> | null };

export type GetOngoingDuelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOngoingDuelsQuery = { __typename?: 'Query', startedDuelsToday?: number | null, activeDuels?: Array<{ __typename?: 'ActiveDuelsType', id?: any | null, youTurn?: boolean | null, isInitiator?: boolean | null, opponent?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, round?: { __typename?: 'DuelRoundType', id: any, roundNumber: number, created: any, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null } | null, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null, session?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null> | null, monthlyScore?: { __typename?: 'MonthlyScoreType', id: any, duels: number, wins: number, loss: number, ties: number, points: number } | null };

export type GetCompletedDuelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompletedDuelsQuery = { __typename?: 'Query', completedDuels?: Array<{ __typename?: 'UsersDuelsDataType', id?: any | null, userDuelsData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, duel?: { __typename?: 'DuelType', id: any, updated: any, status?: DuelStatus | null, isOnboardingDuel: boolean } | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, opponentDuelsData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, session?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null> | null };

export type GetDuelsRankingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuelsRankingQuery = { __typename?: 'Query', ranking?: Array<{ __typename?: 'MonthlyScoreType', id: any, points: number, rank?: number | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null } | null> | null, topUsers?: Array<{ __typename?: 'MonthlyScoreType', id: any, points: number, rank?: number | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null } | null> | null };

export type GetDuelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuelsQuery = { __typename?: 'Query', startedDuelsToday?: number | null, activeDuels?: Array<{ __typename?: 'ActiveDuelsType', id?: any | null, youTurn?: boolean | null, opponent?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, round?: { __typename?: 'DuelRoundType', id: any, roundNumber: number, created: any, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null } | null, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null, session?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null> | null, completedDuels?: Array<{ __typename?: 'UsersDuelsDataType', id?: any | null, userDuelsData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, duel?: { __typename?: 'DuelType', id: any, updated: any, status?: DuelStatus | null } | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, opponentDuelsData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, session?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null } | null> | null, ranking?: Array<{ __typename?: 'MonthlyScoreType', id: any, points: number, rank?: number | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null } | null> | null, topUsers?: Array<{ __typename?: 'MonthlyScoreType', id: any, points: number, rank?: number | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null } | null> | null, monthlyScore?: { __typename?: 'MonthlyScoreType', id: any, duels: number, wins: number, loss: number, ties: number, points: number } | null };

export type UserDuelQueryVariables = Exact<{
  duelId: Scalars['UUID']['input'];
}>;


export type UserDuelQuery = { __typename?: 'Query', duelData?: { __typename?: 'DuelDataType', id?: any | null, status?: DuelStatusesEnum | null, isOnboardingDuel?: boolean | null, opponentScore?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, userScore?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, rounds?: Array<{ __typename?: 'DuelRoundType', id: any, created: any, roundNumber: number, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null> | null, session?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null };

export type SubscribeNotificationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeNotificationCreatedSubscription = { __typename?: 'Subscription', notificationCreated?: { __typename?: 'NotificationType', id: any, updated: any, created: any, data: any, message?: string | null, isRead: boolean } | null };

export type UserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'NotificationType', id: any, created: any, updated: any, data: any, message?: string | null, isRead: boolean } | null> | null };

export type LastUserNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type LastUserNotificationQuery = { __typename?: 'Query', lastNotification?: { __typename?: 'NotificationType', id: any, updated: any, created: any, data: any, message?: string | null, isRead: boolean } | null };

export type UserNetworkCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNetworkCodesQuery = { __typename?: 'Query', codes?: Array<{ __typename?: 'CodesType', id: any, startDate: any, finishDate?: any | null, codeMode?: CodeModelCodeMode | null, sponsor?: { __typename?: 'SponsorType', id: any, title: string, text?: string | null, website?: string | null, email?: string | null, logo?: string | null } | null } | null> | null };

export type UsernameVerifyQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type UsernameVerifyQuery = { __typename?: 'Query', usernameVerify?: boolean | null };

export type EmailVerifyQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type EmailVerifyQuery = { __typename?: 'Query', emailVerify?: boolean | null };

export type EfnNumberVerifyQueryVariables = Exact<{
  efnNumber: Scalars['String']['input'];
}>;


export type EfnNumberVerifyQuery = { __typename?: 'Query', efnNumberVerify?: boolean | null };

export type AllProfessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProfessionsQuery = { __typename?: 'Query', professions?: Array<{ __typename?: 'ProfessionType', id: any, title: string, type?: { __typename?: 'ProfessionTypeType', id: any, type?: number | null } | null } | null> | null };

export type AnotherDataQueryVariables = Exact<{
  professionType: Scalars['Int']['input'];
}>;


export type AnotherDataQuery = { __typename?: 'Query', specialitiesByType?: Array<{ __typename?: 'SpecialityType', id: any, title: string } | null> | null };

export type DoctorDataQueryVariables = Exact<{
  professionType: Scalars['Int']['input'];
}>;


export type DoctorDataQuery = { __typename?: 'Query', specialitiesByType?: Array<{ __typename?: 'SpecialityType', id: any, title: string } | null> | null, workplaces?: Array<{ __typename?: 'WorkplaceType', id: any, title: string } | null> | null };

export type MedicalAssistantDataQueryVariables = Exact<{
  professionType: Scalars['Int']['input'];
}>;


export type MedicalAssistantDataQuery = { __typename?: 'Query', professions?: Array<{ __typename?: 'ProfessionType', id: any, title: string } | null> | null, specialitiesByType?: Array<{ __typename?: 'SpecialityType', id: any, title: string } | null> | null, workplaces?: Array<{ __typename?: 'WorkplaceType', id: any, title: string } | null> | null };

export type MedicalAssistantTraineeDataQueryVariables = Exact<{
  professionType: Scalars['Int']['input'];
}>;


export type MedicalAssistantTraineeDataQuery = { __typename?: 'Query', workplaces?: Array<{ __typename?: 'WorkplaceType', id: any, title: string } | null> | null, studyYears?: Array<{ __typename?: 'StudyYearType', id: any, title?: string | null } | null> | null };

export type StudentDataQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentDataQuery = { __typename?: 'Query', semesters?: Array<{ __typename?: 'SemesterType', id: any, title: string } | null> | null, universities?: Array<{ __typename?: 'UniversityType', id: any, title?: string | null } | null> | null, studySemesters?: Array<{ __typename?: 'StudyBeginType', id: any, title: string } | null> | null };

export type TraineeDataQueryVariables = Exact<{
  professionType: Scalars['Int']['input'];
}>;


export type TraineeDataQuery = { __typename?: 'Query', workplaces?: Array<{ __typename?: 'WorkplaceType', id: any, title: string } | null> | null, educationLevels?: Array<{ __typename?: 'EducationLevelType', id: any, title: string } | null> | null };

export type TodayDailyTipperQueryVariables = Exact<{ [key: string]: never; }>;


export type TodayDailyTipperQuery = { __typename?: 'Query', dailyTipperData?: { __typename?: 'DailyTipperDataType', dailyTipperQuestions?: Array<{ __typename?: 'DailyTipperQuestionAnswerType', id: any, questionNumber?: number | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, actualLearningWeek?: { __typename?: 'ActualLearnWeekType', id: any, weekProgress: any } | null } | null> | null } | null };

export type OnboardingQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuestionsQuery = { __typename?: 'Query', onboardingQuestions?: Array<{ __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string, isCorrect: boolean }> } | null> | null };

export type DailyTipperDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DailyTipperDataQuery = { __typename?: 'Query', dailyTipperData?: { __typename?: 'DailyTipperDataType', dailyResultStatus?: DailyStatusType | null, currentAchievement?: number | null, daysLost?: number | null, dailyTipperQuestions?: Array<{ __typename?: 'DailyTipperQuestionAnswerType', id: any, questionNumber?: number | null, question?: { __typename?: 'QuestionType', id: any, value: string, questionImage?: string | null, explanation?: string | null, sortedLinks?: Array<{ __typename?: 'LinkType', id: any, url: string, linkCategory: { __typename?: 'LinkCategoryType', id: any, title: string } } | null> | null, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, correctAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null, actualLearningWeek?: { __typename?: 'ActualLearnWeekType', id: any, weekProgress: any } | null } | null> | null } | null };

export type UpdateDtDayslostQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateDtDayslostQuery = { __typename?: 'Query', dailyTipperData?: { __typename?: 'DailyTipperDataType', daysLost?: number | null } | null };

export type UserAchievementsRangQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAchievementsRangQuery = { __typename?: 'Query', achievementsRang?: Array<{ __typename?: 'DailyTipperAchievementsType', usersWithAchievementCount?: number | null, achievement?: { __typename?: 'AchievementType', id: any, learningDays: number } | null, usersWithAchievement?: Array<{ __typename?: 'DailyTipperType', id: any, user?: { __typename?: 'UserType', avatar?: string | null, username?: string | null } | null } | null> | null } | null> | null };

export type ClassRoomsAvailableQueryVariables = Exact<{
  isNetworkType?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ClassRoomsAvailableQuery = { __typename?: 'Query', availableClassRooms?: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null> | null };

export type ClassRoomsOngoingQueryVariables = Exact<{ [key: string]: never; }>;


export type ClassRoomsOngoingQuery = { __typename?: 'Query', ongoingClassRooms?: Array<{ __typename?: 'OngoingUserLearningSessionType', isSessionActive?: boolean | null, correctAnswersGoal?: number | null, questionsAmount?: number | null, correctAnswersAmount?: number | null, networkStartDate?: string | null, specialityGroupIcon?: string | null, learningSession?: { __typename?: 'ClassRoomLearningSessionType', deepLink?: string | null, id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null } | null> | null };

export type OnboardingCrSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingCrSessionQuery = { __typename?: 'Query', onboardingSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null };

export type ClassRoomsAvailableBySpecialityGroupQueryVariables = Exact<{
  specialityGroupId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassRoomsAvailableBySpecialityGroupQuery = { __typename?: 'Query', availableSessionsBySpecialityGroup?: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null> | null };

export type ClassRoomsFinishedQueryVariables = Exact<{ [key: string]: never; }>;


export type ClassRoomsFinishedQuery = { __typename?: 'Query', finishedClassRooms?: Array<{ __typename?: 'FinishedClassRoomLearningSessionType', correctAnswersGoal?: number | null, questionsAmount?: number | null, correctAnswersAmount?: number | null, networkStartDate?: string | null, outViaSubscriptionDate?: string | null, specialityGroupIcon?: string | null, userLearningSessionSettingsId?: any | null, learningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null } | null> | null };

export type FindClassRoomsQueryVariables = Exact<{
  searchPointer?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindClassRoomsQuery = { __typename?: 'Query', findClassRooms?: Array<{ __typename?: 'ClassRoomLearningSessionType', specialityGroupIcon?: string | null, id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null> | null };

export type SearchNetworkClassRoomSessionsQueryVariables = Exact<{
  searchPointer?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchNetworkClassRoomSessionsQuery = { __typename?: 'Query', searchNetworkClassRoomSessions?: Array<{ __typename?: 'ClassRoomLearningSessionType', specialityGroupIcon?: string | null, isForSingle: boolean, id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null } | null } } | null> | null };

export type ClassRoomSessionQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassRoomSessionQuery = { __typename?: 'Query', classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, duration?: number | null, specialityGroupIcon?: string | null, deepLink?: string | null, maxUserCapacity?: number | null, isOnboardingSession: boolean, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, description: string, learningMoreInfoLink?: string | null, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, classRoomLecture: Array<{ __typename?: 'ClassRoomLectureType', id: any, lectureNumber: number, isVisible?: boolean | null, lectureQuestionCount?: number | null, lectureGoal?: number | null, correctAnswerCount?: number | null, lecture: { __typename?: 'LectureType', id: any, title: string } }>, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number, title?: string | null } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null, email?: string | null, logo?: string | null, linkToSite?: string | null } | null, sponsors: Array<{ __typename?: 'SponsorType', id: any, title: string, logo?: string | null }> } } | null, lekSessionsData?: Array<{ __typename?: 'UserLEKDatasType', id?: any | null, lekSession?: { __typename?: 'LEKSessionType', id: any, status?: LekSessionStatus | null, finishDateTime?: any | null, startDateTime?: any | null, lek: { __typename?: 'LEKType', id: any, title: string, description: string, possibleAttempts: number } } | null, userLekData?: { __typename?: 'UserLEKDataType', id: any, status?: UserLekDataStatus | null, isPassed: boolean, attemptNumber: number } | null } | null> | null };

export type ClassroomLekSessionsQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassroomLekSessionsQuery = { __typename?: 'Query', lekSessionsData?: Array<{ __typename?: 'UserLEKDatasType', id?: any | null, lekSession?: { __typename?: 'LEKSessionType', id: any, status?: LekSessionStatus | null, finishDateTime?: any | null, startDateTime?: any | null } | null } | null> | null };

export type CrSessionTypeQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CrSessionTypeQuery = { __typename?: 'Query', classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } | null };

export type ClassRoomDetailsQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassRoomDetailsQuery = { __typename?: 'Query', classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, startDate: any, finishDate: any, isForPremiumOnly: boolean, isForSingle: boolean, duration?: number | null, specialityGroupIcon?: string | null, deepLink?: string | null, maxUserCapacity?: number | null, classRoom: { __typename?: 'ClassRoomType', id: any, title: string, description: string, learningMoreInfoLink?: string | null, classRoomImage?: string | null, backgroundImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, isExternalOrganizer?: boolean | null, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number, title?: string | null } | null, organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null, email?: string | null, logo?: string | null, linkToSite?: string | null } | null, sponsors: Array<{ __typename?: 'SponsorType', id: any, title: string, logo?: string | null }> } } | null };

export type SpecialityGroupListQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialityGroupListQuery = { __typename?: 'Query', userSpecialityGroupList?: Array<{ __typename?: 'UserSpecialityGroupType', classRoomSessionCount?: number | null, specialityGroup?: { __typename?: 'SpecialityGroupType', id: any, name: string, icon?: string | null } | null } | null> | null };

export type SpecialityGroupQueryVariables = Exact<{
  specialityGroupId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SpecialityGroupQuery = { __typename?: 'Query', specialityGroup?: { __typename?: 'SpecialityGroupType', id: any, name: string, icon?: string | null } | null };

export type UserOnboardingSpecialityGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOnboardingSpecialityGroupsQuery = { __typename?: 'Query', userOnboardingSpecialityGroups?: any | null };

export type SpecialityGroupByTypeQueryVariables = Exact<{
  groupType: SpecialityGroupTypeEnum;
}>;


export type SpecialityGroupByTypeQuery = { __typename?: 'Query', specialityGroupByType?: { __typename?: 'SpecialityGroupType', id: any, name: string } | null };

export type GetLekSessionQueryVariables = Exact<{
  lekSessionId?: InputMaybe<Scalars['UUID']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetLekSessionQuery = { __typename?: 'Query', lekSession?: { __typename?: 'LEKSessionType', id: any, status?: LekSessionStatus | null, startDateTime?: any | null, finishDateTime?: any | null, lek: { __typename?: 'LEKType', id: any, title: string, lekGoal: number, questionCount?: number | null, answerTimeDuration: number, questions: Array<{ __typename?: 'QuestionType', id: any, questionImage?: string | null, value: string, answers: Array<{ __typename?: 'AnswersType', id: any, value: string }> }> } } | null, userLekData?: { __typename?: 'UserLEKDataType', id: any, created: any, status?: UserLekDataStatus | null, elapsedTime?: number | null, userLekQuestionAnswerData: Array<{ __typename?: 'UserLEKQuestionAnswerDataType', id: any, question: { __typename?: 'QuestionType', id: any }, userAnswer: { __typename?: 'AnswersType', id: any } }> } | null };

export type GetLekSessionResultsQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetLekSessionResultsQuery = { __typename?: 'Query', lekSessionsData?: Array<{ __typename?: 'UserLEKDatasType', id?: any | null, lekSession?: { __typename?: 'LEKSessionType', id: any, finishDateTime?: any | null, status?: LekSessionStatus | null, lek: { __typename?: 'LEKType', id: any, title: string, lekGoal: number, questionCount?: number | null, possibleAttempts: number }, classRoomLearningSession: { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null } } | null, userLekData?: { __typename?: 'UserLEKDataType', id: any, updated: any, status?: UserLekDataStatus | null, correctAnswerCount: number, elapsedTime?: number | null, isPassed: boolean, attemptNumber: number } | null } | null> | null };

export type ClassRoomSessionProgressQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassRoomSessionProgressQuery = { __typename?: 'Query', classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, classRoomLecture: Array<{ __typename?: 'ClassRoomLectureType', id: any, correctAnswerCount?: number | null }> } } | null, ongoingClassRooms?: Array<{ __typename?: 'OngoingUserLearningSessionType', correctAnswersAmount?: number | null, learningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any } | null } | null> | null };

export type ClassRoomStatisticsQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingsId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassRoomStatisticsQuery = { __typename?: 'Query', userQuestionsCountData?: { __typename?: 'UserLearningSessionQuestionsDataType', questionCountTotal?: number | null, questionCount?: number | null, correctAnswerCount?: number | null, wrongAnswerCount?: number | null, questionCountRepeat?: number | null, correctAnswerCountRepeat?: number | null, generalQuestionCount?: number | null } | null };

export type OrganizerQueryVariables = Exact<{
  organizerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type OrganizerQuery = { __typename?: 'Query', organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null, email?: string | null, about?: string | null, logo?: string | null, linkToSite?: string | null, city?: { __typename?: 'CityType', id: any, title?: string | null } | null, classroomSet: Array<{ __typename?: 'ClassRoomType', id: any }> } | null };

export type OrganizerClassroomsQueryVariables = Exact<{
  organizerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type OrganizerClassroomsQuery = { __typename?: 'Query', organizer?: { __typename?: 'OrganizerType', id: any, name?: string | null, classroomSet: Array<{ __typename?: 'ClassRoomType', id: any, title: string, backgroundImage?: string | null, classRoomImage?: string | null, enrollmentType?: number | null, idNumber?: string | null, classRoomLearningSession: Array<{ __typename?: 'ClassRoomLearningSessionType', id: any, startDate: any, finishDate: any, specialityGroupIcon?: string | null }>, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, certificate?: { __typename?: 'CertificateType', id: any, points: number, title?: string | null } | null }> } | null };

export type ClassroomMembersQueryVariables = Exact<{
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassroomMembersQuery = { __typename?: 'Query', startedDuelsToday?: number | null, classRoomMembers?: Array<{ __typename?: 'ClassRoomMemberType', id?: any | null, isAvailableForDuel?: boolean | null, userData?: { __typename?: 'UserLearningSessionCorrectAnswersDataType', id: any, classRoomCorrectAnswersCount: number, user: { __typename?: 'UserType', id?: any | null, username?: string | null, avatar?: string | null }, userClassRoomLearningSessionSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', isClosed: boolean } | null } | null } | null> | null };

export type ClassRoomSettingsQueryVariables = Exact<{
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
  userSessionSettingId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassRoomSettingsQuery = { __typename?: 'Query', userClassRoomSettings?: { __typename?: 'UserClassRoomLearningSessionSettingsType', id: any, created: any, updated: any, isDuelModeEnabled: boolean, isDailyTipperModeEnabled: boolean, isAchieved: boolean, isClosed: boolean, isOut: boolean, isOnboardingSession: boolean, specialityGroupIcon?: string | null, classRoomLearningSession: { __typename?: 'ClassRoomLearningSessionType', id: any, status?: ClassRoomLearningSessionStatus | null, classRoom: { __typename?: 'ClassRoomType', id: any, enrollmentType?: number | null } } } | null };

export type LectorQueryVariables = Exact<{
  lectorId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type LectorQuery = { __typename?: 'Query', lector?: { __typename?: 'LectorType', id: any, firstName: string, lastName: string, email?: string | null, about?: string | null, photo?: string | null, professions: Array<{ __typename?: 'ProfessionType', id: any, title: string }>, specialities: Array<{ __typename?: 'SpecialityType', id: any, title: string }>, aggregatedRate?: { __typename?: 'AggregatedRateType', id: any, averageRate?: number | null, feedbackCount?: number | null } | null, city?: { __typename?: 'CityType', id: any, title?: string | null } | null, lectureSet: Array<{ __typename?: 'LectureType', id: any, title: string, description: string, classroomSet: Array<{ __typename?: 'ClassRoomType', id: any, title: string }> }> } | null };

export type ClassroomLecturesQueryVariables = Exact<{
  learningSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ClassroomLecturesQuery = { __typename?: 'Query', classRoomLectures?: Array<{ __typename?: 'ClassRoomLectureType', id: any, lectureNumber: number, lecture: { __typename?: 'LectureType', id: any, title: string, description: string, lectureLink?: string | null, correctAnswersGoal?: number | null, questions: Array<{ __typename?: 'QuestionType', id: any }>, lectors: Array<{ __typename?: 'LectorType', id: any, firstName: string, lastName: string, photo?: string | null, professions: Array<{ __typename?: 'ProfessionType', id: any, title: string }>, specialities: Array<{ __typename?: 'SpecialityType', id: any, title: string }> }> } } | null> | null };

export type QuizTimeDetailsQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type QuizTimeDetailsQuery = { __typename?: 'Query', quizTimeSession?: { __typename?: 'QuizTimeSessionType', id: any, status?: QuizTimeSessionStatus | null, startDate: any, startDateTime?: any | null, usersCount?: number | null, quizTimeDuration?: number | null, duelDuration?: number | null, finishDateTime?: any | null, isForPremiumOnly: boolean, isUseCode: boolean, maxUserCapacity?: number | null, quizTime: { __typename?: 'QuizTimeType', id: any, quizTimeImage?: string | null, title: string, description: string, participationConditions?: string | null, organizer: { __typename?: 'OrganizerType', id: any, name?: string | null, email?: string | null, logo?: string | null, linkToSite?: string | null }, sponsor: Array<{ __typename?: 'SponsorType', id: any, title: string, text?: string | null, website?: string | null, email?: string | null, logo?: string | null }> } } | null };

export type GetUserQuizSessionSettingsQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetUserQuizSessionSettingsQuery = { __typename?: 'Query', userQuizSessionSettings?: { __typename?: 'UserQuizSessionSettingsType', id: any, userStatus?: UserQuizSessionSettingsUserStatus | null, isQuizSessionAvailableToStart?: boolean | null } | null };

export type QuizTimeUsersQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type QuizTimeUsersQuery = { __typename?: 'Query', quizSessionMembers?: Array<{ __typename?: 'QuizSessionMemberType', id?: any | null, isAvailableForQuizDuel?: boolean | null, userData?: { __typename?: 'QuizDuelScoreType', id: any, rank?: number | null, points: number, user?: { __typename?: 'UserType', id?: any | null, username?: string | null, avatar?: string | null } | null } | null } | null> | null };

export type PrivacyPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivacyPolicyQuery = { __typename?: 'Query', privatePolicy?: { __typename?: 'PrivatePolicyType', id: any, text?: string | null } | null };

export type DataProtectionQueryVariables = Exact<{ [key: string]: never; }>;


export type DataProtectionQuery = { __typename?: 'Query', dataProtection?: { __typename?: 'DataProtectionType', id: any, text?: string | null } | null };

export type ImprintQueryVariables = Exact<{ [key: string]: never; }>;


export type ImprintQuery = { __typename?: 'Query', impressum?: { __typename?: 'ImpressumType', id: any, text?: string | null } | null };

export type QuizSessionsOngoingQueryVariables = Exact<{ [key: string]: never; }>;


export type QuizSessionsOngoingQuery = { __typename?: 'Query', ongoingQuizSessions?: Array<{ __typename?: 'QuizTimeSessionType', id: any, status?: QuizTimeSessionStatus | null, startDate: any, quizTimeDuration?: number | null, startDateTime?: any | null, finishDateTime?: any | null, isForPremiumOnly: boolean, userQuizSessionSetting?: { __typename?: 'UserQuizSessionSettingsType', id: any, userStatus?: UserQuizSessionSettingsUserStatus | null, quizSessionLabelStatus?: QuizSessionLabelStatusesEnum | null } | null, quizTime: { __typename?: 'QuizTimeType', id: any, quizTimeImage?: string | null, title: string, organizer: { __typename?: 'OrganizerType', id: any, name?: string | null } } } | null> | null };

export type QuizSessionsAnnouncedQueryVariables = Exact<{ [key: string]: never; }>;


export type QuizSessionsAnnouncedQuery = { __typename?: 'Query', announcedQuizSessions?: Array<{ __typename?: 'QuizTimeSessionType', id: any, status?: QuizTimeSessionStatus | null, startDate: any, quizTimeDuration?: number | null, startDateTime?: any | null, finishDateTime?: any | null, isForPremiumOnly: boolean, userQuizSessionSetting?: { __typename?: 'UserQuizSessionSettingsType', id: any, userStatus?: UserQuizSessionSettingsUserStatus | null, quizSessionLabelStatus?: QuizSessionLabelStatusesEnum | null } | null, quizTime: { __typename?: 'QuizTimeType', id: any, quizTimeImage?: string | null, title: string, organizer: { __typename?: 'OrganizerType', id: any, name?: string | null } } } | null> | null };

export type QuizSessionsFinishedQueryVariables = Exact<{ [key: string]: never; }>;


export type QuizSessionsFinishedQuery = { __typename?: 'Query', finishedQuizSessions?: Array<{ __typename?: 'FinishedUserQuizSessionType', id?: any | null, userRank?: number | null, quizSession?: { __typename?: 'QuizTimeSessionType', id: any, status?: QuizTimeSessionStatus | null, startDate: any, quizTimeDuration?: number | null, startDateTime?: any | null, finishDateTime?: any | null, isForPremiumOnly: boolean, userQuizSessionSetting?: { __typename?: 'UserQuizSessionSettingsType', id: any, userStatus?: UserQuizSessionSettingsUserStatus | null, quizSessionLabelStatus?: QuizSessionLabelStatusesEnum | null } | null, quizTime: { __typename?: 'QuizTimeType', id: any, quizTimeImage?: string | null, title: string, organizer: { __typename?: 'OrganizerType', id: any, name?: string | null } } } | null } | null> | null };

export type QuizSessionsOnHomePageQueryVariables = Exact<{
  startLess24Hours?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuizSessionsOnHomePageQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id?: any | null, settings?: { __typename?: 'SettingsType', id: any, duelMode: boolean, activeQuizTime?: { __typename?: 'QuizTimeSessionType', id: any } | null } | null } | null, homeQuizSessions?: Array<{ __typename?: 'HomeQuizTimeSessionsType', userStatus?: string | null, quizSession?: { __typename?: 'QuizTimeSessionType', id: any, startDate: any, startDateTime?: any | null, finishDateTime?: any | null, status?: QuizTimeSessionStatus | null, quizTimeDuration?: number | null, duelDuration?: number | null, quizTime: { __typename?: 'QuizTimeType', id: any, title: string, quizTimeImage?: string | null } } | null } | null> | null, inProgressUserQuizSession?: { __typename?: 'QuizTimeSessionType', id: any, startDate: any, startDateTime?: any | null, finishDateTime?: any | null, status?: QuizTimeSessionStatus | null, quizTimeDuration?: number | null, duelDuration?: number | null, quizTime: { __typename?: 'QuizTimeType', id: any, title: string, quizTimeImage?: string | null } } | null };

export type GetActiveQuizDuelsQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetActiveQuizDuelsQuery = { __typename?: 'Query', activeQuizDuels?: Array<{ __typename?: 'ActiveQuizDuelsType', id?: any | null, isInitiator?: boolean | null, opponent?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, round?: { __typename?: 'DuelRoundType', id: any, roundNumber: number, created: any, duel?: { __typename?: 'DuelType', id: any, status?: DuelStatus | null } | null, userQuestions: Array<{ __typename?: 'DuelRoundQuestionAnswerType', id: any, questionNumber?: number | null, user?: { __typename?: 'UserType', id?: any | null } | null, question?: { __typename?: 'QuestionType', id: any, value: string } | null, userAnswer?: { __typename?: 'AnswersType', id: any, value: string } | null }> } | null, session?: { __typename?: 'QuizTimeSessionType', id: any } | null } | null> | null };

export type QuizScoreQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type QuizScoreQuery = { __typename?: 'Query', quizDuelScore?: { __typename?: 'QuizDuelScoreType', id: any, duels: number, points: number, rank?: number | null, wins: number, ties: number, loss: number } | null };

export type GetCompletedQuizDuelsQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetCompletedQuizDuelsQuery = { __typename?: 'Query', completedQuizDuels?: Array<{ __typename?: 'UsersQuizDuelsDataType', id?: any | null, userDuelsData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, duel?: { __typename?: 'DuelType', id: any, updated: any, status?: DuelStatus | null } | null, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, opponentDuelsData?: { __typename?: 'DuelResultUserDataType', id: any, initiator?: boolean | null, youTurn?: boolean | null, duelScore?: number | null, userStatus: DuelResultUserDataUserStatus, user?: { __typename?: 'UserType', id?: any | null, avatar?: string | null, username?: string | null } | null, classRoomLearningSession?: { __typename?: 'ClassRoomLearningSessionType', id: any, classRoom: { __typename?: 'ClassRoomType', id: any, title: string } } | null } | null, session?: { __typename?: 'QuizTimeSessionType', id: any } | null } | null> | null };

export type GetQuizSessionPrizeQueryVariables = Exact<{
  quizSessionId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetQuizSessionPrizeQuery = { __typename?: 'Query', quizSessionPrize?: { __typename?: 'QuizSessionPrizeListType', placeList?: Array<{ __typename?: 'QuizSessionPrizeType', id: any, placeNumber?: number | null, prizeType?: QuizSessionPrizePrizeType | null, roles?: string | null, quizTimePrize: { __typename?: 'QuizTimePrizeType', id: any, title: string, description?: string | null, prizeImage?: string | null } } | null> | null, participationList?: Array<{ __typename?: 'QuizSessionPrizeType', id: any, placeNumber?: number | null, prizeType?: QuizSessionPrizePrizeType | null, roles?: string | null, quizTimePrize: { __typename?: 'QuizTimePrizeType', id: any, title: string, description?: string | null, prizeImage?: string | null } } | null> | null, lotteryList?: Array<{ __typename?: 'QuizSessionPrizeType', id: any, placeNumber?: number | null, prizeType?: QuizSessionPrizePrizeType | null, roles?: string | null, quizTimePrize: { __typename?: 'QuizTimePrizeType', id: any, title: string, description?: string | null, prizeImage?: string | null } } | null> | null } | null };

export type GetFeedbackQuestionQueryVariables = Exact<{
  questionId: Scalars['UUID']['input'];
}>;


export type GetFeedbackQuestionQuery = { __typename?: 'Query', getFeedbackForQuestion?: { __typename?: 'FeedbackForQuestionType', id: any, relevanceRate?: number | null, interestRate?: number | null, comment?: string | null } | null };

export type LearningProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type LearningProgressQuery = { __typename?: 'Query', userLearningProgress?: { __typename?: 'UserLearningProgressType', percentageOfAnswers: any, progressStatus?: UserLearningProgressProgressStatus | null, totalQuestionCount?: number | null, answeredQuestionsCount?: number | null, correctAnsweredQuestionCount?: number | null, incorrectAnsweredQuestionCount?: number | null, percentageOfCorrectAnswers: any, percentageOfIncorrectAnswers: any, duelsCount?: number | null, wonDuelsCount?: number | null, tiedDuelsCount?: number | null, loseDuelsCount?: number | null, sessionStats?: { __typename?: 'UserSessionStatsType', totalSessions?: number | null, achievedCount?: number | null, activeSessions?: number | null } | null } | null };

export type UserDailyStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDailyStatsQuery = { __typename?: 'Query', userDailyStats?: Array<{ __typename?: 'UserDailyStatType', date?: string | null, total?: number | null, incorrect?: number | null, correct?: number | null } | null> | null };

export type TakenAchievementQueryVariables = Exact<{ [key: string]: never; }>;


export type TakenAchievementQuery = { __typename?: 'Query', dailyStatus?: string | null };

export type ForgotPasswordMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', userForgotPassword?: { __typename?: 'UserForgotPasswordMutation', user?: { __typename?: 'UserType', id?: any | null } | null } | null };

export const User_FragmentFragmentDoc = gql`
    fragment user_fragment on UserType {
  id
  avatar
  firstName
  lastName
  username
  email
  dateOfBirth
  gender
  postcode
  dateJoined
  confirmationToken
  profession {
    id
    title
    type {
      id
      title
      type
    }
  }
  anotherProfession
  speciality {
    id
    title
  }
  workplace {
    id
    title
  }
  anotherWorkplace
  efnNumber
  educationLevel {
    id
    title
  }
  university {
    id
    title
  }
  semester {
    id
    title
  }
  registrationNumber
  medicineStudyBegin
  studyBegin {
    id
    title
  }
  studyYear {
    id
    title
  }
  classRoomLearningSession {
    id
  }
  examYear
  professionId
  specialityId
  workplaceId
  educationLevelId
  universityId
  semesterId
  studyBeginId
  studyYearId
  network {
    title
  }
  isPremium
  isInAppPremium
  isPromotionPremium
  isUserForTest
  referralCount
  subscribeToNews
}
    `;
export const User_Settings_FragmentFragmentDoc = gql`
    fragment user_settings_fragment on SettingsType {
  id
  duelMode
  goal
  dailyTipperMode
  pushNotificationMode
  pushNotificationDailyTipperMode
  pushNotificationDuelMode
  pushNotificationNewChapterMode
  pushNotificationPremiumMode
  pushNotificationQuizTimeMode
  isDailyTipperRulesRead
  isDuelRulesRead
  isQuizDuelRulesRead
  isLikeHumeoQuestionRead
  isIntroCompleted
  isClassRoomIntroCompleted
  isCookieAccepted
  isMarketingCookieAccepted
  isIosInstallationPopupSkipped
  isChromeInstallationPopupSkipped
  activeQuizTime {
    id
  }
}
    `;
export const Lecture_FragmentFragmentDoc = gql`
    fragment lecture_fragment on LectureType {
  id
  title
  description
  lectureLink
  correctAnswersGoal
  questions {
    id
  }
  lectors {
    id
    firstName
    lastName
    photo
    professions {
      id
      title
    }
    specialities {
      id
      title
    }
  }
}
    `;
export const Classroom_Ls_FragmentFragmentDoc = gql`
    fragment classroom_ls_fragment on ClassRoomLearningSessionType {
  id
  status
  startDate
  finishDate
  isForPremiumOnly
  duration
  classRoom {
    id
    title
    classRoomImage
    backgroundImage
    enrollmentType
    aggregatedRate {
      id
      averageRate
      feedbackCount
    }
    certificate {
      id
      points
    }
    idNumber
    organizer {
      id
      name
    }
  }
}
    `;
export const User_Question_FragmentFragmentDoc = gql`
    fragment user_question_fragment on DuelRoundQuestionAnswerType {
  id
  questionNumber
  user {
    id
  }
  question {
    id
    value
    questionImage
    explanation
    sortedLinks {
      id
      url
      linkCategory {
        id
        title
      }
    }
    answers {
      id
      value
    }
  }
  userAnswer {
    id
    value
  }
  correctAnswer {
    id
    value
  }
}
    `;
export const Daily_Tipper_Question_FragmentFragmentDoc = gql`
    fragment daily_tipper_question_fragment on DailyTipperQuestionAnswerType {
  id
  questionNumber
  question {
    id
    value
    questionImage
    explanation
    sortedLinks {
      id
      url
      linkCategory {
        id
        title
      }
    }
    answers {
      id
      value
    }
  }
  userAnswer {
    id
    value
  }
  correctAnswer {
    id
    value
  }
  actualLearningWeek {
    id
    weekProgress
  }
}
    `;
export const User_Score_FragmentFragmentDoc = gql`
    fragment user_score_fragment on DuelResultUserDataType {
  id
  user {
    id
    avatar
    username
  }
  classRoomLearningSession {
    id
    classRoom {
      id
      title
    }
  }
  initiator
  youTurn
  duelScore
  userStatus
}
    `;
export const Quiztime_List_FragmentFragmentDoc = gql`
    fragment quiztime_list_fragment on QuizTimeSessionType {
  id
  status
  startDate
  quizTimeDuration
  startDateTime
  finishDateTime
  isForPremiumOnly
  userQuizSessionSetting {
    id
    userStatus
    quizSessionLabelStatus
  }
  quizTime {
    id
    quizTimeImage
    title
    organizer {
      id
      name
    }
  }
}
    `;
export const Quiztime_Homelist_FragmentFragmentDoc = gql`
    fragment quiztime_homelist_fragment on QuizTimeSessionType {
  id
  startDate
  startDateTime
  finishDateTime
  status
  quizTimeDuration
  duelDuration
  quizTime {
    id
    title
    quizTimeImage
  }
}
    `;
export const Quiz_Prize_ItemFragmentDoc = gql`
    fragment quiz_prize_item on QuizSessionPrizeType {
  id
  placeNumber
  prizeType
  roles
  quizTimePrize {
    id
    title
    description
    prizeImage
  }
}
    `;
export const Subscription_FragmentFragmentDoc = gql`
    fragment subscription_fragment on UserSubscriptionType {
  id
  store
  currentPeriodEnd
  lastError
  lastErrorCode
  priceId
  priceAmount
  currencyCode
  currencySymbol
  status
  priceType
  priceInterval
  priceIntervalCount
  feId
  name
  productId
  requestCancel
  upgradeStatus
  defaultCard {
    brand
    last4
  }
}
    `;
export const SignInDocument = gql`
    mutation signIn($email: String, $username: String, $password: String!) {
  userLogin(email: $email, username: $username, password: $password) {
    token
    user {
      ...user_fragment
    }
  }
}
    ${User_FragmentFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignUpDocument = gql`
    mutation signUp($firstName: String, $lastName: String, $email: String, $username: String, $dateOfBirth: Date, $gender: Int, $postcode: String, $specialityId: UUID, $anotherWorkplace: String, $anotherProfession: String, $efnNumber: String, $examYear: Int, $subscribeToNews: Boolean, $password: String, $passwordConfirmation: String, $studyBeginId: UUID, $educationLevelId: UUID, $universityId: UUID, $semesterId: UUID, $sharingSenderId: UUID, $registrationNumber: String, $medicineStudyBegin: Date, $workplaceId: UUID, $professionId: UUID, $studyYearId: UUID, $deepLinkHash: String, $googleAdsMetadata: GenericScalar) {
  userRegistration(
    firstName: $firstName
    lastName: $lastName
    email: $email
    username: $username
    dateOfBirth: $dateOfBirth
    gender: $gender
    postcode: $postcode
    specialityId: $specialityId
    anotherWorkplace: $anotherWorkplace
    anotherProfession: $anotherProfession
    efnNumber: $efnNumber
    examYear: $examYear
    subscribeToNews: $subscribeToNews
    password: $password
    passwordConfirmation: $passwordConfirmation
    studyBeginId: $studyBeginId
    educationLevelId: $educationLevelId
    universityId: $universityId
    semesterId: $semesterId
    sharingSenderId: $sharingSenderId
    registrationNumber: $registrationNumber
    medicineStudyBegin: $medicineStudyBegin
    workplaceId: $workplaceId
    professionId: $professionId
    studyYearId: $studyYearId
    deepLinkHash: $deepLinkHash
    googleAdsMetadata: $googleAdsMetadata
  ) {
    token
    user {
      ...user_fragment
    }
  }
}
    ${User_FragmentFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      gender: // value for 'gender'
 *      postcode: // value for 'postcode'
 *      specialityId: // value for 'specialityId'
 *      anotherWorkplace: // value for 'anotherWorkplace'
 *      anotherProfession: // value for 'anotherProfession'
 *      efnNumber: // value for 'efnNumber'
 *      examYear: // value for 'examYear'
 *      subscribeToNews: // value for 'subscribeToNews'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      studyBeginId: // value for 'studyBeginId'
 *      educationLevelId: // value for 'educationLevelId'
 *      universityId: // value for 'universityId'
 *      semesterId: // value for 'semesterId'
 *      sharingSenderId: // value for 'sharingSenderId'
 *      registrationNumber: // value for 'registrationNumber'
 *      medicineStudyBegin: // value for 'medicineStudyBegin'
 *      workplaceId: // value for 'workplaceId'
 *      professionId: // value for 'professionId'
 *      studyYearId: // value for 'studyYearId'
 *      deepLinkHash: // value for 'deepLinkHash'
 *      googleAdsMetadata: // value for 'googleAdsMetadata'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($anotherWorkplace: String, $anotherProfession: String, $dateOfBirth: Date, $educationLevelId: UUID, $examYear: Int, $firstName: String, $gender: Int, $lastName: String, $medicineStudyBegin: Date, $postcode: String, $registrationNumber: String, $efnNumber: String, $semesterId: UUID, $specialityId: UUID, $studyBeginId: UUID, $studyYearId: UUID, $universityId: UUID, $username: String, $workplaceId: UUID) {
  updateUserData(
    anotherWorkplace: $anotherWorkplace
    anotherProfession: $anotherProfession
    dateOfBirth: $dateOfBirth
    educationLevelId: $educationLevelId
    examYear: $examYear
    firstName: $firstName
    gender: $gender
    lastName: $lastName
    medicineStudyBegin: $medicineStudyBegin
    postcode: $postcode
    registrationNumber: $registrationNumber
    efnNumber: $efnNumber
    semesterId: $semesterId
    specialityId: $specialityId
    studyBeginId: $studyBeginId
    studyYearId: $studyYearId
    universityId: $universityId
    username: $username
    workplaceId: $workplaceId
  ) {
    token
    user {
      ...user_fragment
    }
  }
}
    ${User_FragmentFragmentDoc}`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      anotherWorkplace: // value for 'anotherWorkplace'
 *      anotherProfession: // value for 'anotherProfession'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      educationLevelId: // value for 'educationLevelId'
 *      examYear: // value for 'examYear'
 *      firstName: // value for 'firstName'
 *      gender: // value for 'gender'
 *      lastName: // value for 'lastName'
 *      medicineStudyBegin: // value for 'medicineStudyBegin'
 *      postcode: // value for 'postcode'
 *      registrationNumber: // value for 'registrationNumber'
 *      efnNumber: // value for 'efnNumber'
 *      semesterId: // value for 'semesterId'
 *      specialityId: // value for 'specialityId'
 *      studyBeginId: // value for 'studyBeginId'
 *      studyYearId: // value for 'studyYearId'
 *      universityId: // value for 'universityId'
 *      username: // value for 'username'
 *      workplaceId: // value for 'workplaceId'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($newPassword: String, $newPasswordConfirmation: String, $resetPasswordKey: String) {
  userRestorePassword(
    newPassword: $newPassword
    newPasswordConfirmation: $newPasswordConfirmation
    resetPasswordKey: $resetPasswordKey
  ) {
    user {
      id
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      newPasswordConfirmation: // value for 'newPasswordConfirmation'
 *      resetPasswordKey: // value for 'resetPasswordKey'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ConfirmTokenDocument = gql`
    mutation confirmToken($token: UUID) {
  userConfirm(token: $token) {
    user {
      id
      email
    }
  }
}
    `;
export type ConfirmTokenMutationFn = Apollo.MutationFunction<ConfirmTokenMutation, ConfirmTokenMutationVariables>;

/**
 * __useConfirmTokenMutation__
 *
 * To run a mutation, you first call `useConfirmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTokenMutation, { data, loading, error }] = useConfirmTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmTokenMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTokenMutation, ConfirmTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmTokenMutation, ConfirmTokenMutationVariables>(ConfirmTokenDocument, options);
      }
export type ConfirmTokenMutationHookResult = ReturnType<typeof useConfirmTokenMutation>;
export type ConfirmTokenMutationResult = Apollo.MutationResult<ConfirmTokenMutation>;
export type ConfirmTokenMutationOptions = Apollo.BaseMutationOptions<ConfirmTokenMutation, ConfirmTokenMutationVariables>;
export const UploadPhotoDocument = gql`
    mutation uploadPhoto($file: Upload!) {
  uploadPhoto(file: $file) {
    user {
      id
      avatar
    }
  }
}
    `;
export type UploadPhotoMutationFn = Apollo.MutationFunction<UploadPhotoMutation, UploadPhotoMutationVariables>;

/**
 * __useUploadPhotoMutation__
 *
 * To run a mutation, you first call `useUploadPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPhotoMutation, { data, loading, error }] = useUploadPhotoMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UploadPhotoMutation, UploadPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPhotoMutation, UploadPhotoMutationVariables>(UploadPhotoDocument, options);
      }
export type UploadPhotoMutationHookResult = ReturnType<typeof useUploadPhotoMutation>;
export type UploadPhotoMutationResult = Apollo.MutationResult<UploadPhotoMutation>;
export type UploadPhotoMutationOptions = Apollo.BaseMutationOptions<UploadPhotoMutation, UploadPhotoMutationVariables>;
export const ApplyNetworkCodeDocument = gql`
    mutation applyNetworkCode($code: Int) {
  applyNetworkCodeForUser(code: $code) {
    codes {
      code
    }
  }
}
    `;
export type ApplyNetworkCodeMutationFn = Apollo.MutationFunction<ApplyNetworkCodeMutation, ApplyNetworkCodeMutationVariables>;

/**
 * __useApplyNetworkCodeMutation__
 *
 * To run a mutation, you first call `useApplyNetworkCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyNetworkCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyNetworkCodeMutation, { data, loading, error }] = useApplyNetworkCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useApplyNetworkCodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyNetworkCodeMutation, ApplyNetworkCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyNetworkCodeMutation, ApplyNetworkCodeMutationVariables>(ApplyNetworkCodeDocument, options);
      }
export type ApplyNetworkCodeMutationHookResult = ReturnType<typeof useApplyNetworkCodeMutation>;
export type ApplyNetworkCodeMutationResult = Apollo.MutationResult<ApplyNetworkCodeMutation>;
export type ApplyNetworkCodeMutationOptions = Apollo.BaseMutationOptions<ApplyNetworkCodeMutation, ApplyNetworkCodeMutationVariables>;
export const ApplyClassroomCodeDocument = gql`
    mutation applyClassroomCode($code: Int, $sessionId: UUID, $isNetworkType: Boolean, $isAvailableTab: Boolean, $specialityGroupIcon: String, $deepLinkHash: String) {
  applyClassRoomCode(
    code: $code
    sessionId: $sessionId
    isNetworkType: $isNetworkType
    isAvailableTab: $isAvailableTab
    specialityGroupIcon: $specialityGroupIcon
    deepLinkHash: $deepLinkHash
  ) {
    classRoom {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
}
    `;
export type ApplyClassroomCodeMutationFn = Apollo.MutationFunction<ApplyClassroomCodeMutation, ApplyClassroomCodeMutationVariables>;

/**
 * __useApplyClassroomCodeMutation__
 *
 * To run a mutation, you first call `useApplyClassroomCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyClassroomCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyClassroomCodeMutation, { data, loading, error }] = useApplyClassroomCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      sessionId: // value for 'sessionId'
 *      isNetworkType: // value for 'isNetworkType'
 *      isAvailableTab: // value for 'isAvailableTab'
 *      specialityGroupIcon: // value for 'specialityGroupIcon'
 *      deepLinkHash: // value for 'deepLinkHash'
 *   },
 * });
 */
export function useApplyClassroomCodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyClassroomCodeMutation, ApplyClassroomCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyClassroomCodeMutation, ApplyClassroomCodeMutationVariables>(ApplyClassroomCodeDocument, options);
      }
export type ApplyClassroomCodeMutationHookResult = ReturnType<typeof useApplyClassroomCodeMutation>;
export type ApplyClassroomCodeMutationResult = Apollo.MutationResult<ApplyClassroomCodeMutation>;
export type ApplyClassroomCodeMutationOptions = Apollo.BaseMutationOptions<ApplyClassroomCodeMutation, ApplyClassroomCodeMutationVariables>;
export const JoinNetworkClassRoomDocument = gql`
    mutation joinNetworkClassRoom($sessionId: UUID, $deepLinkHash: String, $specialityGroupIcon: String, $isAfterOnboarding: Boolean) {
  joinToNetworkClassRoom(
    sessionId: $sessionId
    deepLinkHash: $deepLinkHash
    specialityGroupIcon: $specialityGroupIcon
    isAfterOnboarding: $isAfterOnboarding
  ) {
    classRoomSession {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
}
    `;
export type JoinNetworkClassRoomMutationFn = Apollo.MutationFunction<JoinNetworkClassRoomMutation, JoinNetworkClassRoomMutationVariables>;

/**
 * __useJoinNetworkClassRoomMutation__
 *
 * To run a mutation, you first call `useJoinNetworkClassRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinNetworkClassRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinNetworkClassRoomMutation, { data, loading, error }] = useJoinNetworkClassRoomMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      deepLinkHash: // value for 'deepLinkHash'
 *      specialityGroupIcon: // value for 'specialityGroupIcon'
 *      isAfterOnboarding: // value for 'isAfterOnboarding'
 *   },
 * });
 */
export function useJoinNetworkClassRoomMutation(baseOptions?: Apollo.MutationHookOptions<JoinNetworkClassRoomMutation, JoinNetworkClassRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinNetworkClassRoomMutation, JoinNetworkClassRoomMutationVariables>(JoinNetworkClassRoomDocument, options);
      }
export type JoinNetworkClassRoomMutationHookResult = ReturnType<typeof useJoinNetworkClassRoomMutation>;
export type JoinNetworkClassRoomMutationResult = Apollo.MutationResult<JoinNetworkClassRoomMutation>;
export type JoinNetworkClassRoomMutationOptions = Apollo.BaseMutationOptions<JoinNetworkClassRoomMutation, JoinNetworkClassRoomMutationVariables>;
export const JoinBlendedClassRoomDocument = gql`
    mutation joinBlendedClassRoom($sessionId: UUID, $deepLinkHash: String) {
  joinToBlendedClassRoom(sessionId: $sessionId, deepLinkHash: $deepLinkHash) {
    classRoomSession {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
}
    `;
export type JoinBlendedClassRoomMutationFn = Apollo.MutationFunction<JoinBlendedClassRoomMutation, JoinBlendedClassRoomMutationVariables>;

/**
 * __useJoinBlendedClassRoomMutation__
 *
 * To run a mutation, you first call `useJoinBlendedClassRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinBlendedClassRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinBlendedClassRoomMutation, { data, loading, error }] = useJoinBlendedClassRoomMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      deepLinkHash: // value for 'deepLinkHash'
 *   },
 * });
 */
export function useJoinBlendedClassRoomMutation(baseOptions?: Apollo.MutationHookOptions<JoinBlendedClassRoomMutation, JoinBlendedClassRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinBlendedClassRoomMutation, JoinBlendedClassRoomMutationVariables>(JoinBlendedClassRoomDocument, options);
      }
export type JoinBlendedClassRoomMutationHookResult = ReturnType<typeof useJoinBlendedClassRoomMutation>;
export type JoinBlendedClassRoomMutationResult = Apollo.MutationResult<JoinBlendedClassRoomMutation>;
export type JoinBlendedClassRoomMutationOptions = Apollo.BaseMutationOptions<JoinBlendedClassRoomMutation, JoinBlendedClassRoomMutationVariables>;
export const JoinLekClassRoomDocument = gql`
    mutation joinLekClassRoom($sessionId: UUID, $deepLinkHash: String) {
  joinToLekClassRoom(sessionId: $sessionId, deepLinkHash: $deepLinkHash) {
    classRoomSession {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
}
    `;
export type JoinLekClassRoomMutationFn = Apollo.MutationFunction<JoinLekClassRoomMutation, JoinLekClassRoomMutationVariables>;

/**
 * __useJoinLekClassRoomMutation__
 *
 * To run a mutation, you first call `useJoinLekClassRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLekClassRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLekClassRoomMutation, { data, loading, error }] = useJoinLekClassRoomMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      deepLinkHash: // value for 'deepLinkHash'
 *   },
 * });
 */
export function useJoinLekClassRoomMutation(baseOptions?: Apollo.MutationHookOptions<JoinLekClassRoomMutation, JoinLekClassRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinLekClassRoomMutation, JoinLekClassRoomMutationVariables>(JoinLekClassRoomDocument, options);
      }
export type JoinLekClassRoomMutationHookResult = ReturnType<typeof useJoinLekClassRoomMutation>;
export type JoinLekClassRoomMutationResult = Apollo.MutationResult<JoinLekClassRoomMutation>;
export type JoinLekClassRoomMutationOptions = Apollo.BaseMutationOptions<JoinLekClassRoomMutation, JoinLekClassRoomMutationVariables>;
export const JoinCmeClassRoomDocument = gql`
    mutation joinCmeClassRoom($deepLinkHash: String, $isAfterOnboarding: Boolean, $sessionId: UUID, $specialityGroupIcon: String) {
  joinToCmeClassRoom(
    deepLinkHash: $deepLinkHash
    isAfterOnboarding: $isAfterOnboarding
    sessionId: $sessionId
    specialityGroupIcon: $specialityGroupIcon
  ) {
    classRoomSession {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
}
    `;
export type JoinCmeClassRoomMutationFn = Apollo.MutationFunction<JoinCmeClassRoomMutation, JoinCmeClassRoomMutationVariables>;

/**
 * __useJoinCmeClassRoomMutation__
 *
 * To run a mutation, you first call `useJoinCmeClassRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCmeClassRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCmeClassRoomMutation, { data, loading, error }] = useJoinCmeClassRoomMutation({
 *   variables: {
 *      deepLinkHash: // value for 'deepLinkHash'
 *      isAfterOnboarding: // value for 'isAfterOnboarding'
 *      sessionId: // value for 'sessionId'
 *      specialityGroupIcon: // value for 'specialityGroupIcon'
 *   },
 * });
 */
export function useJoinCmeClassRoomMutation(baseOptions?: Apollo.MutationHookOptions<JoinCmeClassRoomMutation, JoinCmeClassRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCmeClassRoomMutation, JoinCmeClassRoomMutationVariables>(JoinCmeClassRoomDocument, options);
      }
export type JoinCmeClassRoomMutationHookResult = ReturnType<typeof useJoinCmeClassRoomMutation>;
export type JoinCmeClassRoomMutationResult = Apollo.MutationResult<JoinCmeClassRoomMutation>;
export type JoinCmeClassRoomMutationOptions = Apollo.BaseMutationOptions<JoinCmeClassRoomMutation, JoinCmeClassRoomMutationVariables>;
export const CreateUserDuelDocument = gql`
    mutation createUserDuel($opponentId: UUID, $sessionId: UUID, $isCustomDuel: Boolean, $isOnboardingDuel: Boolean) {
  createDuel(
    opponentId: $opponentId
    sessionId: $sessionId
    isCustomDuel: $isCustomDuel
    isOnboardingDuel: $isOnboardingDuel
  ) {
    duel {
      id
      status
      duelRound {
        id
        roundNumber
        userQuestions {
          ...user_question_fragment
        }
      }
    }
    errors
  }
}
    ${User_Question_FragmentFragmentDoc}`;
export type CreateUserDuelMutationFn = Apollo.MutationFunction<CreateUserDuelMutation, CreateUserDuelMutationVariables>;

/**
 * __useCreateUserDuelMutation__
 *
 * To run a mutation, you first call `useCreateUserDuelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDuelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDuelMutation, { data, loading, error }] = useCreateUserDuelMutation({
 *   variables: {
 *      opponentId: // value for 'opponentId'
 *      sessionId: // value for 'sessionId'
 *      isCustomDuel: // value for 'isCustomDuel'
 *      isOnboardingDuel: // value for 'isOnboardingDuel'
 *   },
 * });
 */
export function useCreateUserDuelMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDuelMutation, CreateUserDuelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDuelMutation, CreateUserDuelMutationVariables>(CreateUserDuelDocument, options);
      }
export type CreateUserDuelMutationHookResult = ReturnType<typeof useCreateUserDuelMutation>;
export type CreateUserDuelMutationResult = Apollo.MutationResult<CreateUserDuelMutation>;
export type CreateUserDuelMutationOptions = Apollo.BaseMutationOptions<CreateUserDuelMutation, CreateUserDuelMutationVariables>;
export const CreateUserRoundDocument = gql`
    mutation createUserRound($duelId: UUID) {
  createRound(duelId: $duelId) {
    round {
      id
      roundNumber
      duel {
        id
        status
        duelRound {
          id
          roundNumber
          userQuestions {
            ...user_question_fragment
          }
        }
      }
      userQuestions {
        ...user_question_fragment
      }
    }
  }
}
    ${User_Question_FragmentFragmentDoc}`;
export type CreateUserRoundMutationFn = Apollo.MutationFunction<CreateUserRoundMutation, CreateUserRoundMutationVariables>;

/**
 * __useCreateUserRoundMutation__
 *
 * To run a mutation, you first call `useCreateUserRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRoundMutation, { data, loading, error }] = useCreateUserRoundMutation({
 *   variables: {
 *      duelId: // value for 'duelId'
 *   },
 * });
 */
export function useCreateUserRoundMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserRoundMutation, CreateUserRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserRoundMutation, CreateUserRoundMutationVariables>(CreateUserRoundDocument, options);
      }
export type CreateUserRoundMutationHookResult = ReturnType<typeof useCreateUserRoundMutation>;
export type CreateUserRoundMutationResult = Apollo.MutationResult<CreateUserRoundMutation>;
export type CreateUserRoundMutationOptions = Apollo.BaseMutationOptions<CreateUserRoundMutation, CreateUserRoundMutationVariables>;
export const SetUserAnswerDocument = gql`
    mutation setUserAnswer($duelRoundQuestionAnswerId: UUID, $answerId: UUID) {
  setAnswer(
    duelRoundQuestionAnswerId: $duelRoundQuestionAnswerId
    answerId: $answerId
  ) {
    duelRoundQuestionAnswer {
      duelRound {
        id
        duel {
          id
          status
          result {
            currentUserData {
              ...user_score_fragment
            }
            opponentData {
              ...user_score_fragment
            }
          }
        }
        userQuestions {
          ...user_question_fragment
        }
      }
    }
  }
}
    ${User_Score_FragmentFragmentDoc}
${User_Question_FragmentFragmentDoc}`;
export type SetUserAnswerMutationFn = Apollo.MutationFunction<SetUserAnswerMutation, SetUserAnswerMutationVariables>;

/**
 * __useSetUserAnswerMutation__
 *
 * To run a mutation, you first call `useSetUserAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAnswerMutation, { data, loading, error }] = useSetUserAnswerMutation({
 *   variables: {
 *      duelRoundQuestionAnswerId: // value for 'duelRoundQuestionAnswerId'
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useSetUserAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetUserAnswerMutation, SetUserAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserAnswerMutation, SetUserAnswerMutationVariables>(SetUserAnswerDocument, options);
      }
export type SetUserAnswerMutationHookResult = ReturnType<typeof useSetUserAnswerMutation>;
export type SetUserAnswerMutationResult = Apollo.MutationResult<SetUserAnswerMutation>;
export type SetUserAnswerMutationOptions = Apollo.BaseMutationOptions<SetUserAnswerMutation, SetUserAnswerMutationVariables>;
export const SetUserDailyTipperAnswerDocument = gql`
    mutation setUserDailyTipperAnswer($questionId: UUID, $answerId: UUID) {
  setDailyTipperAnswer(questionId: $questionId, answerId: $answerId) {
    dailyTipperQuestionAnswerStatus {
      dailyTipperQuestionAnswer {
        ...daily_tipper_question_fragment
      }
      dailyStatus
    }
  }
}
    ${Daily_Tipper_Question_FragmentFragmentDoc}`;
export type SetUserDailyTipperAnswerMutationFn = Apollo.MutationFunction<SetUserDailyTipperAnswerMutation, SetUserDailyTipperAnswerMutationVariables>;

/**
 * __useSetUserDailyTipperAnswerMutation__
 *
 * To run a mutation, you first call `useSetUserDailyTipperAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserDailyTipperAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserDailyTipperAnswerMutation, { data, loading, error }] = useSetUserDailyTipperAnswerMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useSetUserDailyTipperAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetUserDailyTipperAnswerMutation, SetUserDailyTipperAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserDailyTipperAnswerMutation, SetUserDailyTipperAnswerMutationVariables>(SetUserDailyTipperAnswerDocument, options);
      }
export type SetUserDailyTipperAnswerMutationHookResult = ReturnType<typeof useSetUserDailyTipperAnswerMutation>;
export type SetUserDailyTipperAnswerMutationResult = Apollo.MutationResult<SetUserDailyTipperAnswerMutation>;
export type SetUserDailyTipperAnswerMutationOptions = Apollo.BaseMutationOptions<SetUserDailyTipperAnswerMutation, SetUserDailyTipperAnswerMutationVariables>;
export const SetOnboardingAnswerDocument = gql`
    mutation setOnboardingAnswer($questionId: UUID, $answerId: UUID) {
  setOnboardingAnswer(questionId: $questionId, answerId: $answerId) {
    userOnboardingQuestionAnswerData {
      answerIsCorrect
      question {
        id
      }
      userAnswer {
        id
        value
      }
      correctAnswer {
        id
        value
      }
    }
  }
}
    `;
export type SetOnboardingAnswerMutationFn = Apollo.MutationFunction<SetOnboardingAnswerMutation, SetOnboardingAnswerMutationVariables>;

/**
 * __useSetOnboardingAnswerMutation__
 *
 * To run a mutation, you first call `useSetOnboardingAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOnboardingAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOnboardingAnswerMutation, { data, loading, error }] = useSetOnboardingAnswerMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useSetOnboardingAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetOnboardingAnswerMutation, SetOnboardingAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOnboardingAnswerMutation, SetOnboardingAnswerMutationVariables>(SetOnboardingAnswerDocument, options);
      }
export type SetOnboardingAnswerMutationHookResult = ReturnType<typeof useSetOnboardingAnswerMutation>;
export type SetOnboardingAnswerMutationResult = Apollo.MutationResult<SetOnboardingAnswerMutation>;
export type SetOnboardingAnswerMutationOptions = Apollo.BaseMutationOptions<SetOnboardingAnswerMutation, SetOnboardingAnswerMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation readNotification($id: UUID) {
  notificationStatus(notificationId: $id) {
    notification {
      id
      isRead
    }
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const UnsubscribeToNewsDocument = gql`
    mutation unsubscribeToNews($userId: UUID) {
  userUnsubscribeToNews(userId: $userId) {
    user {
      id
    }
  }
}
    `;
export type UnsubscribeToNewsMutationFn = Apollo.MutationFunction<UnsubscribeToNewsMutation, UnsubscribeToNewsMutationVariables>;

/**
 * __useUnsubscribeToNewsMutation__
 *
 * To run a mutation, you first call `useUnsubscribeToNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeToNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeToNewsMutation, { data, loading, error }] = useUnsubscribeToNewsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnsubscribeToNewsMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeToNewsMutation, UnsubscribeToNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeToNewsMutation, UnsubscribeToNewsMutationVariables>(UnsubscribeToNewsDocument, options);
      }
export type UnsubscribeToNewsMutationHookResult = ReturnType<typeof useUnsubscribeToNewsMutation>;
export type UnsubscribeToNewsMutationResult = Apollo.MutationResult<UnsubscribeToNewsMutation>;
export type UnsubscribeToNewsMutationOptions = Apollo.BaseMutationOptions<UnsubscribeToNewsMutation, UnsubscribeToNewsMutationVariables>;
export const SubscribeToNewsDocument = gql`
    mutation subscribeToNews($userId: UUID) {
  userSubscribeToNews(userId: $userId) {
    user {
      id
    }
  }
}
    `;
export type SubscribeToNewsMutationFn = Apollo.MutationFunction<SubscribeToNewsMutation, SubscribeToNewsMutationVariables>;

/**
 * __useSubscribeToNewsMutation__
 *
 * To run a mutation, you first call `useSubscribeToNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToNewsMutation, { data, loading, error }] = useSubscribeToNewsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSubscribeToNewsMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToNewsMutation, SubscribeToNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToNewsMutation, SubscribeToNewsMutationVariables>(SubscribeToNewsDocument, options);
      }
export type SubscribeToNewsMutationHookResult = ReturnType<typeof useSubscribeToNewsMutation>;
export type SubscribeToNewsMutationResult = Apollo.MutationResult<SubscribeToNewsMutation>;
export type SubscribeToNewsMutationOptions = Apollo.BaseMutationOptions<SubscribeToNewsMutation, SubscribeToNewsMutationVariables>;
export const UpdateDtSettingsDocument = gql`
    mutation updateDTSettings($goal: Int, $mode: Boolean) {
  updateUserSettings(goal: $goal, dailyTipperMode: $mode) {
    userSettings {
      id
      goal
      dailyTipperMode
    }
  }
}
    `;
export type UpdateDtSettingsMutationFn = Apollo.MutationFunction<UpdateDtSettingsMutation, UpdateDtSettingsMutationVariables>;

/**
 * __useUpdateDtSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDtSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDtSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDtSettingsMutation, { data, loading, error }] = useUpdateDtSettingsMutation({
 *   variables: {
 *      goal: // value for 'goal'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useUpdateDtSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDtSettingsMutation, UpdateDtSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDtSettingsMutation, UpdateDtSettingsMutationVariables>(UpdateDtSettingsDocument, options);
      }
export type UpdateDtSettingsMutationHookResult = ReturnType<typeof useUpdateDtSettingsMutation>;
export type UpdateDtSettingsMutationResult = Apollo.MutationResult<UpdateDtSettingsMutation>;
export type UpdateDtSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDtSettingsMutation, UpdateDtSettingsMutationVariables>;
export const UpdateDuelsSettingsDocument = gql`
    mutation updateDuelsSettings($mode: Boolean) {
  updateUserSettings(duelMode: $mode) {
    userSettings {
      id
      duelMode
    }
  }
}
    `;
export type UpdateDuelsSettingsMutationFn = Apollo.MutationFunction<UpdateDuelsSettingsMutation, UpdateDuelsSettingsMutationVariables>;

/**
 * __useUpdateDuelsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDuelsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDuelsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDuelsSettingsMutation, { data, loading, error }] = useUpdateDuelsSettingsMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useUpdateDuelsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDuelsSettingsMutation, UpdateDuelsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDuelsSettingsMutation, UpdateDuelsSettingsMutationVariables>(UpdateDuelsSettingsDocument, options);
      }
export type UpdateDuelsSettingsMutationHookResult = ReturnType<typeof useUpdateDuelsSettingsMutation>;
export type UpdateDuelsSettingsMutationResult = Apollo.MutationResult<UpdateDuelsSettingsMutation>;
export type UpdateDuelsSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDuelsSettingsMutation, UpdateDuelsSettingsMutationVariables>;
export const UpdatePushNotificationsSettingsDocument = gql`
    mutation updatePushNotificationsSettings($pushNotificationMode: Boolean, $pushNotificationDailyTipperMode: Boolean, $pushNotificationDuelMode: Boolean, $pushNotificationNewChapterMode: Boolean, $pushNotificationPremiumMode: Boolean, $pushNotificationQuizTimeMode: Boolean) {
  updateUserSettings(
    pushNotificationMode: $pushNotificationMode
    pushNotificationDailyTipperMode: $pushNotificationDailyTipperMode
    pushNotificationDuelMode: $pushNotificationDuelMode
    pushNotificationNewChapterMode: $pushNotificationNewChapterMode
    pushNotificationPremiumMode: $pushNotificationPremiumMode
    pushNotificationQuizTimeMode: $pushNotificationQuizTimeMode
  ) {
    userSettings {
      id
      pushNotificationMode
      pushNotificationDailyTipperMode
      pushNotificationDuelMode
      pushNotificationNewChapterMode
      pushNotificationPremiumMode
      pushNotificationQuizTimeMode
    }
  }
}
    `;
export type UpdatePushNotificationsSettingsMutationFn = Apollo.MutationFunction<UpdatePushNotificationsSettingsMutation, UpdatePushNotificationsSettingsMutationVariables>;

/**
 * __useUpdatePushNotificationsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePushNotificationsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushNotificationsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePushNotificationsSettingsMutation, { data, loading, error }] = useUpdatePushNotificationsSettingsMutation({
 *   variables: {
 *      pushNotificationMode: // value for 'pushNotificationMode'
 *      pushNotificationDailyTipperMode: // value for 'pushNotificationDailyTipperMode'
 *      pushNotificationDuelMode: // value for 'pushNotificationDuelMode'
 *      pushNotificationNewChapterMode: // value for 'pushNotificationNewChapterMode'
 *      pushNotificationPremiumMode: // value for 'pushNotificationPremiumMode'
 *      pushNotificationQuizTimeMode: // value for 'pushNotificationQuizTimeMode'
 *   },
 * });
 */
export function useUpdatePushNotificationsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePushNotificationsSettingsMutation, UpdatePushNotificationsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePushNotificationsSettingsMutation, UpdatePushNotificationsSettingsMutationVariables>(UpdatePushNotificationsSettingsDocument, options);
      }
export type UpdatePushNotificationsSettingsMutationHookResult = ReturnType<typeof useUpdatePushNotificationsSettingsMutation>;
export type UpdatePushNotificationsSettingsMutationResult = Apollo.MutationResult<UpdatePushNotificationsSettingsMutation>;
export type UpdatePushNotificationsSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePushNotificationsSettingsMutation, UpdatePushNotificationsSettingsMutationVariables>;
export const UpdateRulesSettingsDocument = gql`
    mutation updateRulesSettings($isDailyTipperRulesRead: Boolean, $isDuelRulesRead: Boolean, $isQuizDuelRulesRead: Boolean, $isIntroCompleted: Boolean) {
  updateUserSettings(
    isDailyTipperRulesRead: $isDailyTipperRulesRead
    isDuelRulesRead: $isDuelRulesRead
    isQuizDuelRulesRead: $isQuizDuelRulesRead
    isIntroCompleted: $isIntroCompleted
  ) {
    userSettings {
      id
      isDailyTipperRulesRead
      isDuelRulesRead
      isQuizDuelRulesRead
      isIntroCompleted
    }
  }
}
    `;
export type UpdateRulesSettingsMutationFn = Apollo.MutationFunction<UpdateRulesSettingsMutation, UpdateRulesSettingsMutationVariables>;

/**
 * __useUpdateRulesSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateRulesSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRulesSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRulesSettingsMutation, { data, loading, error }] = useUpdateRulesSettingsMutation({
 *   variables: {
 *      isDailyTipperRulesRead: // value for 'isDailyTipperRulesRead'
 *      isDuelRulesRead: // value for 'isDuelRulesRead'
 *      isQuizDuelRulesRead: // value for 'isQuizDuelRulesRead'
 *      isIntroCompleted: // value for 'isIntroCompleted'
 *   },
 * });
 */
export function useUpdateRulesSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRulesSettingsMutation, UpdateRulesSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRulesSettingsMutation, UpdateRulesSettingsMutationVariables>(UpdateRulesSettingsDocument, options);
      }
export type UpdateRulesSettingsMutationHookResult = ReturnType<typeof useUpdateRulesSettingsMutation>;
export type UpdateRulesSettingsMutationResult = Apollo.MutationResult<UpdateRulesSettingsMutation>;
export type UpdateRulesSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateRulesSettingsMutation, UpdateRulesSettingsMutationVariables>;
export const UpdateClassroomSettingsDocument = gql`
    mutation updateClassroomSettings($sessionId: UUID, $dailyTipperMode: Boolean, $duelMode: Boolean, $isAchieved: Boolean, $isClosed: Boolean, $isOut: Boolean) {
  updateUserClassRoomSettings(
    sessionId: $sessionId
    dailyTipperMode: $dailyTipperMode
    duelMode: $duelMode
    isAchieved: $isAchieved
    isClosed: $isClosed
    isOut: $isOut
  ) {
    userClassRoomSettings {
      id
      isDuelModeEnabled
      isDailyTipperModeEnabled
      isAchieved
      isClosed
      isOut
    }
  }
}
    `;
export type UpdateClassroomSettingsMutationFn = Apollo.MutationFunction<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>;

/**
 * __useUpdateClassroomSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassroomSettingsMutation, { data, loading, error }] = useUpdateClassroomSettingsMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      dailyTipperMode: // value for 'dailyTipperMode'
 *      duelMode: // value for 'duelMode'
 *      isAchieved: // value for 'isAchieved'
 *      isClosed: // value for 'isClosed'
 *      isOut: // value for 'isOut'
 *   },
 * });
 */
export function useUpdateClassroomSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>(UpdateClassroomSettingsDocument, options);
      }
export type UpdateClassroomSettingsMutationHookResult = ReturnType<typeof useUpdateClassroomSettingsMutation>;
export type UpdateClassroomSettingsMutationResult = Apollo.MutationResult<UpdateClassroomSettingsMutation>;
export type UpdateClassroomSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateClassroomSettingsMutation, UpdateClassroomSettingsMutationVariables>;
export const UpdateIsIntroCompletedSettingsDocument = gql`
    mutation UpdateIsIntroCompletedSettings($isIntroCompleted: Boolean) {
  updateUserSettings(isIntroCompleted: $isIntroCompleted) {
    userSettings {
      id
      isIntroCompleted
    }
  }
}
    `;
export type UpdateIsIntroCompletedSettingsMutationFn = Apollo.MutationFunction<UpdateIsIntroCompletedSettingsMutation, UpdateIsIntroCompletedSettingsMutationVariables>;

/**
 * __useUpdateIsIntroCompletedSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIsIntroCompletedSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsIntroCompletedSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsIntroCompletedSettingsMutation, { data, loading, error }] = useUpdateIsIntroCompletedSettingsMutation({
 *   variables: {
 *      isIntroCompleted: // value for 'isIntroCompleted'
 *   },
 * });
 */
export function useUpdateIsIntroCompletedSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsIntroCompletedSettingsMutation, UpdateIsIntroCompletedSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsIntroCompletedSettingsMutation, UpdateIsIntroCompletedSettingsMutationVariables>(UpdateIsIntroCompletedSettingsDocument, options);
      }
export type UpdateIsIntroCompletedSettingsMutationHookResult = ReturnType<typeof useUpdateIsIntroCompletedSettingsMutation>;
export type UpdateIsIntroCompletedSettingsMutationResult = Apollo.MutationResult<UpdateIsIntroCompletedSettingsMutation>;
export type UpdateIsIntroCompletedSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateIsIntroCompletedSettingsMutation, UpdateIsIntroCompletedSettingsMutationVariables>;
export const UpdateIsClassRoomIntroCompletedSettingsDocument = gql`
    mutation UpdateIsClassRoomIntroCompletedSettings($isClassRoomIntroCompleted: Boolean) {
  updateUserSettings(isClassRoomIntroCompleted: $isClassRoomIntroCompleted) {
    userSettings {
      id
      isClassRoomIntroCompleted
    }
  }
}
    `;
export type UpdateIsClassRoomIntroCompletedSettingsMutationFn = Apollo.MutationFunction<UpdateIsClassRoomIntroCompletedSettingsMutation, UpdateIsClassRoomIntroCompletedSettingsMutationVariables>;

/**
 * __useUpdateIsClassRoomIntroCompletedSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIsClassRoomIntroCompletedSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsClassRoomIntroCompletedSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsClassRoomIntroCompletedSettingsMutation, { data, loading, error }] = useUpdateIsClassRoomIntroCompletedSettingsMutation({
 *   variables: {
 *      isClassRoomIntroCompleted: // value for 'isClassRoomIntroCompleted'
 *   },
 * });
 */
export function useUpdateIsClassRoomIntroCompletedSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsClassRoomIntroCompletedSettingsMutation, UpdateIsClassRoomIntroCompletedSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsClassRoomIntroCompletedSettingsMutation, UpdateIsClassRoomIntroCompletedSettingsMutationVariables>(UpdateIsClassRoomIntroCompletedSettingsDocument, options);
      }
export type UpdateIsClassRoomIntroCompletedSettingsMutationHookResult = ReturnType<typeof useUpdateIsClassRoomIntroCompletedSettingsMutation>;
export type UpdateIsClassRoomIntroCompletedSettingsMutationResult = Apollo.MutationResult<UpdateIsClassRoomIntroCompletedSettingsMutation>;
export type UpdateIsClassRoomIntroCompletedSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateIsClassRoomIntroCompletedSettingsMutation, UpdateIsClassRoomIntroCompletedSettingsMutationVariables>;
export const UpdateCookieAcceptedSettingsDocument = gql`
    mutation updateCookieAcceptedSettings($isCookieAccepted: Boolean, $isMarketingCookieAccepted: Boolean) {
  updateUserSettings(
    isCookieAccepted: $isCookieAccepted
    isMarketingCookieAccepted: $isMarketingCookieAccepted
  ) {
    userSettings {
      id
      isCookieAccepted
      isMarketingCookieAccepted
    }
  }
}
    `;
export type UpdateCookieAcceptedSettingsMutationFn = Apollo.MutationFunction<UpdateCookieAcceptedSettingsMutation, UpdateCookieAcceptedSettingsMutationVariables>;

/**
 * __useUpdateCookieAcceptedSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCookieAcceptedSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCookieAcceptedSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCookieAcceptedSettingsMutation, { data, loading, error }] = useUpdateCookieAcceptedSettingsMutation({
 *   variables: {
 *      isCookieAccepted: // value for 'isCookieAccepted'
 *      isMarketingCookieAccepted: // value for 'isMarketingCookieAccepted'
 *   },
 * });
 */
export function useUpdateCookieAcceptedSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCookieAcceptedSettingsMutation, UpdateCookieAcceptedSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCookieAcceptedSettingsMutation, UpdateCookieAcceptedSettingsMutationVariables>(UpdateCookieAcceptedSettingsDocument, options);
      }
export type UpdateCookieAcceptedSettingsMutationHookResult = ReturnType<typeof useUpdateCookieAcceptedSettingsMutation>;
export type UpdateCookieAcceptedSettingsMutationResult = Apollo.MutationResult<UpdateCookieAcceptedSettingsMutation>;
export type UpdateCookieAcceptedSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCookieAcceptedSettingsMutation, UpdateCookieAcceptedSettingsMutationVariables>;
export const LeaveClassroomDocument = gql`
    mutation leaveClassroom($sessionId: UUID) {
  leaveClassRoom(sessionId: $sessionId) {
    learningSessionSettings {
      id
    }
  }
}
    `;
export type LeaveClassroomMutationFn = Apollo.MutationFunction<LeaveClassroomMutation, LeaveClassroomMutationVariables>;

/**
 * __useLeaveClassroomMutation__
 *
 * To run a mutation, you first call `useLeaveClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveClassroomMutation, { data, loading, error }] = useLeaveClassroomMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useLeaveClassroomMutation(baseOptions?: Apollo.MutationHookOptions<LeaveClassroomMutation, LeaveClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveClassroomMutation, LeaveClassroomMutationVariables>(LeaveClassroomDocument, options);
      }
export type LeaveClassroomMutationHookResult = ReturnType<typeof useLeaveClassroomMutation>;
export type LeaveClassroomMutationResult = Apollo.MutationResult<LeaveClassroomMutation>;
export type LeaveClassroomMutationOptions = Apollo.BaseMutationOptions<LeaveClassroomMutation, LeaveClassroomMutationVariables>;
export const LeaveNetworkClassroomDocument = gql`
    mutation leaveNetworkClassroom($userSessionSettingsId: UUID) {
  leaveNetworkClassRoom(userSessionSettingsId: $userSessionSettingsId) {
    learningSessionSettings {
      id
    }
  }
}
    `;
export type LeaveNetworkClassroomMutationFn = Apollo.MutationFunction<LeaveNetworkClassroomMutation, LeaveNetworkClassroomMutationVariables>;

/**
 * __useLeaveNetworkClassroomMutation__
 *
 * To run a mutation, you first call `useLeaveNetworkClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveNetworkClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveNetworkClassroomMutation, { data, loading, error }] = useLeaveNetworkClassroomMutation({
 *   variables: {
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useLeaveNetworkClassroomMutation(baseOptions?: Apollo.MutationHookOptions<LeaveNetworkClassroomMutation, LeaveNetworkClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveNetworkClassroomMutation, LeaveNetworkClassroomMutationVariables>(LeaveNetworkClassroomDocument, options);
      }
export type LeaveNetworkClassroomMutationHookResult = ReturnType<typeof useLeaveNetworkClassroomMutation>;
export type LeaveNetworkClassroomMutationResult = Apollo.MutationResult<LeaveNetworkClassroomMutation>;
export type LeaveNetworkClassroomMutationOptions = Apollo.BaseMutationOptions<LeaveNetworkClassroomMutation, LeaveNetworkClassroomMutationVariables>;
export const EarlyFinishNetworkClassroomDocument = gql`
    mutation earlyFinishNetworkClassroom($userSessionSettingsId: UUID) {
  earlyFinishNetworkClassRoom(userSessionSettingsId: $userSessionSettingsId) {
    learningSessionSettings {
      id
    }
  }
}
    `;
export type EarlyFinishNetworkClassroomMutationFn = Apollo.MutationFunction<EarlyFinishNetworkClassroomMutation, EarlyFinishNetworkClassroomMutationVariables>;

/**
 * __useEarlyFinishNetworkClassroomMutation__
 *
 * To run a mutation, you first call `useEarlyFinishNetworkClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyFinishNetworkClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyFinishNetworkClassroomMutation, { data, loading, error }] = useEarlyFinishNetworkClassroomMutation({
 *   variables: {
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useEarlyFinishNetworkClassroomMutation(baseOptions?: Apollo.MutationHookOptions<EarlyFinishNetworkClassroomMutation, EarlyFinishNetworkClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarlyFinishNetworkClassroomMutation, EarlyFinishNetworkClassroomMutationVariables>(EarlyFinishNetworkClassroomDocument, options);
      }
export type EarlyFinishNetworkClassroomMutationHookResult = ReturnType<typeof useEarlyFinishNetworkClassroomMutation>;
export type EarlyFinishNetworkClassroomMutationResult = Apollo.MutationResult<EarlyFinishNetworkClassroomMutation>;
export type EarlyFinishNetworkClassroomMutationOptions = Apollo.BaseMutationOptions<EarlyFinishNetworkClassroomMutation, EarlyFinishNetworkClassroomMutationVariables>;
export const EarlyFinishBlendedClassroomDocument = gql`
    mutation earlyFinishBlendedClassroom($userSessionSettingsId: UUID) {
  earlyFinishBlendedClassRoom(userSessionSettingsId: $userSessionSettingsId) {
    learningSessionSettings {
      id
    }
  }
}
    `;
export type EarlyFinishBlendedClassroomMutationFn = Apollo.MutationFunction<EarlyFinishBlendedClassroomMutation, EarlyFinishBlendedClassroomMutationVariables>;

/**
 * __useEarlyFinishBlendedClassroomMutation__
 *
 * To run a mutation, you first call `useEarlyFinishBlendedClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyFinishBlendedClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyFinishBlendedClassroomMutation, { data, loading, error }] = useEarlyFinishBlendedClassroomMutation({
 *   variables: {
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useEarlyFinishBlendedClassroomMutation(baseOptions?: Apollo.MutationHookOptions<EarlyFinishBlendedClassroomMutation, EarlyFinishBlendedClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarlyFinishBlendedClassroomMutation, EarlyFinishBlendedClassroomMutationVariables>(EarlyFinishBlendedClassroomDocument, options);
      }
export type EarlyFinishBlendedClassroomMutationHookResult = ReturnType<typeof useEarlyFinishBlendedClassroomMutation>;
export type EarlyFinishBlendedClassroomMutationResult = Apollo.MutationResult<EarlyFinishBlendedClassroomMutation>;
export type EarlyFinishBlendedClassroomMutationOptions = Apollo.BaseMutationOptions<EarlyFinishBlendedClassroomMutation, EarlyFinishBlendedClassroomMutationVariables>;
export const EarlyFinishLekClassroomDocument = gql`
    mutation earlyFinishLekClassroom($userSessionSettingsId: UUID) {
  earlyFinishLekClassRoom(userSessionSettingsId: $userSessionSettingsId) {
    learningSessionSettings {
      id
    }
  }
}
    `;
export type EarlyFinishLekClassroomMutationFn = Apollo.MutationFunction<EarlyFinishLekClassroomMutation, EarlyFinishLekClassroomMutationVariables>;

/**
 * __useEarlyFinishLekClassroomMutation__
 *
 * To run a mutation, you first call `useEarlyFinishLekClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyFinishLekClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyFinishLekClassroomMutation, { data, loading, error }] = useEarlyFinishLekClassroomMutation({
 *   variables: {
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useEarlyFinishLekClassroomMutation(baseOptions?: Apollo.MutationHookOptions<EarlyFinishLekClassroomMutation, EarlyFinishLekClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EarlyFinishLekClassroomMutation, EarlyFinishLekClassroomMutationVariables>(EarlyFinishLekClassroomDocument, options);
      }
export type EarlyFinishLekClassroomMutationHookResult = ReturnType<typeof useEarlyFinishLekClassroomMutation>;
export type EarlyFinishLekClassroomMutationResult = Apollo.MutationResult<EarlyFinishLekClassroomMutation>;
export type EarlyFinishLekClassroomMutationOptions = Apollo.BaseMutationOptions<EarlyFinishLekClassroomMutation, EarlyFinishLekClassroomMutationVariables>;
export const ResumeBlendedClassroomDocument = gql`
    mutation resumeBlendedClassroom($userSessionSettingsId: UUID!) {
  resumeBlendedClassRoom(userSessionSettingsId: $userSessionSettingsId) {
    learningSessionSettings {
      id
      classRoomLearningSession {
        id
      }
    }
  }
}
    `;
export type ResumeBlendedClassroomMutationFn = Apollo.MutationFunction<ResumeBlendedClassroomMutation, ResumeBlendedClassroomMutationVariables>;

/**
 * __useResumeBlendedClassroomMutation__
 *
 * To run a mutation, you first call `useResumeBlendedClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeBlendedClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeBlendedClassroomMutation, { data, loading, error }] = useResumeBlendedClassroomMutation({
 *   variables: {
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useResumeBlendedClassroomMutation(baseOptions?: Apollo.MutationHookOptions<ResumeBlendedClassroomMutation, ResumeBlendedClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeBlendedClassroomMutation, ResumeBlendedClassroomMutationVariables>(ResumeBlendedClassroomDocument, options);
      }
export type ResumeBlendedClassroomMutationHookResult = ReturnType<typeof useResumeBlendedClassroomMutation>;
export type ResumeBlendedClassroomMutationResult = Apollo.MutationResult<ResumeBlendedClassroomMutation>;
export type ResumeBlendedClassroomMutationOptions = Apollo.BaseMutationOptions<ResumeBlendedClassroomMutation, ResumeBlendedClassroomMutationVariables>;
export const PauseBlendedClassroomDocument = gql`
    mutation pauseBlendedClassroom($userSessionSettingsId: UUID!) {
  pauseBlendedClassRoom(userSessionSettingsId: $userSessionSettingsId) {
    learningSessionSettings {
      id
      classRoomLearningSession {
        id
      }
    }
  }
}
    `;
export type PauseBlendedClassroomMutationFn = Apollo.MutationFunction<PauseBlendedClassroomMutation, PauseBlendedClassroomMutationVariables>;

/**
 * __usePauseBlendedClassroomMutation__
 *
 * To run a mutation, you first call `usePauseBlendedClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseBlendedClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseBlendedClassroomMutation, { data, loading, error }] = usePauseBlendedClassroomMutation({
 *   variables: {
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function usePauseBlendedClassroomMutation(baseOptions?: Apollo.MutationHookOptions<PauseBlendedClassroomMutation, PauseBlendedClassroomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseBlendedClassroomMutation, PauseBlendedClassroomMutationVariables>(PauseBlendedClassroomDocument, options);
      }
export type PauseBlendedClassroomMutationHookResult = ReturnType<typeof usePauseBlendedClassroomMutation>;
export type PauseBlendedClassroomMutationResult = Apollo.MutationResult<PauseBlendedClassroomMutation>;
export type PauseBlendedClassroomMutationOptions = Apollo.BaseMutationOptions<PauseBlendedClassroomMutation, PauseBlendedClassroomMutationVariables>;
export const UserLekStartDocument = gql`
    mutation userLekStart($lekSessionId: UUID, $startTime: DateTime) {
  lekStart(lekSessionId: $lekSessionId, startTime: $startTime) {
    userLekData {
      id
      created
      status
      elapsedTime
      lekSession {
        id
      }
      userLekQuestionAnswerData {
        id
        question {
          id
        }
        userAnswer {
          id
        }
      }
    }
  }
}
    `;
export type UserLekStartMutationFn = Apollo.MutationFunction<UserLekStartMutation, UserLekStartMutationVariables>;

/**
 * __useUserLekStartMutation__
 *
 * To run a mutation, you first call `useUserLekStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLekStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLekStartMutation, { data, loading, error }] = useUserLekStartMutation({
 *   variables: {
 *      lekSessionId: // value for 'lekSessionId'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useUserLekStartMutation(baseOptions?: Apollo.MutationHookOptions<UserLekStartMutation, UserLekStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLekStartMutation, UserLekStartMutationVariables>(UserLekStartDocument, options);
      }
export type UserLekStartMutationHookResult = ReturnType<typeof useUserLekStartMutation>;
export type UserLekStartMutationResult = Apollo.MutationResult<UserLekStartMutation>;
export type UserLekStartMutationOptions = Apollo.BaseMutationOptions<UserLekStartMutation, UserLekStartMutationVariables>;
export const UpdateIsChromeInstallationPopupSkippedSettingsDocument = gql`
    mutation updateIsChromeInstallationPopupSkippedSettings($isChromeInstallationPopupSkipped: Boolean) {
  updateUserSettings(
    isChromeInstallationPopupSkipped: $isChromeInstallationPopupSkipped
  ) {
    userSettings {
      id
      isChromeInstallationPopupSkipped
    }
  }
}
    `;
export type UpdateIsChromeInstallationPopupSkippedSettingsMutationFn = Apollo.MutationFunction<UpdateIsChromeInstallationPopupSkippedSettingsMutation, UpdateIsChromeInstallationPopupSkippedSettingsMutationVariables>;

/**
 * __useUpdateIsChromeInstallationPopupSkippedSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIsChromeInstallationPopupSkippedSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsChromeInstallationPopupSkippedSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsChromeInstallationPopupSkippedSettingsMutation, { data, loading, error }] = useUpdateIsChromeInstallationPopupSkippedSettingsMutation({
 *   variables: {
 *      isChromeInstallationPopupSkipped: // value for 'isChromeInstallationPopupSkipped'
 *   },
 * });
 */
export function useUpdateIsChromeInstallationPopupSkippedSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsChromeInstallationPopupSkippedSettingsMutation, UpdateIsChromeInstallationPopupSkippedSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsChromeInstallationPopupSkippedSettingsMutation, UpdateIsChromeInstallationPopupSkippedSettingsMutationVariables>(UpdateIsChromeInstallationPopupSkippedSettingsDocument, options);
      }
export type UpdateIsChromeInstallationPopupSkippedSettingsMutationHookResult = ReturnType<typeof useUpdateIsChromeInstallationPopupSkippedSettingsMutation>;
export type UpdateIsChromeInstallationPopupSkippedSettingsMutationResult = Apollo.MutationResult<UpdateIsChromeInstallationPopupSkippedSettingsMutation>;
export type UpdateIsChromeInstallationPopupSkippedSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateIsChromeInstallationPopupSkippedSettingsMutation, UpdateIsChromeInstallationPopupSkippedSettingsMutationVariables>;
export const UserLekFinishDocument = gql`
    mutation userLekFinish($lekSessionId: UUID, $userLekDataId: UUID) {
  lekFinish(lekSessionId: $lekSessionId, userLekDataId: $userLekDataId) {
    userLekData {
      id
      status
      elapsedTime
      isPassed
      correctAnswerCount
    }
  }
}
    `;
export type UserLekFinishMutationFn = Apollo.MutationFunction<UserLekFinishMutation, UserLekFinishMutationVariables>;

/**
 * __useUserLekFinishMutation__
 *
 * To run a mutation, you first call `useUserLekFinishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLekFinishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLekFinishMutation, { data, loading, error }] = useUserLekFinishMutation({
 *   variables: {
 *      lekSessionId: // value for 'lekSessionId'
 *      userLekDataId: // value for 'userLekDataId'
 *   },
 * });
 */
export function useUserLekFinishMutation(baseOptions?: Apollo.MutationHookOptions<UserLekFinishMutation, UserLekFinishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLekFinishMutation, UserLekFinishMutationVariables>(UserLekFinishDocument, options);
      }
export type UserLekFinishMutationHookResult = ReturnType<typeof useUserLekFinishMutation>;
export type UserLekFinishMutationResult = Apollo.MutationResult<UserLekFinishMutation>;
export type UserLekFinishMutationOptions = Apollo.BaseMutationOptions<UserLekFinishMutation, UserLekFinishMutationVariables>;
export const SetUserLekAnswerDocument = gql`
    mutation setUserLekAnswer($answerId: UUID, $lekSessionId: UUID, $questionId: UUID, $answerTime: DateTime) {
  setLekAnswer(
    answerId: $answerId
    lekSessionId: $lekSessionId
    questionId: $questionId
    answerTime: $answerTime
  ) {
    userLekQuestionAnswerData {
      id
      userLekData {
        id
        status
      }
    }
  }
}
    `;
export type SetUserLekAnswerMutationFn = Apollo.MutationFunction<SetUserLekAnswerMutation, SetUserLekAnswerMutationVariables>;

/**
 * __useSetUserLekAnswerMutation__
 *
 * To run a mutation, you first call `useSetUserLekAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserLekAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserLekAnswerMutation, { data, loading, error }] = useSetUserLekAnswerMutation({
 *   variables: {
 *      answerId: // value for 'answerId'
 *      lekSessionId: // value for 'lekSessionId'
 *      questionId: // value for 'questionId'
 *      answerTime: // value for 'answerTime'
 *   },
 * });
 */
export function useSetUserLekAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetUserLekAnswerMutation, SetUserLekAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserLekAnswerMutation, SetUserLekAnswerMutationVariables>(SetUserLekAnswerDocument, options);
      }
export type SetUserLekAnswerMutationHookResult = ReturnType<typeof useSetUserLekAnswerMutation>;
export type SetUserLekAnswerMutationResult = Apollo.MutationResult<SetUserLekAnswerMutation>;
export type SetUserLekAnswerMutationOptions = Apollo.BaseMutationOptions<SetUserLekAnswerMutation, SetUserLekAnswerMutationVariables>;
export const DeleteUserAccountDocument = gql`
    mutation deleteUserAccount {
  deleteAccount {
    isDeleted
  }
}
    `;
export type DeleteUserAccountMutationFn = Apollo.MutationFunction<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;

/**
 * __useDeleteUserAccountMutation__
 *
 * To run a mutation, you first call `useDeleteUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAccountMutation, { data, loading, error }] = useDeleteUserAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, options);
      }
export type DeleteUserAccountMutationHookResult = ReturnType<typeof useDeleteUserAccountMutation>;
export type DeleteUserAccountMutationResult = Apollo.MutationResult<DeleteUserAccountMutation>;
export type DeleteUserAccountMutationOptions = Apollo.BaseMutationOptions<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>;
export const CreateStripeCheckoutSessionDocument = gql`
    mutation createStripeCheckoutSession($returnUrl: String, $stripePriceId: String!) {
  createCheckoutSession(returnUrl: $returnUrl, stripePriceId: $stripePriceId) {
    session
  }
}
    `;
export type CreateStripeCheckoutSessionMutationFn = Apollo.MutationFunction<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>;

/**
 * __useCreateStripeCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripeCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCheckoutSessionMutation, { data, loading, error }] = useCreateStripeCheckoutSessionMutation({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *      stripePriceId: // value for 'stripePriceId'
 *   },
 * });
 */
export function useCreateStripeCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>(CreateStripeCheckoutSessionDocument, options);
      }
export type CreateStripeCheckoutSessionMutationHookResult = ReturnType<typeof useCreateStripeCheckoutSessionMutation>;
export type CreateStripeCheckoutSessionMutationResult = Apollo.MutationResult<CreateStripeCheckoutSessionMutation>;
export type CreateStripeCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>;
export const ChangeStripeSubscriptionDocument = gql`
    mutation changeStripeSubscription($stripePriceId: String) {
  changeSubscription(stripePriceId: $stripePriceId) {
    subscription {
      id
      status
      currentPeriodEnd
      requestCancel
      upgradeStatus
      product {
        id
        feId
        name
      }
      price {
        id
        type
        amount
        interval
        intervalCount
        trialPeriodDays
        stripeProductId
        appleStoreId
        googlePlayId
      }
    }
  }
}
    `;
export type ChangeStripeSubscriptionMutationFn = Apollo.MutationFunction<ChangeStripeSubscriptionMutation, ChangeStripeSubscriptionMutationVariables>;

/**
 * __useChangeStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useChangeStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeStripeSubscriptionMutation, { data, loading, error }] = useChangeStripeSubscriptionMutation({
 *   variables: {
 *      stripePriceId: // value for 'stripePriceId'
 *   },
 * });
 */
export function useChangeStripeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeStripeSubscriptionMutation, ChangeStripeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeStripeSubscriptionMutation, ChangeStripeSubscriptionMutationVariables>(ChangeStripeSubscriptionDocument, options);
      }
export type ChangeStripeSubscriptionMutationHookResult = ReturnType<typeof useChangeStripeSubscriptionMutation>;
export type ChangeStripeSubscriptionMutationResult = Apollo.MutationResult<ChangeStripeSubscriptionMutation>;
export type ChangeStripeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ChangeStripeSubscriptionMutation, ChangeStripeSubscriptionMutationVariables>;
export const DeleteStripePaymentMethodDocument = gql`
    mutation deleteStripePaymentMethod {
  deleteDefaultPaymentMethod {
    customer {
      id
      defaultCard {
        brand
        last4
      }
    }
  }
}
    `;
export type DeleteStripePaymentMethodMutationFn = Apollo.MutationFunction<DeleteStripePaymentMethodMutation, DeleteStripePaymentMethodMutationVariables>;

/**
 * __useDeleteStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStripePaymentMethodMutation, { data, loading, error }] = useDeleteStripePaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteStripePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStripePaymentMethodMutation, DeleteStripePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStripePaymentMethodMutation, DeleteStripePaymentMethodMutationVariables>(DeleteStripePaymentMethodDocument, options);
      }
export type DeleteStripePaymentMethodMutationHookResult = ReturnType<typeof useDeleteStripePaymentMethodMutation>;
export type DeleteStripePaymentMethodMutationResult = Apollo.MutationResult<DeleteStripePaymentMethodMutation>;
export type DeleteStripePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteStripePaymentMethodMutation, DeleteStripePaymentMethodMutationVariables>;
export const CreateStripeSetupCheckoutSessionDocument = gql`
    mutation createStripeSetupCheckoutSession($returnUrl: String, $stripePriceId: String!) {
  createSetupCheckoutSession(returnUrl: $returnUrl, stripePriceId: $stripePriceId) {
    session
  }
}
    `;
export type CreateStripeSetupCheckoutSessionMutationFn = Apollo.MutationFunction<CreateStripeSetupCheckoutSessionMutation, CreateStripeSetupCheckoutSessionMutationVariables>;

/**
 * __useCreateStripeSetupCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripeSetupCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeSetupCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeSetupCheckoutSessionMutation, { data, loading, error }] = useCreateStripeSetupCheckoutSessionMutation({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *      stripePriceId: // value for 'stripePriceId'
 *   },
 * });
 */
export function useCreateStripeSetupCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeSetupCheckoutSessionMutation, CreateStripeSetupCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeSetupCheckoutSessionMutation, CreateStripeSetupCheckoutSessionMutationVariables>(CreateStripeSetupCheckoutSessionDocument, options);
      }
export type CreateStripeSetupCheckoutSessionMutationHookResult = ReturnType<typeof useCreateStripeSetupCheckoutSessionMutation>;
export type CreateStripeSetupCheckoutSessionMutationResult = Apollo.MutationResult<CreateStripeSetupCheckoutSessionMutation>;
export type CreateStripeSetupCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateStripeSetupCheckoutSessionMutation, CreateStripeSetupCheckoutSessionMutationVariables>;
export const CancelUserSubscriptionDocument = gql`
    mutation cancelUserSubscription {
  cancelSubscription {
    subscription {
      id
      status
      currentPeriodEnd
      requestCancel
      product {
        id
        feId
        name
      }
      price {
        id
        type
        amount
        interval
        intervalCount
        trialPeriodDays
        stripeProductId
        appleStoreId
        googlePlayId
      }
    }
  }
}
    `;
export type CancelUserSubscriptionMutationFn = Apollo.MutationFunction<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>;

/**
 * __useCancelUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUserSubscriptionMutation, { data, loading, error }] = useCancelUserSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelUserSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>(CancelUserSubscriptionDocument, options);
      }
export type CancelUserSubscriptionMutationHookResult = ReturnType<typeof useCancelUserSubscriptionMutation>;
export type CancelUserSubscriptionMutationResult = Apollo.MutationResult<CancelUserSubscriptionMutation>;
export type CancelUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>;
export const RenewPlanDocument = gql`
    mutation renewPlan {
  renewSubscription {
    subscription {
      id
      status
      currentPeriodEnd
      requestCancel
      product {
        id
        feId
        name
      }
      price {
        id
        type
        amount
        interval
        intervalCount
        trialPeriodDays
        stripeProductId
        appleStoreId
        googlePlayId
      }
    }
  }
}
    `;
export type RenewPlanMutationFn = Apollo.MutationFunction<RenewPlanMutation, RenewPlanMutationVariables>;

/**
 * __useRenewPlanMutation__
 *
 * To run a mutation, you first call `useRenewPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewPlanMutation, { data, loading, error }] = useRenewPlanMutation({
 *   variables: {
 *   },
 * });
 */
export function useRenewPlanMutation(baseOptions?: Apollo.MutationHookOptions<RenewPlanMutation, RenewPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewPlanMutation, RenewPlanMutationVariables>(RenewPlanDocument, options);
      }
export type RenewPlanMutationHookResult = ReturnType<typeof useRenewPlanMutation>;
export type RenewPlanMutationResult = Apollo.MutationResult<RenewPlanMutation>;
export type RenewPlanMutationOptions = Apollo.BaseMutationOptions<RenewPlanMutation, RenewPlanMutationVariables>;
export const InAppUserSubscribeDocument = gql`
    mutation inAppUserSubscribe($subscriptionObject: GenericScalar) {
  inAppSubscribe(subscriptionObject: $subscriptionObject) {
    inAppSubscription {
      id
      me {
        id
        isPremium
        isInAppPremium
        isPromotionPremium
      }
      subscription {
        ...subscription_fragment
      }
    }
  }
}
    ${Subscription_FragmentFragmentDoc}`;
export type InAppUserSubscribeMutationFn = Apollo.MutationFunction<InAppUserSubscribeMutation, InAppUserSubscribeMutationVariables>;

/**
 * __useInAppUserSubscribeMutation__
 *
 * To run a mutation, you first call `useInAppUserSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInAppUserSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inAppUserSubscribeMutation, { data, loading, error }] = useInAppUserSubscribeMutation({
 *   variables: {
 *      subscriptionObject: // value for 'subscriptionObject'
 *   },
 * });
 */
export function useInAppUserSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<InAppUserSubscribeMutation, InAppUserSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InAppUserSubscribeMutation, InAppUserSubscribeMutationVariables>(InAppUserSubscribeDocument, options);
      }
export type InAppUserSubscribeMutationHookResult = ReturnType<typeof useInAppUserSubscribeMutation>;
export type InAppUserSubscribeMutationResult = Apollo.MutationResult<InAppUserSubscribeMutation>;
export type InAppUserSubscribeMutationOptions = Apollo.BaseMutationOptions<InAppUserSubscribeMutation, InAppUserSubscribeMutationVariables>;
export const UpgradeInAppSubscriptionDocument = gql`
    mutation upgradeInAppSubscription($subscriptionObject: GenericScalar) {
  changeInAppSubscription(subscriptionObject: $subscriptionObject) {
    inAppSubscription {
      id
      me {
        id
        isPremium
        isInAppPremium
        isPromotionPremium
      }
      subscription {
        ...subscription_fragment
      }
    }
  }
}
    ${Subscription_FragmentFragmentDoc}`;
export type UpgradeInAppSubscriptionMutationFn = Apollo.MutationFunction<UpgradeInAppSubscriptionMutation, UpgradeInAppSubscriptionMutationVariables>;

/**
 * __useUpgradeInAppSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeInAppSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeInAppSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeInAppSubscriptionMutation, { data, loading, error }] = useUpgradeInAppSubscriptionMutation({
 *   variables: {
 *      subscriptionObject: // value for 'subscriptionObject'
 *   },
 * });
 */
export function useUpgradeInAppSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeInAppSubscriptionMutation, UpgradeInAppSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeInAppSubscriptionMutation, UpgradeInAppSubscriptionMutationVariables>(UpgradeInAppSubscriptionDocument, options);
      }
export type UpgradeInAppSubscriptionMutationHookResult = ReturnType<typeof useUpgradeInAppSubscriptionMutation>;
export type UpgradeInAppSubscriptionMutationResult = Apollo.MutationResult<UpgradeInAppSubscriptionMutation>;
export type UpgradeInAppSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpgradeInAppSubscriptionMutation, UpgradeInAppSubscriptionMutationVariables>;
export const UpdateIsIosInstallationPopupSkippedSettingsDocument = gql`
    mutation updateIsIosInstallationPopupSkippedSettings($isIosInstallationPopupSkipped: Boolean) {
  updateUserSettings(
    isIosInstallationPopupSkipped: $isIosInstallationPopupSkipped
  ) {
    userSettings {
      id
      isIosInstallationPopupSkipped
    }
  }
}
    `;
export type UpdateIsIosInstallationPopupSkippedSettingsMutationFn = Apollo.MutationFunction<UpdateIsIosInstallationPopupSkippedSettingsMutation, UpdateIsIosInstallationPopupSkippedSettingsMutationVariables>;

/**
 * __useUpdateIsIosInstallationPopupSkippedSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIsIosInstallationPopupSkippedSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsIosInstallationPopupSkippedSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsIosInstallationPopupSkippedSettingsMutation, { data, loading, error }] = useUpdateIsIosInstallationPopupSkippedSettingsMutation({
 *   variables: {
 *      isIosInstallationPopupSkipped: // value for 'isIosInstallationPopupSkipped'
 *   },
 * });
 */
export function useUpdateIsIosInstallationPopupSkippedSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsIosInstallationPopupSkippedSettingsMutation, UpdateIsIosInstallationPopupSkippedSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsIosInstallationPopupSkippedSettingsMutation, UpdateIsIosInstallationPopupSkippedSettingsMutationVariables>(UpdateIsIosInstallationPopupSkippedSettingsDocument, options);
      }
export type UpdateIsIosInstallationPopupSkippedSettingsMutationHookResult = ReturnType<typeof useUpdateIsIosInstallationPopupSkippedSettingsMutation>;
export type UpdateIsIosInstallationPopupSkippedSettingsMutationResult = Apollo.MutationResult<UpdateIsIosInstallationPopupSkippedSettingsMutation>;
export type UpdateIsIosInstallationPopupSkippedSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateIsIosInstallationPopupSkippedSettingsMutation, UpdateIsIosInstallationPopupSkippedSettingsMutationVariables>;
export const ApplyQuizTimeCodeDocument = gql`
    mutation applyQuizTimeCode($code: Int, $sessionId: UUID!, $deepLinkHash: String) {
  joinToQuiz(code: $code, sessionId: $sessionId, deepLinkHash: $deepLinkHash) {
    quizSession {
      id
      quizTime {
        id
      }
    }
  }
}
    `;
export type ApplyQuizTimeCodeMutationFn = Apollo.MutationFunction<ApplyQuizTimeCodeMutation, ApplyQuizTimeCodeMutationVariables>;

/**
 * __useApplyQuizTimeCodeMutation__
 *
 * To run a mutation, you first call `useApplyQuizTimeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyQuizTimeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyQuizTimeCodeMutation, { data, loading, error }] = useApplyQuizTimeCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      sessionId: // value for 'sessionId'
 *      deepLinkHash: // value for 'deepLinkHash'
 *   },
 * });
 */
export function useApplyQuizTimeCodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyQuizTimeCodeMutation, ApplyQuizTimeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyQuizTimeCodeMutation, ApplyQuizTimeCodeMutationVariables>(ApplyQuizTimeCodeDocument, options);
      }
export type ApplyQuizTimeCodeMutationHookResult = ReturnType<typeof useApplyQuizTimeCodeMutation>;
export type ApplyQuizTimeCodeMutationResult = Apollo.MutationResult<ApplyQuizTimeCodeMutation>;
export type ApplyQuizTimeCodeMutationOptions = Apollo.BaseMutationOptions<ApplyQuizTimeCodeMutation, ApplyQuizTimeCodeMutationVariables>;
export const LeaveQuizTimeDocument = gql`
    mutation LeaveQuizTime($sessionId: UUID!) {
  leaveQuiz(sessionId: $sessionId) {
    session {
      id
    }
  }
}
    `;
export type LeaveQuizTimeMutationFn = Apollo.MutationFunction<LeaveQuizTimeMutation, LeaveQuizTimeMutationVariables>;

/**
 * __useLeaveQuizTimeMutation__
 *
 * To run a mutation, you first call `useLeaveQuizTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveQuizTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveQuizTimeMutation, { data, loading, error }] = useLeaveQuizTimeMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useLeaveQuizTimeMutation(baseOptions?: Apollo.MutationHookOptions<LeaveQuizTimeMutation, LeaveQuizTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveQuizTimeMutation, LeaveQuizTimeMutationVariables>(LeaveQuizTimeDocument, options);
      }
export type LeaveQuizTimeMutationHookResult = ReturnType<typeof useLeaveQuizTimeMutation>;
export type LeaveQuizTimeMutationResult = Apollo.MutationResult<LeaveQuizTimeMutation>;
export type LeaveQuizTimeMutationOptions = Apollo.BaseMutationOptions<LeaveQuizTimeMutation, LeaveQuizTimeMutationVariables>;
export const StartQuizDocument = gql`
    mutation startQuiz($quizSessionId: UUID!) {
  quizStartByUser(quizSessionId: $quizSessionId) {
    quizSession {
      id
      status
    }
  }
}
    `;
export type StartQuizMutationFn = Apollo.MutationFunction<StartQuizMutation, StartQuizMutationVariables>;

/**
 * __useStartQuizMutation__
 *
 * To run a mutation, you first call `useStartQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuizMutation, { data, loading, error }] = useStartQuizMutation({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useStartQuizMutation(baseOptions?: Apollo.MutationHookOptions<StartQuizMutation, StartQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartQuizMutation, StartQuizMutationVariables>(StartQuizDocument, options);
      }
export type StartQuizMutationHookResult = ReturnType<typeof useStartQuizMutation>;
export type StartQuizMutationResult = Apollo.MutationResult<StartQuizMutation>;
export type StartQuizMutationOptions = Apollo.BaseMutationOptions<StartQuizMutation, StartQuizMutationVariables>;
export const PauseQuizDocument = gql`
    mutation pauseQuiz($pauseMode: Boolean!, $quizSessionId: UUID!) {
  switchPauseMode(pauseMode: $pauseMode, quizSessionId: $quizSessionId) {
    userQuizSessionSettings {
      id
      userStatus
    }
  }
}
    `;
export type PauseQuizMutationFn = Apollo.MutationFunction<PauseQuizMutation, PauseQuizMutationVariables>;

/**
 * __usePauseQuizMutation__
 *
 * To run a mutation, you first call `usePauseQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseQuizMutation, { data, loading, error }] = usePauseQuizMutation({
 *   variables: {
 *      pauseMode: // value for 'pauseMode'
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function usePauseQuizMutation(baseOptions?: Apollo.MutationHookOptions<PauseQuizMutation, PauseQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseQuizMutation, PauseQuizMutationVariables>(PauseQuizDocument, options);
      }
export type PauseQuizMutationHookResult = ReturnType<typeof usePauseQuizMutation>;
export type PauseQuizMutationResult = Apollo.MutationResult<PauseQuizMutation>;
export type PauseQuizMutationOptions = Apollo.BaseMutationOptions<PauseQuizMutation, PauseQuizMutationVariables>;
export const CreateQuiztimeDuelDocument = gql`
    mutation createQuiztimeDuel($quizSessionId: UUID!) {
  createQuizDuel(quizSessionId: $quizSessionId) {
    duel {
      id
      status
      duelRound {
        id
        roundNumber
        userQuestions {
          ...user_question_fragment
        }
      }
    }
  }
}
    ${User_Question_FragmentFragmentDoc}`;
export type CreateQuiztimeDuelMutationFn = Apollo.MutationFunction<CreateQuiztimeDuelMutation, CreateQuiztimeDuelMutationVariables>;

/**
 * __useCreateQuiztimeDuelMutation__
 *
 * To run a mutation, you first call `useCreateQuiztimeDuelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuiztimeDuelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuiztimeDuelMutation, { data, loading, error }] = useCreateQuiztimeDuelMutation({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useCreateQuiztimeDuelMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuiztimeDuelMutation, CreateQuiztimeDuelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuiztimeDuelMutation, CreateQuiztimeDuelMutationVariables>(CreateQuiztimeDuelDocument, options);
      }
export type CreateQuiztimeDuelMutationHookResult = ReturnType<typeof useCreateQuiztimeDuelMutation>;
export type CreateQuiztimeDuelMutationResult = Apollo.MutationResult<CreateQuiztimeDuelMutation>;
export type CreateQuiztimeDuelMutationOptions = Apollo.BaseMutationOptions<CreateQuiztimeDuelMutation, CreateQuiztimeDuelMutationVariables>;
export const CreateQuiztimeDuelByOpponentDocument = gql`
    mutation createQuiztimeDuelByOpponent($opponentId: UUID!, $quizSessionId: UUID!) {
  createQuizDuelByOpponent(opponentId: $opponentId, quizSessionId: $quizSessionId) {
    duel {
      id
      status
      duelRound {
        id
        roundNumber
        userQuestions {
          ...user_question_fragment
        }
      }
    }
  }
}
    ${User_Question_FragmentFragmentDoc}`;
export type CreateQuiztimeDuelByOpponentMutationFn = Apollo.MutationFunction<CreateQuiztimeDuelByOpponentMutation, CreateQuiztimeDuelByOpponentMutationVariables>;

/**
 * __useCreateQuiztimeDuelByOpponentMutation__
 *
 * To run a mutation, you first call `useCreateQuiztimeDuelByOpponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuiztimeDuelByOpponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuiztimeDuelByOpponentMutation, { data, loading, error }] = useCreateQuiztimeDuelByOpponentMutation({
 *   variables: {
 *      opponentId: // value for 'opponentId'
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useCreateQuiztimeDuelByOpponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuiztimeDuelByOpponentMutation, CreateQuiztimeDuelByOpponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuiztimeDuelByOpponentMutation, CreateQuiztimeDuelByOpponentMutationVariables>(CreateQuiztimeDuelByOpponentDocument, options);
      }
export type CreateQuiztimeDuelByOpponentMutationHookResult = ReturnType<typeof useCreateQuiztimeDuelByOpponentMutation>;
export type CreateQuiztimeDuelByOpponentMutationResult = Apollo.MutationResult<CreateQuiztimeDuelByOpponentMutation>;
export type CreateQuiztimeDuelByOpponentMutationOptions = Apollo.BaseMutationOptions<CreateQuiztimeDuelByOpponentMutation, CreateQuiztimeDuelByOpponentMutationVariables>;
export const AddWaitingUserNotificationDocument = gql`
    mutation addWaitingUserNotification($sessionId: UUID!) {
  addWaitingUser(sessionId: $sessionId) {
    waitingUser {
      id
      quizSession {
        id
        usersCount
      }
    }
  }
}
    `;
export type AddWaitingUserNotificationMutationFn = Apollo.MutationFunction<AddWaitingUserNotificationMutation, AddWaitingUserNotificationMutationVariables>;

/**
 * __useAddWaitingUserNotificationMutation__
 *
 * To run a mutation, you first call `useAddWaitingUserNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWaitingUserNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWaitingUserNotificationMutation, { data, loading, error }] = useAddWaitingUserNotificationMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useAddWaitingUserNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AddWaitingUserNotificationMutation, AddWaitingUserNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWaitingUserNotificationMutation, AddWaitingUserNotificationMutationVariables>(AddWaitingUserNotificationDocument, options);
      }
export type AddWaitingUserNotificationMutationHookResult = ReturnType<typeof useAddWaitingUserNotificationMutation>;
export type AddWaitingUserNotificationMutationResult = Apollo.MutationResult<AddWaitingUserNotificationMutation>;
export type AddWaitingUserNotificationMutationOptions = Apollo.BaseMutationOptions<AddWaitingUserNotificationMutation, AddWaitingUserNotificationMutationVariables>;
export const GetDeepLinkDocument = gql`
    mutation getDeepLink($hash: String!, $source: String) {
  getDeepLink(hash: $hash, source: $source) {
    deepLink {
      targetObjectId
      targetType
    }
  }
}
    `;
export type GetDeepLinkMutationFn = Apollo.MutationFunction<GetDeepLinkMutation, GetDeepLinkMutationVariables>;

/**
 * __useGetDeepLinkMutation__
 *
 * To run a mutation, you first call `useGetDeepLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDeepLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDeepLinkMutation, { data, loading, error }] = useGetDeepLinkMutation({
 *   variables: {
 *      hash: // value for 'hash'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetDeepLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetDeepLinkMutation, GetDeepLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDeepLinkMutation, GetDeepLinkMutationVariables>(GetDeepLinkDocument, options);
      }
export type GetDeepLinkMutationHookResult = ReturnType<typeof useGetDeepLinkMutation>;
export type GetDeepLinkMutationResult = Apollo.MutationResult<GetDeepLinkMutation>;
export type GetDeepLinkMutationOptions = Apollo.BaseMutationOptions<GetDeepLinkMutation, GetDeepLinkMutationVariables>;
export const CreateFeedbackQuestionDocument = gql`
    mutation createFeedbackQuestion($questionId: UUID!, $interestRate: Int!, $relevanceRate: Int!, $comment: String) {
  createFeedbackForQuestion(
    questionId: $questionId
    interestRate: $interestRate
    relevanceRate: $relevanceRate
    comment: $comment
  ) {
    feedbackForQuestion {
      id
      relevanceRate
      interestRate
      comment
      question {
        id
        value
      }
    }
  }
}
    `;
export type CreateFeedbackQuestionMutationFn = Apollo.MutationFunction<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>;

/**
 * __useCreateFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackQuestionMutation, { data, loading, error }] = useCreateFeedbackQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      interestRate: // value for 'interestRate'
 *      relevanceRate: // value for 'relevanceRate'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>(CreateFeedbackQuestionDocument, options);
      }
export type CreateFeedbackQuestionMutationHookResult = ReturnType<typeof useCreateFeedbackQuestionMutation>;
export type CreateFeedbackQuestionMutationResult = Apollo.MutationResult<CreateFeedbackQuestionMutation>;
export type CreateFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>;
export const EditFeedbackQuestionDocument = gql`
    mutation editFeedbackQuestion($questionId: UUID!, $interestRate: Int, $relevanceRate: Int, $comment: String) {
  editFeedbackForQuestion(
    questionId: $questionId
    interestRate: $interestRate
    relevanceRate: $relevanceRate
    comment: $comment
  ) {
    feedbackForQuestion {
      id
      relevanceRate
      interestRate
      comment
      question {
        id
        value
      }
    }
  }
}
    `;
export type EditFeedbackQuestionMutationFn = Apollo.MutationFunction<EditFeedbackQuestionMutation, EditFeedbackQuestionMutationVariables>;

/**
 * __useEditFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useEditFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFeedbackQuestionMutation, { data, loading, error }] = useEditFeedbackQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      interestRate: // value for 'interestRate'
 *      relevanceRate: // value for 'relevanceRate'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useEditFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<EditFeedbackQuestionMutation, EditFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFeedbackQuestionMutation, EditFeedbackQuestionMutationVariables>(EditFeedbackQuestionDocument, options);
      }
export type EditFeedbackQuestionMutationHookResult = ReturnType<typeof useEditFeedbackQuestionMutation>;
export type EditFeedbackQuestionMutationResult = Apollo.MutationResult<EditFeedbackQuestionMutation>;
export type EditFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<EditFeedbackQuestionMutation, EditFeedbackQuestionMutationVariables>;
export const SetExpoTokenDocument = gql`
    mutation setExpoToken($expoToken: String) {
  setUserExpoToken(expoToken: $expoToken) {
    result
  }
}
    `;
export type SetExpoTokenMutationFn = Apollo.MutationFunction<SetExpoTokenMutation, SetExpoTokenMutationVariables>;

/**
 * __useSetExpoTokenMutation__
 *
 * To run a mutation, you first call `useSetExpoTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExpoTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExpoTokenMutation, { data, loading, error }] = useSetExpoTokenMutation({
 *   variables: {
 *      expoToken: // value for 'expoToken'
 *   },
 * });
 */
export function useSetExpoTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetExpoTokenMutation, SetExpoTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetExpoTokenMutation, SetExpoTokenMutationVariables>(SetExpoTokenDocument, options);
      }
export type SetExpoTokenMutationHookResult = ReturnType<typeof useSetExpoTokenMutation>;
export type SetExpoTokenMutationResult = Apollo.MutationResult<SetExpoTokenMutation>;
export type SetExpoTokenMutationOptions = Apollo.BaseMutationOptions<SetExpoTokenMutation, SetExpoTokenMutationVariables>;
export const UserSubscriptionDocument = gql`
    query userSubscription {
  me {
    id
    isPremium
    isPromotionPremium
    isInAppPremium
    promotionFinishDate
  }
  subscription {
    ...subscription_fragment
  }
}
    ${Subscription_FragmentFragmentDoc}`;

/**
 * __useUserSubscriptionQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<UserSubscriptionQuery, UserSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSubscriptionQuery, UserSubscriptionQueryVariables>(UserSubscriptionDocument, options);
      }
export function useUserSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSubscriptionQuery, UserSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSubscriptionQuery, UserSubscriptionQueryVariables>(UserSubscriptionDocument, options);
        }
export type UserSubscriptionQueryHookResult = ReturnType<typeof useUserSubscriptionQuery>;
export type UserSubscriptionLazyQueryHookResult = ReturnType<typeof useUserSubscriptionLazyQuery>;
export type UserSubscriptionQueryResult = Apollo.QueryResult<UserSubscriptionQuery, UserSubscriptionQueryVariables>;
export const UserDiscountsDocument = gql`
    query userDiscounts {
  discounts {
    id
    couponName
    status
    discount
    startActiveDatetime
    finishActiveDatetime
  }
}
    `;

/**
 * __useUserDiscountsQuery__
 *
 * To run a query within a React component, call `useUserDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<UserDiscountsQuery, UserDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDiscountsQuery, UserDiscountsQueryVariables>(UserDiscountsDocument, options);
      }
export function useUserDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDiscountsQuery, UserDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDiscountsQuery, UserDiscountsQueryVariables>(UserDiscountsDocument, options);
        }
export type UserDiscountsQueryHookResult = ReturnType<typeof useUserDiscountsQuery>;
export type UserDiscountsLazyQueryHookResult = ReturnType<typeof useUserDiscountsLazyQuery>;
export type UserDiscountsQueryResult = Apollo.QueryResult<UserDiscountsQuery, UserDiscountsQueryVariables>;
export const UserPlansDocument = gql`
    query userPlans {
  plans {
    id
    isActive
    feId
    name
    prices {
      id
      stripeId
      isActive
      currency {
        id
        symbol
      }
      amount
      interval
      intervalCount
      name
      trialPeriodDays
      type
      googlePlayId
      appleStoreId
    }
  }
}
    `;

/**
 * __useUserPlansQuery__
 *
 * To run a query within a React component, call `useUserPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPlansQuery(baseOptions?: Apollo.QueryHookOptions<UserPlansQuery, UserPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPlansQuery, UserPlansQueryVariables>(UserPlansDocument, options);
      }
export function useUserPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPlansQuery, UserPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPlansQuery, UserPlansQueryVariables>(UserPlansDocument, options);
        }
export type UserPlansQueryHookResult = ReturnType<typeof useUserPlansQuery>;
export type UserPlansLazyQueryHookResult = ReturnType<typeof useUserPlansLazyQuery>;
export type UserPlansQueryResult = Apollo.QueryResult<UserPlansQuery, UserPlansQueryVariables>;
export const StripeCheckoutSessionStatusDocument = gql`
    query stripeCheckoutSessionStatus($sessionId: String!) {
  checkoutSessionStatus(sessionId: $sessionId) {
    status
    session
  }
}
    `;

/**
 * __useStripeCheckoutSessionStatusQuery__
 *
 * To run a query within a React component, call `useStripeCheckoutSessionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCheckoutSessionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCheckoutSessionStatusQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useStripeCheckoutSessionStatusQuery(baseOptions: Apollo.QueryHookOptions<StripeCheckoutSessionStatusQuery, StripeCheckoutSessionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCheckoutSessionStatusQuery, StripeCheckoutSessionStatusQueryVariables>(StripeCheckoutSessionStatusDocument, options);
      }
export function useStripeCheckoutSessionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCheckoutSessionStatusQuery, StripeCheckoutSessionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCheckoutSessionStatusQuery, StripeCheckoutSessionStatusQueryVariables>(StripeCheckoutSessionStatusDocument, options);
        }
export type StripeCheckoutSessionStatusQueryHookResult = ReturnType<typeof useStripeCheckoutSessionStatusQuery>;
export type StripeCheckoutSessionStatusLazyQueryHookResult = ReturnType<typeof useStripeCheckoutSessionStatusLazyQuery>;
export type StripeCheckoutSessionStatusQueryResult = Apollo.QueryResult<StripeCheckoutSessionStatusQuery, StripeCheckoutSessionStatusQueryVariables>;
export const UserMeDocument = gql`
    query userMe {
  me {
    id
    ...user_fragment
    settings {
      ...user_settings_fragment
    }
  }
  monthlyScore {
    id
    points
  }
  contentAvailable
  featureFlags {
    id
    name
    enabled
  }
  joinedClassRooms
}
    ${User_FragmentFragmentDoc}
${User_Settings_FragmentFragmentDoc}`;

/**
 * __useUserMeQuery__
 *
 * To run a query within a React component, call `useUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMeQuery(baseOptions?: Apollo.QueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
      }
export function useUserMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
        }
export type UserMeQueryHookResult = ReturnType<typeof useUserMeQuery>;
export type UserMeLazyQueryHookResult = ReturnType<typeof useUserMeLazyQuery>;
export type UserMeQueryResult = Apollo.QueryResult<UserMeQuery, UserMeQueryVariables>;
export const DtWeeklyProgressDocument = gql`
    query dtWeeklyProgress {
  me {
    id
    dailytipper {
      id
      dailyStatus
      totalProgress
      nextAchievement {
        id
        learningDays
      }
      currentAchievement {
        id
        learningDays
      }
      yearAchievement {
        id
        yearNumber
      }
    }
  }
  dailyTipperWeeklyProgress {
    id
    weeklyGoal
    completedDays
    correctAnswersCount
    wrongAnswersCount
    weekNumber
  }
}
    `;

/**
 * __useDtWeeklyProgressQuery__
 *
 * To run a query within a React component, call `useDtWeeklyProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useDtWeeklyProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDtWeeklyProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useDtWeeklyProgressQuery(baseOptions?: Apollo.QueryHookOptions<DtWeeklyProgressQuery, DtWeeklyProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DtWeeklyProgressQuery, DtWeeklyProgressQueryVariables>(DtWeeklyProgressDocument, options);
      }
export function useDtWeeklyProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DtWeeklyProgressQuery, DtWeeklyProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DtWeeklyProgressQuery, DtWeeklyProgressQueryVariables>(DtWeeklyProgressDocument, options);
        }
export type DtWeeklyProgressQueryHookResult = ReturnType<typeof useDtWeeklyProgressQuery>;
export type DtWeeklyProgressLazyQueryHookResult = ReturnType<typeof useDtWeeklyProgressLazyQuery>;
export type DtWeeklyProgressQueryResult = Apollo.QueryResult<DtWeeklyProgressQuery, DtWeeklyProgressQueryVariables>;
export const GetActiveDuelsDocument = gql`
    query getActiveDuels {
  activeDuels {
    id
    opponent {
      id
      avatar
      username
    }
    round {
      id
      roundNumber
      created
      duel {
        id
        status
      }
      userQuestions {
        id
        questionNumber
        user {
          id
        }
        question {
          id
          value
        }
        userAnswer {
          id
          value
        }
      }
    }
    youTurn
    isInitiator
    session {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
  startedDuelsToday
}
    `;

/**
 * __useGetActiveDuelsQuery__
 *
 * To run a query within a React component, call `useGetActiveDuelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDuelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDuelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveDuelsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveDuelsQuery, GetActiveDuelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveDuelsQuery, GetActiveDuelsQueryVariables>(GetActiveDuelsDocument, options);
      }
export function useGetActiveDuelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveDuelsQuery, GetActiveDuelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveDuelsQuery, GetActiveDuelsQueryVariables>(GetActiveDuelsDocument, options);
        }
export type GetActiveDuelsQueryHookResult = ReturnType<typeof useGetActiveDuelsQuery>;
export type GetActiveDuelsLazyQueryHookResult = ReturnType<typeof useGetActiveDuelsLazyQuery>;
export type GetActiveDuelsQueryResult = Apollo.QueryResult<GetActiveDuelsQuery, GetActiveDuelsQueryVariables>;
export const GetOngoingDuelsDocument = gql`
    query getOngoingDuels {
  activeDuels {
    id
    opponent {
      id
      avatar
      username
    }
    round {
      id
      roundNumber
      created
      duel {
        id
        status
      }
      userQuestions {
        id
        questionNumber
        user {
          id
        }
        userAnswer {
          id
          value
        }
      }
    }
    youTurn
    isInitiator
    session {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
  monthlyScore {
    id
    duels
    wins
    loss
    ties
    points
  }
  startedDuelsToday
}
    `;

/**
 * __useGetOngoingDuelsQuery__
 *
 * To run a query within a React component, call `useGetOngoingDuelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOngoingDuelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOngoingDuelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOngoingDuelsQuery(baseOptions?: Apollo.QueryHookOptions<GetOngoingDuelsQuery, GetOngoingDuelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOngoingDuelsQuery, GetOngoingDuelsQueryVariables>(GetOngoingDuelsDocument, options);
      }
export function useGetOngoingDuelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOngoingDuelsQuery, GetOngoingDuelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOngoingDuelsQuery, GetOngoingDuelsQueryVariables>(GetOngoingDuelsDocument, options);
        }
export type GetOngoingDuelsQueryHookResult = ReturnType<typeof useGetOngoingDuelsQuery>;
export type GetOngoingDuelsLazyQueryHookResult = ReturnType<typeof useGetOngoingDuelsLazyQuery>;
export type GetOngoingDuelsQueryResult = Apollo.QueryResult<GetOngoingDuelsQuery, GetOngoingDuelsQueryVariables>;
export const GetCompletedDuelsDocument = gql`
    query getCompletedDuels {
  completedDuels {
    id
    userDuelsData {
      ...user_score_fragment
      duel {
        id
        updated
        status
        isOnboardingDuel
      }
    }
    opponentDuelsData {
      ...user_score_fragment
    }
    session {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
}
    ${User_Score_FragmentFragmentDoc}`;

/**
 * __useGetCompletedDuelsQuery__
 *
 * To run a query within a React component, call `useGetCompletedDuelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedDuelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedDuelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompletedDuelsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompletedDuelsQuery, GetCompletedDuelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedDuelsQuery, GetCompletedDuelsQueryVariables>(GetCompletedDuelsDocument, options);
      }
export function useGetCompletedDuelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedDuelsQuery, GetCompletedDuelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedDuelsQuery, GetCompletedDuelsQueryVariables>(GetCompletedDuelsDocument, options);
        }
export type GetCompletedDuelsQueryHookResult = ReturnType<typeof useGetCompletedDuelsQuery>;
export type GetCompletedDuelsLazyQueryHookResult = ReturnType<typeof useGetCompletedDuelsLazyQuery>;
export type GetCompletedDuelsQueryResult = Apollo.QueryResult<GetCompletedDuelsQuery, GetCompletedDuelsQueryVariables>;
export const GetDuelsRankingDocument = gql`
    query getDuelsRanking {
  ranking {
    id
    user {
      id
      avatar
      username
    }
    points
    rank
  }
  topUsers {
    id
    user {
      id
      avatar
      username
    }
    points
    rank
  }
}
    `;

/**
 * __useGetDuelsRankingQuery__
 *
 * To run a query within a React component, call `useGetDuelsRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuelsRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuelsRankingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDuelsRankingQuery(baseOptions?: Apollo.QueryHookOptions<GetDuelsRankingQuery, GetDuelsRankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuelsRankingQuery, GetDuelsRankingQueryVariables>(GetDuelsRankingDocument, options);
      }
export function useGetDuelsRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuelsRankingQuery, GetDuelsRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuelsRankingQuery, GetDuelsRankingQueryVariables>(GetDuelsRankingDocument, options);
        }
export type GetDuelsRankingQueryHookResult = ReturnType<typeof useGetDuelsRankingQuery>;
export type GetDuelsRankingLazyQueryHookResult = ReturnType<typeof useGetDuelsRankingLazyQuery>;
export type GetDuelsRankingQueryResult = Apollo.QueryResult<GetDuelsRankingQuery, GetDuelsRankingQueryVariables>;
export const GetDuelsDocument = gql`
    query getDuels {
  activeDuels {
    id
    opponent {
      id
      avatar
      username
    }
    round {
      id
      roundNumber
      created
      duel {
        id
        status
      }
      userQuestions {
        id
        questionNumber
        user {
          id
        }
        userAnswer {
          id
          value
        }
      }
    }
    youTurn
    session {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
  startedDuelsToday
  completedDuels {
    id
    userDuelsData {
      ...user_score_fragment
      duel {
        id
        updated
        status
      }
    }
    opponentDuelsData {
      ...user_score_fragment
    }
    session {
      id
      classRoom {
        id
        enrollmentType
      }
    }
  }
  ranking {
    id
    user {
      id
      avatar
      username
    }
    points
    rank
  }
  topUsers {
    id
    user {
      id
      avatar
      username
    }
    points
    rank
  }
  monthlyScore {
    id
    duels
    wins
    loss
    ties
    points
  }
}
    ${User_Score_FragmentFragmentDoc}`;

/**
 * __useGetDuelsQuery__
 *
 * To run a query within a React component, call `useGetDuelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDuelsQuery(baseOptions?: Apollo.QueryHookOptions<GetDuelsQuery, GetDuelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuelsQuery, GetDuelsQueryVariables>(GetDuelsDocument, options);
      }
export function useGetDuelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuelsQuery, GetDuelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuelsQuery, GetDuelsQueryVariables>(GetDuelsDocument, options);
        }
export type GetDuelsQueryHookResult = ReturnType<typeof useGetDuelsQuery>;
export type GetDuelsLazyQueryHookResult = ReturnType<typeof useGetDuelsLazyQuery>;
export type GetDuelsQueryResult = Apollo.QueryResult<GetDuelsQuery, GetDuelsQueryVariables>;
export const UserDuelDocument = gql`
    query userDuel($duelId: UUID!) {
  duelData(duelId: $duelId) {
    id
    status
    opponentScore {
      ...user_score_fragment
    }
    userScore {
      ...user_score_fragment
    }
    rounds {
      id
      created
      roundNumber
      userQuestions {
        ...user_question_fragment
      }
    }
    session {
      id
      classRoom {
        id
        title
      }
    }
    isOnboardingDuel
  }
}
    ${User_Score_FragmentFragmentDoc}
${User_Question_FragmentFragmentDoc}`;

/**
 * __useUserDuelQuery__
 *
 * To run a query within a React component, call `useUserDuelQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDuelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDuelQuery({
 *   variables: {
 *      duelId: // value for 'duelId'
 *   },
 * });
 */
export function useUserDuelQuery(baseOptions: Apollo.QueryHookOptions<UserDuelQuery, UserDuelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDuelQuery, UserDuelQueryVariables>(UserDuelDocument, options);
      }
export function useUserDuelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDuelQuery, UserDuelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDuelQuery, UserDuelQueryVariables>(UserDuelDocument, options);
        }
export type UserDuelQueryHookResult = ReturnType<typeof useUserDuelQuery>;
export type UserDuelLazyQueryHookResult = ReturnType<typeof useUserDuelLazyQuery>;
export type UserDuelQueryResult = Apollo.QueryResult<UserDuelQuery, UserDuelQueryVariables>;
export const SubscribeNotificationCreatedDocument = gql`
    subscription subscribeNotificationCreated {
  notificationCreated {
    id
    updated
    created
    data
    message
    isRead
  }
}
    `;

/**
 * __useSubscribeNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useSubscribeNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeNotificationCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeNotificationCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeNotificationCreatedSubscription, SubscribeNotificationCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeNotificationCreatedSubscription, SubscribeNotificationCreatedSubscriptionVariables>(SubscribeNotificationCreatedDocument, options);
      }
export type SubscribeNotificationCreatedSubscriptionHookResult = ReturnType<typeof useSubscribeNotificationCreatedSubscription>;
export type SubscribeNotificationCreatedSubscriptionResult = Apollo.SubscriptionResult<SubscribeNotificationCreatedSubscription>;
export const UserNotificationsDocument = gql`
    query userNotifications {
  notifications {
    id
    created
    updated
    data
    message
    isRead
  }
}
    `;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const LastUserNotificationDocument = gql`
    query lastUserNotification {
  lastNotification {
    id
    updated
    created
    data
    message
    isRead
  }
}
    `;

/**
 * __useLastUserNotificationQuery__
 *
 * To run a query within a React component, call `useLastUserNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastUserNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastUserNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastUserNotificationQuery(baseOptions?: Apollo.QueryHookOptions<LastUserNotificationQuery, LastUserNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastUserNotificationQuery, LastUserNotificationQueryVariables>(LastUserNotificationDocument, options);
      }
export function useLastUserNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastUserNotificationQuery, LastUserNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastUserNotificationQuery, LastUserNotificationQueryVariables>(LastUserNotificationDocument, options);
        }
export type LastUserNotificationQueryHookResult = ReturnType<typeof useLastUserNotificationQuery>;
export type LastUserNotificationLazyQueryHookResult = ReturnType<typeof useLastUserNotificationLazyQuery>;
export type LastUserNotificationQueryResult = Apollo.QueryResult<LastUserNotificationQuery, LastUserNotificationQueryVariables>;
export const UserNetworkCodesDocument = gql`
    query userNetworkCodes {
  codes {
    id
    startDate
    finishDate
    sponsor {
      id
      title
      text
      website
      email
      logo
    }
    codeMode
  }
}
    `;

/**
 * __useUserNetworkCodesQuery__
 *
 * To run a query within a React component, call `useUserNetworkCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNetworkCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNetworkCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNetworkCodesQuery(baseOptions?: Apollo.QueryHookOptions<UserNetworkCodesQuery, UserNetworkCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNetworkCodesQuery, UserNetworkCodesQueryVariables>(UserNetworkCodesDocument, options);
      }
export function useUserNetworkCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNetworkCodesQuery, UserNetworkCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNetworkCodesQuery, UserNetworkCodesQueryVariables>(UserNetworkCodesDocument, options);
        }
export type UserNetworkCodesQueryHookResult = ReturnType<typeof useUserNetworkCodesQuery>;
export type UserNetworkCodesLazyQueryHookResult = ReturnType<typeof useUserNetworkCodesLazyQuery>;
export type UserNetworkCodesQueryResult = Apollo.QueryResult<UserNetworkCodesQuery, UserNetworkCodesQueryVariables>;
export const UsernameVerifyDocument = gql`
    query usernameVerify($username: String!) {
  usernameVerify(username: $username)
}
    `;

/**
 * __useUsernameVerifyQuery__
 *
 * To run a query within a React component, call `useUsernameVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsernameVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsernameVerifyQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUsernameVerifyQuery(baseOptions: Apollo.QueryHookOptions<UsernameVerifyQuery, UsernameVerifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsernameVerifyQuery, UsernameVerifyQueryVariables>(UsernameVerifyDocument, options);
      }
export function useUsernameVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsernameVerifyQuery, UsernameVerifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsernameVerifyQuery, UsernameVerifyQueryVariables>(UsernameVerifyDocument, options);
        }
export type UsernameVerifyQueryHookResult = ReturnType<typeof useUsernameVerifyQuery>;
export type UsernameVerifyLazyQueryHookResult = ReturnType<typeof useUsernameVerifyLazyQuery>;
export type UsernameVerifyQueryResult = Apollo.QueryResult<UsernameVerifyQuery, UsernameVerifyQueryVariables>;
export const EmailVerifyDocument = gql`
    query emailVerify($email: String!) {
  emailVerify(email: $email)
}
    `;

/**
 * __useEmailVerifyQuery__
 *
 * To run a query within a React component, call `useEmailVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailVerifyQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailVerifyQuery(baseOptions: Apollo.QueryHookOptions<EmailVerifyQuery, EmailVerifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailVerifyQuery, EmailVerifyQueryVariables>(EmailVerifyDocument, options);
      }
export function useEmailVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailVerifyQuery, EmailVerifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailVerifyQuery, EmailVerifyQueryVariables>(EmailVerifyDocument, options);
        }
export type EmailVerifyQueryHookResult = ReturnType<typeof useEmailVerifyQuery>;
export type EmailVerifyLazyQueryHookResult = ReturnType<typeof useEmailVerifyLazyQuery>;
export type EmailVerifyQueryResult = Apollo.QueryResult<EmailVerifyQuery, EmailVerifyQueryVariables>;
export const EfnNumberVerifyDocument = gql`
    query efnNumberVerify($efnNumber: String!) {
  efnNumberVerify(efnNumber: $efnNumber)
}
    `;

/**
 * __useEfnNumberVerifyQuery__
 *
 * To run a query within a React component, call `useEfnNumberVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEfnNumberVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEfnNumberVerifyQuery({
 *   variables: {
 *      efnNumber: // value for 'efnNumber'
 *   },
 * });
 */
export function useEfnNumberVerifyQuery(baseOptions: Apollo.QueryHookOptions<EfnNumberVerifyQuery, EfnNumberVerifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EfnNumberVerifyQuery, EfnNumberVerifyQueryVariables>(EfnNumberVerifyDocument, options);
      }
export function useEfnNumberVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EfnNumberVerifyQuery, EfnNumberVerifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EfnNumberVerifyQuery, EfnNumberVerifyQueryVariables>(EfnNumberVerifyDocument, options);
        }
export type EfnNumberVerifyQueryHookResult = ReturnType<typeof useEfnNumberVerifyQuery>;
export type EfnNumberVerifyLazyQueryHookResult = ReturnType<typeof useEfnNumberVerifyLazyQuery>;
export type EfnNumberVerifyQueryResult = Apollo.QueryResult<EfnNumberVerifyQuery, EfnNumberVerifyQueryVariables>;
export const AllProfessionsDocument = gql`
    query allProfessions {
  professions {
    id
    title
    type {
      id
      type
    }
  }
}
    `;

/**
 * __useAllProfessionsQuery__
 *
 * To run a query within a React component, call `useAllProfessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProfessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProfessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProfessionsQuery(baseOptions?: Apollo.QueryHookOptions<AllProfessionsQuery, AllProfessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProfessionsQuery, AllProfessionsQueryVariables>(AllProfessionsDocument, options);
      }
export function useAllProfessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProfessionsQuery, AllProfessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProfessionsQuery, AllProfessionsQueryVariables>(AllProfessionsDocument, options);
        }
export type AllProfessionsQueryHookResult = ReturnType<typeof useAllProfessionsQuery>;
export type AllProfessionsLazyQueryHookResult = ReturnType<typeof useAllProfessionsLazyQuery>;
export type AllProfessionsQueryResult = Apollo.QueryResult<AllProfessionsQuery, AllProfessionsQueryVariables>;
export const AnotherDataDocument = gql`
    query anotherData($professionType: Int!) {
  specialitiesByType(professionType: $professionType) {
    id
    title
  }
}
    `;

/**
 * __useAnotherDataQuery__
 *
 * To run a query within a React component, call `useAnotherDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnotherDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnotherDataQuery({
 *   variables: {
 *      professionType: // value for 'professionType'
 *   },
 * });
 */
export function useAnotherDataQuery(baseOptions: Apollo.QueryHookOptions<AnotherDataQuery, AnotherDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnotherDataQuery, AnotherDataQueryVariables>(AnotherDataDocument, options);
      }
export function useAnotherDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnotherDataQuery, AnotherDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnotherDataQuery, AnotherDataQueryVariables>(AnotherDataDocument, options);
        }
export type AnotherDataQueryHookResult = ReturnType<typeof useAnotherDataQuery>;
export type AnotherDataLazyQueryHookResult = ReturnType<typeof useAnotherDataLazyQuery>;
export type AnotherDataQueryResult = Apollo.QueryResult<AnotherDataQuery, AnotherDataQueryVariables>;
export const DoctorDataDocument = gql`
    query doctorData($professionType: Int!) {
  specialitiesByType(professionType: $professionType) {
    id
    title
  }
  workplaces(professionType: $professionType) {
    id
    title
  }
}
    `;

/**
 * __useDoctorDataQuery__
 *
 * To run a query within a React component, call `useDoctorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorDataQuery({
 *   variables: {
 *      professionType: // value for 'professionType'
 *   },
 * });
 */
export function useDoctorDataQuery(baseOptions: Apollo.QueryHookOptions<DoctorDataQuery, DoctorDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorDataQuery, DoctorDataQueryVariables>(DoctorDataDocument, options);
      }
export function useDoctorDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorDataQuery, DoctorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorDataQuery, DoctorDataQueryVariables>(DoctorDataDocument, options);
        }
export type DoctorDataQueryHookResult = ReturnType<typeof useDoctorDataQuery>;
export type DoctorDataLazyQueryHookResult = ReturnType<typeof useDoctorDataLazyQuery>;
export type DoctorDataQueryResult = Apollo.QueryResult<DoctorDataQuery, DoctorDataQueryVariables>;
export const MedicalAssistantDataDocument = gql`
    query medicalAssistantData($professionType: Int!) {
  professions {
    id
    title
  }
  specialitiesByType(professionType: $professionType) {
    id
    title
  }
  workplaces(professionType: $professionType) {
    id
    title
  }
}
    `;

/**
 * __useMedicalAssistantDataQuery__
 *
 * To run a query within a React component, call `useMedicalAssistantDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalAssistantDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalAssistantDataQuery({
 *   variables: {
 *      professionType: // value for 'professionType'
 *   },
 * });
 */
export function useMedicalAssistantDataQuery(baseOptions: Apollo.QueryHookOptions<MedicalAssistantDataQuery, MedicalAssistantDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicalAssistantDataQuery, MedicalAssistantDataQueryVariables>(MedicalAssistantDataDocument, options);
      }
export function useMedicalAssistantDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalAssistantDataQuery, MedicalAssistantDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicalAssistantDataQuery, MedicalAssistantDataQueryVariables>(MedicalAssistantDataDocument, options);
        }
export type MedicalAssistantDataQueryHookResult = ReturnType<typeof useMedicalAssistantDataQuery>;
export type MedicalAssistantDataLazyQueryHookResult = ReturnType<typeof useMedicalAssistantDataLazyQuery>;
export type MedicalAssistantDataQueryResult = Apollo.QueryResult<MedicalAssistantDataQuery, MedicalAssistantDataQueryVariables>;
export const MedicalAssistantTraineeDataDocument = gql`
    query medicalAssistantTraineeData($professionType: Int!) {
  workplaces(professionType: $professionType) {
    id
    title
  }
  studyYears {
    id
    title
  }
}
    `;

/**
 * __useMedicalAssistantTraineeDataQuery__
 *
 * To run a query within a React component, call `useMedicalAssistantTraineeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalAssistantTraineeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalAssistantTraineeDataQuery({
 *   variables: {
 *      professionType: // value for 'professionType'
 *   },
 * });
 */
export function useMedicalAssistantTraineeDataQuery(baseOptions: Apollo.QueryHookOptions<MedicalAssistantTraineeDataQuery, MedicalAssistantTraineeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicalAssistantTraineeDataQuery, MedicalAssistantTraineeDataQueryVariables>(MedicalAssistantTraineeDataDocument, options);
      }
export function useMedicalAssistantTraineeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalAssistantTraineeDataQuery, MedicalAssistantTraineeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicalAssistantTraineeDataQuery, MedicalAssistantTraineeDataQueryVariables>(MedicalAssistantTraineeDataDocument, options);
        }
export type MedicalAssistantTraineeDataQueryHookResult = ReturnType<typeof useMedicalAssistantTraineeDataQuery>;
export type MedicalAssistantTraineeDataLazyQueryHookResult = ReturnType<typeof useMedicalAssistantTraineeDataLazyQuery>;
export type MedicalAssistantTraineeDataQueryResult = Apollo.QueryResult<MedicalAssistantTraineeDataQuery, MedicalAssistantTraineeDataQueryVariables>;
export const StudentDataDocument = gql`
    query studentData {
  semesters {
    id
    title
  }
  universities {
    id
    title
  }
  studySemesters {
    id
    title
  }
}
    `;

/**
 * __useStudentDataQuery__
 *
 * To run a query within a React component, call `useStudentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentDataQuery(baseOptions?: Apollo.QueryHookOptions<StudentDataQuery, StudentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDataQuery, StudentDataQueryVariables>(StudentDataDocument, options);
      }
export function useStudentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDataQuery, StudentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDataQuery, StudentDataQueryVariables>(StudentDataDocument, options);
        }
export type StudentDataQueryHookResult = ReturnType<typeof useStudentDataQuery>;
export type StudentDataLazyQueryHookResult = ReturnType<typeof useStudentDataLazyQuery>;
export type StudentDataQueryResult = Apollo.QueryResult<StudentDataQuery, StudentDataQueryVariables>;
export const TraineeDataDocument = gql`
    query traineeData($professionType: Int!) {
  workplaces(professionType: $professionType) {
    id
    title
  }
  educationLevels {
    id
    title
  }
}
    `;

/**
 * __useTraineeDataQuery__
 *
 * To run a query within a React component, call `useTraineeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTraineeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTraineeDataQuery({
 *   variables: {
 *      professionType: // value for 'professionType'
 *   },
 * });
 */
export function useTraineeDataQuery(baseOptions: Apollo.QueryHookOptions<TraineeDataQuery, TraineeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TraineeDataQuery, TraineeDataQueryVariables>(TraineeDataDocument, options);
      }
export function useTraineeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TraineeDataQuery, TraineeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TraineeDataQuery, TraineeDataQueryVariables>(TraineeDataDocument, options);
        }
export type TraineeDataQueryHookResult = ReturnType<typeof useTraineeDataQuery>;
export type TraineeDataLazyQueryHookResult = ReturnType<typeof useTraineeDataLazyQuery>;
export type TraineeDataQueryResult = Apollo.QueryResult<TraineeDataQuery, TraineeDataQueryVariables>;
export const TodayDailyTipperDocument = gql`
    query todayDailyTipper {
  dailyTipperData {
    dailyTipperQuestions {
      ...daily_tipper_question_fragment
    }
  }
}
    ${Daily_Tipper_Question_FragmentFragmentDoc}`;

/**
 * __useTodayDailyTipperQuery__
 *
 * To run a query within a React component, call `useTodayDailyTipperQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodayDailyTipperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodayDailyTipperQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodayDailyTipperQuery(baseOptions?: Apollo.QueryHookOptions<TodayDailyTipperQuery, TodayDailyTipperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodayDailyTipperQuery, TodayDailyTipperQueryVariables>(TodayDailyTipperDocument, options);
      }
export function useTodayDailyTipperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodayDailyTipperQuery, TodayDailyTipperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodayDailyTipperQuery, TodayDailyTipperQueryVariables>(TodayDailyTipperDocument, options);
        }
export type TodayDailyTipperQueryHookResult = ReturnType<typeof useTodayDailyTipperQuery>;
export type TodayDailyTipperLazyQueryHookResult = ReturnType<typeof useTodayDailyTipperLazyQuery>;
export type TodayDailyTipperQueryResult = Apollo.QueryResult<TodayDailyTipperQuery, TodayDailyTipperQueryVariables>;
export const OnboardingQuestionsDocument = gql`
    query onboardingQuestions {
  onboardingQuestions {
    id
    value
    questionImage
    explanation
    sortedLinks {
      id
      url
      linkCategory {
        id
        title
      }
    }
    answers {
      id
      value
      isCorrect
    }
  }
}
    `;

/**
 * __useOnboardingQuestionsQuery__
 *
 * To run a query within a React component, call `useOnboardingQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingQuestionsQuery, OnboardingQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingQuestionsQuery, OnboardingQuestionsQueryVariables>(OnboardingQuestionsDocument, options);
      }
export function useOnboardingQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingQuestionsQuery, OnboardingQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingQuestionsQuery, OnboardingQuestionsQueryVariables>(OnboardingQuestionsDocument, options);
        }
export type OnboardingQuestionsQueryHookResult = ReturnType<typeof useOnboardingQuestionsQuery>;
export type OnboardingQuestionsLazyQueryHookResult = ReturnType<typeof useOnboardingQuestionsLazyQuery>;
export type OnboardingQuestionsQueryResult = Apollo.QueryResult<OnboardingQuestionsQuery, OnboardingQuestionsQueryVariables>;
export const DailyTipperDataDocument = gql`
    query dailyTipperData {
  dailyTipperData {
    dailyResultStatus
    currentAchievement
    daysLost
    dailyTipperQuestions {
      ...daily_tipper_question_fragment
    }
  }
}
    ${Daily_Tipper_Question_FragmentFragmentDoc}`;

/**
 * __useDailyTipperDataQuery__
 *
 * To run a query within a React component, call `useDailyTipperDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyTipperDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyTipperDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDailyTipperDataQuery(baseOptions?: Apollo.QueryHookOptions<DailyTipperDataQuery, DailyTipperDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyTipperDataQuery, DailyTipperDataQueryVariables>(DailyTipperDataDocument, options);
      }
export function useDailyTipperDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyTipperDataQuery, DailyTipperDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyTipperDataQuery, DailyTipperDataQueryVariables>(DailyTipperDataDocument, options);
        }
export type DailyTipperDataQueryHookResult = ReturnType<typeof useDailyTipperDataQuery>;
export type DailyTipperDataLazyQueryHookResult = ReturnType<typeof useDailyTipperDataLazyQuery>;
export type DailyTipperDataQueryResult = Apollo.QueryResult<DailyTipperDataQuery, DailyTipperDataQueryVariables>;
export const UpdateDtDayslostDocument = gql`
    query updateDtDayslost {
  dailyTipperData {
    daysLost
  }
}
    `;

/**
 * __useUpdateDtDayslostQuery__
 *
 * To run a query within a React component, call `useUpdateDtDayslostQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateDtDayslostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateDtDayslostQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateDtDayslostQuery(baseOptions?: Apollo.QueryHookOptions<UpdateDtDayslostQuery, UpdateDtDayslostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateDtDayslostQuery, UpdateDtDayslostQueryVariables>(UpdateDtDayslostDocument, options);
      }
export function useUpdateDtDayslostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateDtDayslostQuery, UpdateDtDayslostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateDtDayslostQuery, UpdateDtDayslostQueryVariables>(UpdateDtDayslostDocument, options);
        }
export type UpdateDtDayslostQueryHookResult = ReturnType<typeof useUpdateDtDayslostQuery>;
export type UpdateDtDayslostLazyQueryHookResult = ReturnType<typeof useUpdateDtDayslostLazyQuery>;
export type UpdateDtDayslostQueryResult = Apollo.QueryResult<UpdateDtDayslostQuery, UpdateDtDayslostQueryVariables>;
export const UserAchievementsRangDocument = gql`
    query userAchievementsRang {
  achievementsRang(showedInRankUsers: 3) {
    achievement {
      id
      learningDays
    }
    usersWithAchievementCount
    usersWithAchievement {
      id
      user {
        avatar
        username
      }
    }
  }
}
    `;

/**
 * __useUserAchievementsRangQuery__
 *
 * To run a query within a React component, call `useUserAchievementsRangQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAchievementsRangQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAchievementsRangQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAchievementsRangQuery(baseOptions?: Apollo.QueryHookOptions<UserAchievementsRangQuery, UserAchievementsRangQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAchievementsRangQuery, UserAchievementsRangQueryVariables>(UserAchievementsRangDocument, options);
      }
export function useUserAchievementsRangLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAchievementsRangQuery, UserAchievementsRangQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAchievementsRangQuery, UserAchievementsRangQueryVariables>(UserAchievementsRangDocument, options);
        }
export type UserAchievementsRangQueryHookResult = ReturnType<typeof useUserAchievementsRangQuery>;
export type UserAchievementsRangLazyQueryHookResult = ReturnType<typeof useUserAchievementsRangLazyQuery>;
export type UserAchievementsRangQueryResult = Apollo.QueryResult<UserAchievementsRangQuery, UserAchievementsRangQueryVariables>;
export const ClassRoomsAvailableDocument = gql`
    query classRoomsAvailable($isNetworkType: Boolean) {
  availableClassRooms(isNetworkType: $isNetworkType) {
    ...classroom_ls_fragment
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useClassRoomsAvailableQuery__
 *
 * To run a query within a React component, call `useClassRoomsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomsAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomsAvailableQuery({
 *   variables: {
 *      isNetworkType: // value for 'isNetworkType'
 *   },
 * });
 */
export function useClassRoomsAvailableQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomsAvailableQuery, ClassRoomsAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomsAvailableQuery, ClassRoomsAvailableQueryVariables>(ClassRoomsAvailableDocument, options);
      }
export function useClassRoomsAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomsAvailableQuery, ClassRoomsAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomsAvailableQuery, ClassRoomsAvailableQueryVariables>(ClassRoomsAvailableDocument, options);
        }
export type ClassRoomsAvailableQueryHookResult = ReturnType<typeof useClassRoomsAvailableQuery>;
export type ClassRoomsAvailableLazyQueryHookResult = ReturnType<typeof useClassRoomsAvailableLazyQuery>;
export type ClassRoomsAvailableQueryResult = Apollo.QueryResult<ClassRoomsAvailableQuery, ClassRoomsAvailableQueryVariables>;
export const ClassRoomsOngoingDocument = gql`
    query classRoomsOngoing {
  ongoingClassRooms {
    isSessionActive
    correctAnswersGoal
    questionsAmount
    correctAnswersAmount
    networkStartDate
    learningSession {
      ...classroom_ls_fragment
      deepLink
    }
    specialityGroupIcon
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useClassRoomsOngoingQuery__
 *
 * To run a query within a React component, call `useClassRoomsOngoingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomsOngoingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomsOngoingQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassRoomsOngoingQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomsOngoingQuery, ClassRoomsOngoingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomsOngoingQuery, ClassRoomsOngoingQueryVariables>(ClassRoomsOngoingDocument, options);
      }
export function useClassRoomsOngoingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomsOngoingQuery, ClassRoomsOngoingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomsOngoingQuery, ClassRoomsOngoingQueryVariables>(ClassRoomsOngoingDocument, options);
        }
export type ClassRoomsOngoingQueryHookResult = ReturnType<typeof useClassRoomsOngoingQuery>;
export type ClassRoomsOngoingLazyQueryHookResult = ReturnType<typeof useClassRoomsOngoingLazyQuery>;
export type ClassRoomsOngoingQueryResult = Apollo.QueryResult<ClassRoomsOngoingQuery, ClassRoomsOngoingQueryVariables>;
export const OnboardingCrSessionDocument = gql`
    query onboardingCrSession {
  onboardingSession {
    ...classroom_ls_fragment
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useOnboardingCrSessionQuery__
 *
 * To run a query within a React component, call `useOnboardingCrSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCrSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingCrSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingCrSessionQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingCrSessionQuery, OnboardingCrSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingCrSessionQuery, OnboardingCrSessionQueryVariables>(OnboardingCrSessionDocument, options);
      }
export function useOnboardingCrSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingCrSessionQuery, OnboardingCrSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingCrSessionQuery, OnboardingCrSessionQueryVariables>(OnboardingCrSessionDocument, options);
        }
export type OnboardingCrSessionQueryHookResult = ReturnType<typeof useOnboardingCrSessionQuery>;
export type OnboardingCrSessionLazyQueryHookResult = ReturnType<typeof useOnboardingCrSessionLazyQuery>;
export type OnboardingCrSessionQueryResult = Apollo.QueryResult<OnboardingCrSessionQuery, OnboardingCrSessionQueryVariables>;
export const ClassRoomsAvailableBySpecialityGroupDocument = gql`
    query classRoomsAvailableBySpecialityGroup($specialityGroupId: UUID) {
  availableSessionsBySpecialityGroup(specialityGroupId: $specialityGroupId) {
    ...classroom_ls_fragment
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useClassRoomsAvailableBySpecialityGroupQuery__
 *
 * To run a query within a React component, call `useClassRoomsAvailableBySpecialityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomsAvailableBySpecialityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomsAvailableBySpecialityGroupQuery({
 *   variables: {
 *      specialityGroupId: // value for 'specialityGroupId'
 *   },
 * });
 */
export function useClassRoomsAvailableBySpecialityGroupQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomsAvailableBySpecialityGroupQuery, ClassRoomsAvailableBySpecialityGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomsAvailableBySpecialityGroupQuery, ClassRoomsAvailableBySpecialityGroupQueryVariables>(ClassRoomsAvailableBySpecialityGroupDocument, options);
      }
export function useClassRoomsAvailableBySpecialityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomsAvailableBySpecialityGroupQuery, ClassRoomsAvailableBySpecialityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomsAvailableBySpecialityGroupQuery, ClassRoomsAvailableBySpecialityGroupQueryVariables>(ClassRoomsAvailableBySpecialityGroupDocument, options);
        }
export type ClassRoomsAvailableBySpecialityGroupQueryHookResult = ReturnType<typeof useClassRoomsAvailableBySpecialityGroupQuery>;
export type ClassRoomsAvailableBySpecialityGroupLazyQueryHookResult = ReturnType<typeof useClassRoomsAvailableBySpecialityGroupLazyQuery>;
export type ClassRoomsAvailableBySpecialityGroupQueryResult = Apollo.QueryResult<ClassRoomsAvailableBySpecialityGroupQuery, ClassRoomsAvailableBySpecialityGroupQueryVariables>;
export const ClassRoomsFinishedDocument = gql`
    query classRoomsFinished {
  finishedClassRooms {
    correctAnswersGoal
    questionsAmount
    correctAnswersAmount
    networkStartDate
    outViaSubscriptionDate
    specialityGroupIcon
    userLearningSessionSettingsId
    learningSession {
      ...classroom_ls_fragment
    }
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useClassRoomsFinishedQuery__
 *
 * To run a query within a React component, call `useClassRoomsFinishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomsFinishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomsFinishedQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassRoomsFinishedQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomsFinishedQuery, ClassRoomsFinishedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomsFinishedQuery, ClassRoomsFinishedQueryVariables>(ClassRoomsFinishedDocument, options);
      }
export function useClassRoomsFinishedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomsFinishedQuery, ClassRoomsFinishedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomsFinishedQuery, ClassRoomsFinishedQueryVariables>(ClassRoomsFinishedDocument, options);
        }
export type ClassRoomsFinishedQueryHookResult = ReturnType<typeof useClassRoomsFinishedQuery>;
export type ClassRoomsFinishedLazyQueryHookResult = ReturnType<typeof useClassRoomsFinishedLazyQuery>;
export type ClassRoomsFinishedQueryResult = Apollo.QueryResult<ClassRoomsFinishedQuery, ClassRoomsFinishedQueryVariables>;
export const FindClassRoomsDocument = gql`
    query findClassRooms($searchPointer: String) {
  findClassRooms(searchPointer: $searchPointer) {
    ...classroom_ls_fragment
    specialityGroupIcon
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useFindClassRoomsQuery__
 *
 * To run a query within a React component, call `useFindClassRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindClassRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindClassRoomsQuery({
 *   variables: {
 *      searchPointer: // value for 'searchPointer'
 *   },
 * });
 */
export function useFindClassRoomsQuery(baseOptions?: Apollo.QueryHookOptions<FindClassRoomsQuery, FindClassRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindClassRoomsQuery, FindClassRoomsQueryVariables>(FindClassRoomsDocument, options);
      }
export function useFindClassRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindClassRoomsQuery, FindClassRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindClassRoomsQuery, FindClassRoomsQueryVariables>(FindClassRoomsDocument, options);
        }
export type FindClassRoomsQueryHookResult = ReturnType<typeof useFindClassRoomsQuery>;
export type FindClassRoomsLazyQueryHookResult = ReturnType<typeof useFindClassRoomsLazyQuery>;
export type FindClassRoomsQueryResult = Apollo.QueryResult<FindClassRoomsQuery, FindClassRoomsQueryVariables>;
export const SearchNetworkClassRoomSessionsDocument = gql`
    query searchNetworkClassRoomSessions($searchPointer: String) {
  searchNetworkClassRoomSessions(searchPointer: $searchPointer) {
    ...classroom_ls_fragment
    specialityGroupIcon
    isForSingle
  }
}
    ${Classroom_Ls_FragmentFragmentDoc}`;

/**
 * __useSearchNetworkClassRoomSessionsQuery__
 *
 * To run a query within a React component, call `useSearchNetworkClassRoomSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNetworkClassRoomSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNetworkClassRoomSessionsQuery({
 *   variables: {
 *      searchPointer: // value for 'searchPointer'
 *   },
 * });
 */
export function useSearchNetworkClassRoomSessionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchNetworkClassRoomSessionsQuery, SearchNetworkClassRoomSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchNetworkClassRoomSessionsQuery, SearchNetworkClassRoomSessionsQueryVariables>(SearchNetworkClassRoomSessionsDocument, options);
      }
export function useSearchNetworkClassRoomSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchNetworkClassRoomSessionsQuery, SearchNetworkClassRoomSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchNetworkClassRoomSessionsQuery, SearchNetworkClassRoomSessionsQueryVariables>(SearchNetworkClassRoomSessionsDocument, options);
        }
export type SearchNetworkClassRoomSessionsQueryHookResult = ReturnType<typeof useSearchNetworkClassRoomSessionsQuery>;
export type SearchNetworkClassRoomSessionsLazyQueryHookResult = ReturnType<typeof useSearchNetworkClassRoomSessionsLazyQuery>;
export type SearchNetworkClassRoomSessionsQueryResult = Apollo.QueryResult<SearchNetworkClassRoomSessionsQuery, SearchNetworkClassRoomSessionsQueryVariables>;
export const ClassRoomSessionDocument = gql`
    query classRoomSession($sessionId: UUID, $userSessionSettingsId: UUID) {
  classRoomLearningSession(sessionId: $sessionId) {
    id
    status
    startDate
    finishDate
    isForPremiumOnly
    duration
    specialityGroupIcon
    deepLink
    maxUserCapacity
    isOnboardingSession
    classRoom {
      id
      title
      description
      learningMoreInfoLink
      classRoomImage
      backgroundImage
      enrollmentType
      classRoomLecture {
        id
        lectureNumber
        isVisible
        lectureQuestionCount
        lectureGoal(
          learningSessionId: $sessionId
          userSessionSettingsId: $userSessionSettingsId
        )
        correctAnswerCount(
          learningSessionId: $sessionId
          userSessionSettingsId: $userSessionSettingsId
        )
        lecture {
          id
          title
        }
      }
      aggregatedRate {
        id
        averageRate
        feedbackCount
      }
      certificate {
        id
        points
        title
      }
      idNumber
      organizer {
        id
        name
        email
        logo
        linkToSite
      }
      sponsors {
        id
        title
        logo
      }
    }
  }
  lekSessionsData(learningSessionId: $sessionId) {
    id
    lekSession {
      id
      status
      finishDateTime
      startDateTime
      lek {
        id
        title
        description
        possibleAttempts
      }
    }
    userLekData {
      id
      status
      isPassed
      attemptNumber
    }
  }
}
    `;

/**
 * __useClassRoomSessionQuery__
 *
 * To run a query within a React component, call `useClassRoomSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useClassRoomSessionQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomSessionQuery, ClassRoomSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomSessionQuery, ClassRoomSessionQueryVariables>(ClassRoomSessionDocument, options);
      }
export function useClassRoomSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomSessionQuery, ClassRoomSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomSessionQuery, ClassRoomSessionQueryVariables>(ClassRoomSessionDocument, options);
        }
export type ClassRoomSessionQueryHookResult = ReturnType<typeof useClassRoomSessionQuery>;
export type ClassRoomSessionLazyQueryHookResult = ReturnType<typeof useClassRoomSessionLazyQuery>;
export type ClassRoomSessionQueryResult = Apollo.QueryResult<ClassRoomSessionQuery, ClassRoomSessionQueryVariables>;
export const ClassroomLekSessionsDocument = gql`
    query classroomLekSessions($sessionId: UUID) {
  lekSessionsData(learningSessionId: $sessionId) {
    id
    lekSession {
      id
      status
      finishDateTime
      startDateTime
    }
  }
}
    `;

/**
 * __useClassroomLekSessionsQuery__
 *
 * To run a query within a React component, call `useClassroomLekSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomLekSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomLekSessionsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useClassroomLekSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ClassroomLekSessionsQuery, ClassroomLekSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomLekSessionsQuery, ClassroomLekSessionsQueryVariables>(ClassroomLekSessionsDocument, options);
      }
export function useClassroomLekSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomLekSessionsQuery, ClassroomLekSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomLekSessionsQuery, ClassroomLekSessionsQueryVariables>(ClassroomLekSessionsDocument, options);
        }
export type ClassroomLekSessionsQueryHookResult = ReturnType<typeof useClassroomLekSessionsQuery>;
export type ClassroomLekSessionsLazyQueryHookResult = ReturnType<typeof useClassroomLekSessionsLazyQuery>;
export type ClassroomLekSessionsQueryResult = Apollo.QueryResult<ClassroomLekSessionsQuery, ClassroomLekSessionsQueryVariables>;
export const CrSessionTypeDocument = gql`
    query CRSessionType($sessionId: UUID) {
  classRoomLearningSession(sessionId: $sessionId) {
    id
    classRoom {
      id
      enrollmentType
    }
  }
}
    `;

/**
 * __useCrSessionTypeQuery__
 *
 * To run a query within a React component, call `useCrSessionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrSessionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrSessionTypeQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCrSessionTypeQuery(baseOptions?: Apollo.QueryHookOptions<CrSessionTypeQuery, CrSessionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrSessionTypeQuery, CrSessionTypeQueryVariables>(CrSessionTypeDocument, options);
      }
export function useCrSessionTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrSessionTypeQuery, CrSessionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrSessionTypeQuery, CrSessionTypeQueryVariables>(CrSessionTypeDocument, options);
        }
export type CrSessionTypeQueryHookResult = ReturnType<typeof useCrSessionTypeQuery>;
export type CrSessionTypeLazyQueryHookResult = ReturnType<typeof useCrSessionTypeLazyQuery>;
export type CrSessionTypeQueryResult = Apollo.QueryResult<CrSessionTypeQuery, CrSessionTypeQueryVariables>;
export const ClassRoomDetailsDocument = gql`
    query classRoomDetails($sessionId: UUID) {
  classRoomLearningSession(sessionId: $sessionId) {
    id
    status
    startDate
    finishDate
    isForPremiumOnly
    isForSingle
    duration
    specialityGroupIcon
    deepLink
    maxUserCapacity
    classRoom {
      id
      title
      description
      learningMoreInfoLink
      classRoomImage
      backgroundImage
      enrollmentType
      aggregatedRate {
        id
        averageRate
        feedbackCount
      }
      certificate {
        id
        points
        title
      }
      idNumber
      isExternalOrganizer
      organizer {
        id
        name
        email
        logo
        linkToSite
      }
      sponsors {
        id
        title
        logo
      }
    }
  }
}
    `;

/**
 * __useClassRoomDetailsQuery__
 *
 * To run a query within a React component, call `useClassRoomDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomDetailsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useClassRoomDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomDetailsQuery, ClassRoomDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomDetailsQuery, ClassRoomDetailsQueryVariables>(ClassRoomDetailsDocument, options);
      }
export function useClassRoomDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomDetailsQuery, ClassRoomDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomDetailsQuery, ClassRoomDetailsQueryVariables>(ClassRoomDetailsDocument, options);
        }
export type ClassRoomDetailsQueryHookResult = ReturnType<typeof useClassRoomDetailsQuery>;
export type ClassRoomDetailsLazyQueryHookResult = ReturnType<typeof useClassRoomDetailsLazyQuery>;
export type ClassRoomDetailsQueryResult = Apollo.QueryResult<ClassRoomDetailsQuery, ClassRoomDetailsQueryVariables>;
export const SpecialityGroupListDocument = gql`
    query specialityGroupList {
  userSpecialityGroupList {
    classRoomSessionCount
    specialityGroup {
      id
      name
      icon
    }
  }
}
    `;

/**
 * __useSpecialityGroupListQuery__
 *
 * To run a query within a React component, call `useSpecialityGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialityGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialityGroupListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpecialityGroupListQuery(baseOptions?: Apollo.QueryHookOptions<SpecialityGroupListQuery, SpecialityGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialityGroupListQuery, SpecialityGroupListQueryVariables>(SpecialityGroupListDocument, options);
      }
export function useSpecialityGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialityGroupListQuery, SpecialityGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialityGroupListQuery, SpecialityGroupListQueryVariables>(SpecialityGroupListDocument, options);
        }
export type SpecialityGroupListQueryHookResult = ReturnType<typeof useSpecialityGroupListQuery>;
export type SpecialityGroupListLazyQueryHookResult = ReturnType<typeof useSpecialityGroupListLazyQuery>;
export type SpecialityGroupListQueryResult = Apollo.QueryResult<SpecialityGroupListQuery, SpecialityGroupListQueryVariables>;
export const SpecialityGroupDocument = gql`
    query specialityGroup($specialityGroupId: UUID) {
  specialityGroup(specialityGroupId: $specialityGroupId) {
    id
    name
    icon
  }
}
    `;

/**
 * __useSpecialityGroupQuery__
 *
 * To run a query within a React component, call `useSpecialityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialityGroupQuery({
 *   variables: {
 *      specialityGroupId: // value for 'specialityGroupId'
 *   },
 * });
 */
export function useSpecialityGroupQuery(baseOptions?: Apollo.QueryHookOptions<SpecialityGroupQuery, SpecialityGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialityGroupQuery, SpecialityGroupQueryVariables>(SpecialityGroupDocument, options);
      }
export function useSpecialityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialityGroupQuery, SpecialityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialityGroupQuery, SpecialityGroupQueryVariables>(SpecialityGroupDocument, options);
        }
export type SpecialityGroupQueryHookResult = ReturnType<typeof useSpecialityGroupQuery>;
export type SpecialityGroupLazyQueryHookResult = ReturnType<typeof useSpecialityGroupLazyQuery>;
export type SpecialityGroupQueryResult = Apollo.QueryResult<SpecialityGroupQuery, SpecialityGroupQueryVariables>;
export const UserOnboardingSpecialityGroupsDocument = gql`
    query userOnboardingSpecialityGroups {
  userOnboardingSpecialityGroups
}
    `;

/**
 * __useUserOnboardingSpecialityGroupsQuery__
 *
 * To run a query within a React component, call `useUserOnboardingSpecialityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOnboardingSpecialityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOnboardingSpecialityGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserOnboardingSpecialityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<UserOnboardingSpecialityGroupsQuery, UserOnboardingSpecialityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserOnboardingSpecialityGroupsQuery, UserOnboardingSpecialityGroupsQueryVariables>(UserOnboardingSpecialityGroupsDocument, options);
      }
export function useUserOnboardingSpecialityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserOnboardingSpecialityGroupsQuery, UserOnboardingSpecialityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserOnboardingSpecialityGroupsQuery, UserOnboardingSpecialityGroupsQueryVariables>(UserOnboardingSpecialityGroupsDocument, options);
        }
export type UserOnboardingSpecialityGroupsQueryHookResult = ReturnType<typeof useUserOnboardingSpecialityGroupsQuery>;
export type UserOnboardingSpecialityGroupsLazyQueryHookResult = ReturnType<typeof useUserOnboardingSpecialityGroupsLazyQuery>;
export type UserOnboardingSpecialityGroupsQueryResult = Apollo.QueryResult<UserOnboardingSpecialityGroupsQuery, UserOnboardingSpecialityGroupsQueryVariables>;
export const SpecialityGroupByTypeDocument = gql`
    query specialityGroupByType($groupType: SpecialityGroupTypeEnum!) {
  specialityGroupByType(groupType: $groupType) {
    id
    name
  }
}
    `;

/**
 * __useSpecialityGroupByTypeQuery__
 *
 * To run a query within a React component, call `useSpecialityGroupByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialityGroupByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialityGroupByTypeQuery({
 *   variables: {
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useSpecialityGroupByTypeQuery(baseOptions: Apollo.QueryHookOptions<SpecialityGroupByTypeQuery, SpecialityGroupByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialityGroupByTypeQuery, SpecialityGroupByTypeQueryVariables>(SpecialityGroupByTypeDocument, options);
      }
export function useSpecialityGroupByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialityGroupByTypeQuery, SpecialityGroupByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialityGroupByTypeQuery, SpecialityGroupByTypeQueryVariables>(SpecialityGroupByTypeDocument, options);
        }
export type SpecialityGroupByTypeQueryHookResult = ReturnType<typeof useSpecialityGroupByTypeQuery>;
export type SpecialityGroupByTypeLazyQueryHookResult = ReturnType<typeof useSpecialityGroupByTypeLazyQuery>;
export type SpecialityGroupByTypeQueryResult = Apollo.QueryResult<SpecialityGroupByTypeQuery, SpecialityGroupByTypeQueryVariables>;
export const GetLekSessionDocument = gql`
    query GetLekSession($lekSessionId: UUID, $sessionId: UUID) {
  lekSession(lekSessionId: $lekSessionId) {
    id
    status
    startDateTime
    finishDateTime
    lek {
      id
      title
      lekGoal
      questionCount
      answerTimeDuration
      questions {
        id
        questionImage
        value
        answers {
          id
          value
        }
      }
    }
  }
  userLekData(learningSessionId: $sessionId) {
    id
    created
    status
    elapsedTime
    userLekQuestionAnswerData {
      id
      question {
        id
      }
      userAnswer {
        id
      }
    }
  }
}
    `;

/**
 * __useGetLekSessionQuery__
 *
 * To run a query within a React component, call `useGetLekSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLekSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLekSessionQuery({
 *   variables: {
 *      lekSessionId: // value for 'lekSessionId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetLekSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetLekSessionQuery, GetLekSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLekSessionQuery, GetLekSessionQueryVariables>(GetLekSessionDocument, options);
      }
export function useGetLekSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLekSessionQuery, GetLekSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLekSessionQuery, GetLekSessionQueryVariables>(GetLekSessionDocument, options);
        }
export type GetLekSessionQueryHookResult = ReturnType<typeof useGetLekSessionQuery>;
export type GetLekSessionLazyQueryHookResult = ReturnType<typeof useGetLekSessionLazyQuery>;
export type GetLekSessionQueryResult = Apollo.QueryResult<GetLekSessionQuery, GetLekSessionQueryVariables>;
export const GetLekSessionResultsDocument = gql`
    query GetLekSessionResults($sessionId: UUID) {
  lekSessionsData(learningSessionId: $sessionId) {
    id
    lekSession {
      id
      finishDateTime
      status
      lek {
        id
        title
        lekGoal
        questionCount
        possibleAttempts
      }
      classRoomLearningSession {
        id
        status
      }
    }
    userLekData {
      id
      updated
      status
      correctAnswerCount
      elapsedTime
      isPassed
      attemptNumber
    }
  }
}
    `;

/**
 * __useGetLekSessionResultsQuery__
 *
 * To run a query within a React component, call `useGetLekSessionResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLekSessionResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLekSessionResultsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetLekSessionResultsQuery(baseOptions?: Apollo.QueryHookOptions<GetLekSessionResultsQuery, GetLekSessionResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLekSessionResultsQuery, GetLekSessionResultsQueryVariables>(GetLekSessionResultsDocument, options);
      }
export function useGetLekSessionResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLekSessionResultsQuery, GetLekSessionResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLekSessionResultsQuery, GetLekSessionResultsQueryVariables>(GetLekSessionResultsDocument, options);
        }
export type GetLekSessionResultsQueryHookResult = ReturnType<typeof useGetLekSessionResultsQuery>;
export type GetLekSessionResultsLazyQueryHookResult = ReturnType<typeof useGetLekSessionResultsLazyQuery>;
export type GetLekSessionResultsQueryResult = Apollo.QueryResult<GetLekSessionResultsQuery, GetLekSessionResultsQueryVariables>;
export const ClassRoomSessionProgressDocument = gql`
    query classRoomSessionProgress($sessionId: UUID) {
  classRoomLearningSession(sessionId: $sessionId) {
    id
    classRoom {
      id
      classRoomLecture {
        id
        correctAnswerCount(learningSessionId: $sessionId)
      }
    }
  }
  ongoingClassRooms {
    correctAnswersAmount
    learningSession {
      id
    }
  }
}
    `;

/**
 * __useClassRoomSessionProgressQuery__
 *
 * To run a query within a React component, call `useClassRoomSessionProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomSessionProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomSessionProgressQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useClassRoomSessionProgressQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomSessionProgressQuery, ClassRoomSessionProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomSessionProgressQuery, ClassRoomSessionProgressQueryVariables>(ClassRoomSessionProgressDocument, options);
      }
export function useClassRoomSessionProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomSessionProgressQuery, ClassRoomSessionProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomSessionProgressQuery, ClassRoomSessionProgressQueryVariables>(ClassRoomSessionProgressDocument, options);
        }
export type ClassRoomSessionProgressQueryHookResult = ReturnType<typeof useClassRoomSessionProgressQuery>;
export type ClassRoomSessionProgressLazyQueryHookResult = ReturnType<typeof useClassRoomSessionProgressLazyQuery>;
export type ClassRoomSessionProgressQueryResult = Apollo.QueryResult<ClassRoomSessionProgressQuery, ClassRoomSessionProgressQueryVariables>;
export const ClassRoomStatisticsDocument = gql`
    query classRoomStatistics($sessionId: UUID, $userSessionSettingsId: UUID) {
  userQuestionsCountData(
    sessionId: $sessionId
    userSessionSettingsId: $userSessionSettingsId
  ) {
    questionCountTotal
    questionCount
    correctAnswerCount
    wrongAnswerCount
    questionCountRepeat
    correctAnswerCountRepeat
    generalQuestionCount
  }
}
    `;

/**
 * __useClassRoomStatisticsQuery__
 *
 * To run a query within a React component, call `useClassRoomStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomStatisticsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      userSessionSettingsId: // value for 'userSessionSettingsId'
 *   },
 * });
 */
export function useClassRoomStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomStatisticsQuery, ClassRoomStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomStatisticsQuery, ClassRoomStatisticsQueryVariables>(ClassRoomStatisticsDocument, options);
      }
export function useClassRoomStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomStatisticsQuery, ClassRoomStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomStatisticsQuery, ClassRoomStatisticsQueryVariables>(ClassRoomStatisticsDocument, options);
        }
export type ClassRoomStatisticsQueryHookResult = ReturnType<typeof useClassRoomStatisticsQuery>;
export type ClassRoomStatisticsLazyQueryHookResult = ReturnType<typeof useClassRoomStatisticsLazyQuery>;
export type ClassRoomStatisticsQueryResult = Apollo.QueryResult<ClassRoomStatisticsQuery, ClassRoomStatisticsQueryVariables>;
export const OrganizerDocument = gql`
    query organizer($organizerId: UUID) {
  organizer(organizerId: $organizerId) {
    id
    name
    email
    about
    logo
    linkToSite
    city {
      id
      title
    }
    classroomSet {
      id
    }
  }
}
    `;

/**
 * __useOrganizerQuery__
 *
 * To run a query within a React component, call `useOrganizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizerQuery({
 *   variables: {
 *      organizerId: // value for 'organizerId'
 *   },
 * });
 */
export function useOrganizerQuery(baseOptions?: Apollo.QueryHookOptions<OrganizerQuery, OrganizerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizerQuery, OrganizerQueryVariables>(OrganizerDocument, options);
      }
export function useOrganizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizerQuery, OrganizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizerQuery, OrganizerQueryVariables>(OrganizerDocument, options);
        }
export type OrganizerQueryHookResult = ReturnType<typeof useOrganizerQuery>;
export type OrganizerLazyQueryHookResult = ReturnType<typeof useOrganizerLazyQuery>;
export type OrganizerQueryResult = Apollo.QueryResult<OrganizerQuery, OrganizerQueryVariables>;
export const OrganizerClassroomsDocument = gql`
    query organizerClassrooms($organizerId: UUID) {
  organizer(organizerId: $organizerId) {
    id
    name
    classroomSet {
      id
      title
      backgroundImage
      classRoomImage
      enrollmentType
      classRoomLearningSession {
        id
        startDate
        finishDate
        specialityGroupIcon
      }
      aggregatedRate {
        id
        averageRate
        feedbackCount
      }
      certificate {
        id
        points
        title
        title
      }
      idNumber
    }
  }
}
    `;

/**
 * __useOrganizerClassroomsQuery__
 *
 * To run a query within a React component, call `useOrganizerClassroomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizerClassroomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizerClassroomsQuery({
 *   variables: {
 *      organizerId: // value for 'organizerId'
 *   },
 * });
 */
export function useOrganizerClassroomsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizerClassroomsQuery, OrganizerClassroomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizerClassroomsQuery, OrganizerClassroomsQueryVariables>(OrganizerClassroomsDocument, options);
      }
export function useOrganizerClassroomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizerClassroomsQuery, OrganizerClassroomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizerClassroomsQuery, OrganizerClassroomsQueryVariables>(OrganizerClassroomsDocument, options);
        }
export type OrganizerClassroomsQueryHookResult = ReturnType<typeof useOrganizerClassroomsQuery>;
export type OrganizerClassroomsLazyQueryHookResult = ReturnType<typeof useOrganizerClassroomsLazyQuery>;
export type OrganizerClassroomsQueryResult = Apollo.QueryResult<OrganizerClassroomsQuery, OrganizerClassroomsQueryVariables>;
export const ClassroomMembersDocument = gql`
    query classroomMembers($sessionId: UUID) {
  classRoomMembers(classRoomSessionId: $sessionId) {
    id
    isAvailableForDuel
    userData {
      id
      user {
        id
        username
        avatar
      }
      userClassRoomLearningSessionSettings {
        isClosed
      }
      classRoomCorrectAnswersCount
    }
  }
  startedDuelsToday
}
    `;

/**
 * __useClassroomMembersQuery__
 *
 * To run a query within a React component, call `useClassroomMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomMembersQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useClassroomMembersQuery(baseOptions?: Apollo.QueryHookOptions<ClassroomMembersQuery, ClassroomMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomMembersQuery, ClassroomMembersQueryVariables>(ClassroomMembersDocument, options);
      }
export function useClassroomMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomMembersQuery, ClassroomMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomMembersQuery, ClassroomMembersQueryVariables>(ClassroomMembersDocument, options);
        }
export type ClassroomMembersQueryHookResult = ReturnType<typeof useClassroomMembersQuery>;
export type ClassroomMembersLazyQueryHookResult = ReturnType<typeof useClassroomMembersLazyQuery>;
export type ClassroomMembersQueryResult = Apollo.QueryResult<ClassroomMembersQuery, ClassroomMembersQueryVariables>;
export const ClassRoomSettingsDocument = gql`
    query classRoomSettings($learningSessionId: UUID, $userSessionSettingId: UUID) {
  userClassRoomSettings(
    learningSessionId: $learningSessionId
    userSessionSettingId: $userSessionSettingId
  ) {
    id
    created
    updated
    isDuelModeEnabled
    isDailyTipperModeEnabled
    isAchieved
    isClosed
    isOut
    isOnboardingSession
    classRoomLearningSession {
      id
      status
      classRoom {
        id
        enrollmentType
      }
    }
    specialityGroupIcon
  }
}
    `;

/**
 * __useClassRoomSettingsQuery__
 *
 * To run a query within a React component, call `useClassRoomSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassRoomSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassRoomSettingsQuery({
 *   variables: {
 *      learningSessionId: // value for 'learningSessionId'
 *      userSessionSettingId: // value for 'userSessionSettingId'
 *   },
 * });
 */
export function useClassRoomSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ClassRoomSettingsQuery, ClassRoomSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassRoomSettingsQuery, ClassRoomSettingsQueryVariables>(ClassRoomSettingsDocument, options);
      }
export function useClassRoomSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassRoomSettingsQuery, ClassRoomSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassRoomSettingsQuery, ClassRoomSettingsQueryVariables>(ClassRoomSettingsDocument, options);
        }
export type ClassRoomSettingsQueryHookResult = ReturnType<typeof useClassRoomSettingsQuery>;
export type ClassRoomSettingsLazyQueryHookResult = ReturnType<typeof useClassRoomSettingsLazyQuery>;
export type ClassRoomSettingsQueryResult = Apollo.QueryResult<ClassRoomSettingsQuery, ClassRoomSettingsQueryVariables>;
export const LectorDocument = gql`
    query lector($lectorId: UUID) {
  lector(lectorId: $lectorId) {
    id
    firstName
    lastName
    email
    about
    photo
    professions {
      id
      title
    }
    specialities {
      id
      title
    }
    aggregatedRate {
      id
      averageRate
      feedbackCount
    }
    city {
      id
      title
    }
    lectureSet {
      id
      title
      description
      classroomSet {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useLectorQuery__
 *
 * To run a query within a React component, call `useLectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLectorQuery({
 *   variables: {
 *      lectorId: // value for 'lectorId'
 *   },
 * });
 */
export function useLectorQuery(baseOptions?: Apollo.QueryHookOptions<LectorQuery, LectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LectorQuery, LectorQueryVariables>(LectorDocument, options);
      }
export function useLectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LectorQuery, LectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LectorQuery, LectorQueryVariables>(LectorDocument, options);
        }
export type LectorQueryHookResult = ReturnType<typeof useLectorQuery>;
export type LectorLazyQueryHookResult = ReturnType<typeof useLectorLazyQuery>;
export type LectorQueryResult = Apollo.QueryResult<LectorQuery, LectorQueryVariables>;
export const ClassroomLecturesDocument = gql`
    query classroomLectures($learningSessionId: UUID) {
  classRoomLectures(learningSessionId: $learningSessionId) {
    id
    lectureNumber
    lecture {
      ...lecture_fragment
    }
  }
}
    ${Lecture_FragmentFragmentDoc}`;

/**
 * __useClassroomLecturesQuery__
 *
 * To run a query within a React component, call `useClassroomLecturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomLecturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomLecturesQuery({
 *   variables: {
 *      learningSessionId: // value for 'learningSessionId'
 *   },
 * });
 */
export function useClassroomLecturesQuery(baseOptions?: Apollo.QueryHookOptions<ClassroomLecturesQuery, ClassroomLecturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomLecturesQuery, ClassroomLecturesQueryVariables>(ClassroomLecturesDocument, options);
      }
export function useClassroomLecturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomLecturesQuery, ClassroomLecturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomLecturesQuery, ClassroomLecturesQueryVariables>(ClassroomLecturesDocument, options);
        }
export type ClassroomLecturesQueryHookResult = ReturnType<typeof useClassroomLecturesQuery>;
export type ClassroomLecturesLazyQueryHookResult = ReturnType<typeof useClassroomLecturesLazyQuery>;
export type ClassroomLecturesQueryResult = Apollo.QueryResult<ClassroomLecturesQuery, ClassroomLecturesQueryVariables>;
export const QuizTimeDetailsDocument = gql`
    query quizTimeDetails($quizSessionId: UUID) {
  quizTimeSession(quizSessionId: $quizSessionId) {
    id
    status
    startDate
    startDateTime
    usersCount
    quizTimeDuration
    duelDuration
    finishDateTime
    isForPremiumOnly
    isUseCode
    maxUserCapacity
    quizTime {
      id
      quizTimeImage
      title
      description
      participationConditions
      organizer {
        id
        name
        email
        logo
        linkToSite
      }
      sponsor {
        id
        title
        text
        website
        email
        logo
      }
    }
  }
}
    `;

/**
 * __useQuizTimeDetailsQuery__
 *
 * To run a query within a React component, call `useQuizTimeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizTimeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizTimeDetailsQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useQuizTimeDetailsQuery(baseOptions?: Apollo.QueryHookOptions<QuizTimeDetailsQuery, QuizTimeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizTimeDetailsQuery, QuizTimeDetailsQueryVariables>(QuizTimeDetailsDocument, options);
      }
export function useQuizTimeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizTimeDetailsQuery, QuizTimeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizTimeDetailsQuery, QuizTimeDetailsQueryVariables>(QuizTimeDetailsDocument, options);
        }
export type QuizTimeDetailsQueryHookResult = ReturnType<typeof useQuizTimeDetailsQuery>;
export type QuizTimeDetailsLazyQueryHookResult = ReturnType<typeof useQuizTimeDetailsLazyQuery>;
export type QuizTimeDetailsQueryResult = Apollo.QueryResult<QuizTimeDetailsQuery, QuizTimeDetailsQueryVariables>;
export const GetUserQuizSessionSettingsDocument = gql`
    query getUserQuizSessionSettings($quizSessionId: UUID) {
  userQuizSessionSettings(quizSessionId: $quizSessionId) {
    id
    userStatus
    isQuizSessionAvailableToStart
  }
}
    `;

/**
 * __useGetUserQuizSessionSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserQuizSessionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuizSessionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuizSessionSettingsQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useGetUserQuizSessionSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuizSessionSettingsQuery, GetUserQuizSessionSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuizSessionSettingsQuery, GetUserQuizSessionSettingsQueryVariables>(GetUserQuizSessionSettingsDocument, options);
      }
export function useGetUserQuizSessionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuizSessionSettingsQuery, GetUserQuizSessionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuizSessionSettingsQuery, GetUserQuizSessionSettingsQueryVariables>(GetUserQuizSessionSettingsDocument, options);
        }
export type GetUserQuizSessionSettingsQueryHookResult = ReturnType<typeof useGetUserQuizSessionSettingsQuery>;
export type GetUserQuizSessionSettingsLazyQueryHookResult = ReturnType<typeof useGetUserQuizSessionSettingsLazyQuery>;
export type GetUserQuizSessionSettingsQueryResult = Apollo.QueryResult<GetUserQuizSessionSettingsQuery, GetUserQuizSessionSettingsQueryVariables>;
export const QuizTimeUsersDocument = gql`
    query quizTimeUsers($quizSessionId: UUID) {
  quizSessionMembers(quizSessionId: $quizSessionId) {
    id
    userData {
      id
      rank
      points
      user {
        id
        username
        avatar
      }
    }
    isAvailableForQuizDuel
  }
}
    `;

/**
 * __useQuizTimeUsersQuery__
 *
 * To run a query within a React component, call `useQuizTimeUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizTimeUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizTimeUsersQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useQuizTimeUsersQuery(baseOptions?: Apollo.QueryHookOptions<QuizTimeUsersQuery, QuizTimeUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizTimeUsersQuery, QuizTimeUsersQueryVariables>(QuizTimeUsersDocument, options);
      }
export function useQuizTimeUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizTimeUsersQuery, QuizTimeUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizTimeUsersQuery, QuizTimeUsersQueryVariables>(QuizTimeUsersDocument, options);
        }
export type QuizTimeUsersQueryHookResult = ReturnType<typeof useQuizTimeUsersQuery>;
export type QuizTimeUsersLazyQueryHookResult = ReturnType<typeof useQuizTimeUsersLazyQuery>;
export type QuizTimeUsersQueryResult = Apollo.QueryResult<QuizTimeUsersQuery, QuizTimeUsersQueryVariables>;
export const PrivacyPolicyDocument = gql`
    query privacyPolicy {
  privatePolicy {
    id
    text
  }
}
    `;

/**
 * __usePrivacyPolicyQuery__
 *
 * To run a query within a React component, call `usePrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivacyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, options);
      }
export function usePrivacyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, options);
        }
export type PrivacyPolicyQueryHookResult = ReturnType<typeof usePrivacyPolicyQuery>;
export type PrivacyPolicyLazyQueryHookResult = ReturnType<typeof usePrivacyPolicyLazyQuery>;
export type PrivacyPolicyQueryResult = Apollo.QueryResult<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>;
export const DataProtectionDocument = gql`
    query dataProtection {
  dataProtection {
    id
    text
  }
}
    `;

/**
 * __useDataProtectionQuery__
 *
 * To run a query within a React component, call `useDataProtectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataProtectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataProtectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataProtectionQuery(baseOptions?: Apollo.QueryHookOptions<DataProtectionQuery, DataProtectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataProtectionQuery, DataProtectionQueryVariables>(DataProtectionDocument, options);
      }
export function useDataProtectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataProtectionQuery, DataProtectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataProtectionQuery, DataProtectionQueryVariables>(DataProtectionDocument, options);
        }
export type DataProtectionQueryHookResult = ReturnType<typeof useDataProtectionQuery>;
export type DataProtectionLazyQueryHookResult = ReturnType<typeof useDataProtectionLazyQuery>;
export type DataProtectionQueryResult = Apollo.QueryResult<DataProtectionQuery, DataProtectionQueryVariables>;
export const ImprintDocument = gql`
    query imprint {
  impressum {
    id
    text
  }
}
    `;

/**
 * __useImprintQuery__
 *
 * To run a query within a React component, call `useImprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useImprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImprintQuery({
 *   variables: {
 *   },
 * });
 */
export function useImprintQuery(baseOptions?: Apollo.QueryHookOptions<ImprintQuery, ImprintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImprintQuery, ImprintQueryVariables>(ImprintDocument, options);
      }
export function useImprintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImprintQuery, ImprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImprintQuery, ImprintQueryVariables>(ImprintDocument, options);
        }
export type ImprintQueryHookResult = ReturnType<typeof useImprintQuery>;
export type ImprintLazyQueryHookResult = ReturnType<typeof useImprintLazyQuery>;
export type ImprintQueryResult = Apollo.QueryResult<ImprintQuery, ImprintQueryVariables>;
export const QuizSessionsOngoingDocument = gql`
    query QuizSessionsOngoing {
  ongoingQuizSessions {
    ...quiztime_list_fragment
  }
}
    ${Quiztime_List_FragmentFragmentDoc}`;

/**
 * __useQuizSessionsOngoingQuery__
 *
 * To run a query within a React component, call `useQuizSessionsOngoingQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizSessionsOngoingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizSessionsOngoingQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuizSessionsOngoingQuery(baseOptions?: Apollo.QueryHookOptions<QuizSessionsOngoingQuery, QuizSessionsOngoingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizSessionsOngoingQuery, QuizSessionsOngoingQueryVariables>(QuizSessionsOngoingDocument, options);
      }
export function useQuizSessionsOngoingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizSessionsOngoingQuery, QuizSessionsOngoingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizSessionsOngoingQuery, QuizSessionsOngoingQueryVariables>(QuizSessionsOngoingDocument, options);
        }
export type QuizSessionsOngoingQueryHookResult = ReturnType<typeof useQuizSessionsOngoingQuery>;
export type QuizSessionsOngoingLazyQueryHookResult = ReturnType<typeof useQuizSessionsOngoingLazyQuery>;
export type QuizSessionsOngoingQueryResult = Apollo.QueryResult<QuizSessionsOngoingQuery, QuizSessionsOngoingQueryVariables>;
export const QuizSessionsAnnouncedDocument = gql`
    query QuizSessionsAnnounced {
  announcedQuizSessions {
    ...quiztime_list_fragment
  }
}
    ${Quiztime_List_FragmentFragmentDoc}`;

/**
 * __useQuizSessionsAnnouncedQuery__
 *
 * To run a query within a React component, call `useQuizSessionsAnnouncedQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizSessionsAnnouncedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizSessionsAnnouncedQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuizSessionsAnnouncedQuery(baseOptions?: Apollo.QueryHookOptions<QuizSessionsAnnouncedQuery, QuizSessionsAnnouncedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizSessionsAnnouncedQuery, QuizSessionsAnnouncedQueryVariables>(QuizSessionsAnnouncedDocument, options);
      }
export function useQuizSessionsAnnouncedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizSessionsAnnouncedQuery, QuizSessionsAnnouncedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizSessionsAnnouncedQuery, QuizSessionsAnnouncedQueryVariables>(QuizSessionsAnnouncedDocument, options);
        }
export type QuizSessionsAnnouncedQueryHookResult = ReturnType<typeof useQuizSessionsAnnouncedQuery>;
export type QuizSessionsAnnouncedLazyQueryHookResult = ReturnType<typeof useQuizSessionsAnnouncedLazyQuery>;
export type QuizSessionsAnnouncedQueryResult = Apollo.QueryResult<QuizSessionsAnnouncedQuery, QuizSessionsAnnouncedQueryVariables>;
export const QuizSessionsFinishedDocument = gql`
    query QuizSessionsFinished {
  finishedQuizSessions {
    id
    quizSession {
      ...quiztime_list_fragment
    }
    userRank
  }
}
    ${Quiztime_List_FragmentFragmentDoc}`;

/**
 * __useQuizSessionsFinishedQuery__
 *
 * To run a query within a React component, call `useQuizSessionsFinishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizSessionsFinishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizSessionsFinishedQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuizSessionsFinishedQuery(baseOptions?: Apollo.QueryHookOptions<QuizSessionsFinishedQuery, QuizSessionsFinishedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizSessionsFinishedQuery, QuizSessionsFinishedQueryVariables>(QuizSessionsFinishedDocument, options);
      }
export function useQuizSessionsFinishedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizSessionsFinishedQuery, QuizSessionsFinishedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizSessionsFinishedQuery, QuizSessionsFinishedQueryVariables>(QuizSessionsFinishedDocument, options);
        }
export type QuizSessionsFinishedQueryHookResult = ReturnType<typeof useQuizSessionsFinishedQuery>;
export type QuizSessionsFinishedLazyQueryHookResult = ReturnType<typeof useQuizSessionsFinishedLazyQuery>;
export type QuizSessionsFinishedQueryResult = Apollo.QueryResult<QuizSessionsFinishedQuery, QuizSessionsFinishedQueryVariables>;
export const QuizSessionsOnHomePageDocument = gql`
    query quizSessionsOnHomePage($startLess24Hours: Boolean) {
  me {
    id
    settings {
      id
      duelMode
      activeQuizTime {
        id
      }
    }
  }
  homeQuizSessions(startLess24Hours: $startLess24Hours) {
    quizSession {
      ...quiztime_homelist_fragment
    }
    userStatus
  }
  inProgressUserQuizSession {
    ...quiztime_homelist_fragment
  }
}
    ${Quiztime_Homelist_FragmentFragmentDoc}`;

/**
 * __useQuizSessionsOnHomePageQuery__
 *
 * To run a query within a React component, call `useQuizSessionsOnHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizSessionsOnHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizSessionsOnHomePageQuery({
 *   variables: {
 *      startLess24Hours: // value for 'startLess24Hours'
 *   },
 * });
 */
export function useQuizSessionsOnHomePageQuery(baseOptions?: Apollo.QueryHookOptions<QuizSessionsOnHomePageQuery, QuizSessionsOnHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizSessionsOnHomePageQuery, QuizSessionsOnHomePageQueryVariables>(QuizSessionsOnHomePageDocument, options);
      }
export function useQuizSessionsOnHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizSessionsOnHomePageQuery, QuizSessionsOnHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizSessionsOnHomePageQuery, QuizSessionsOnHomePageQueryVariables>(QuizSessionsOnHomePageDocument, options);
        }
export type QuizSessionsOnHomePageQueryHookResult = ReturnType<typeof useQuizSessionsOnHomePageQuery>;
export type QuizSessionsOnHomePageLazyQueryHookResult = ReturnType<typeof useQuizSessionsOnHomePageLazyQuery>;
export type QuizSessionsOnHomePageQueryResult = Apollo.QueryResult<QuizSessionsOnHomePageQuery, QuizSessionsOnHomePageQueryVariables>;
export const GetActiveQuizDuelsDocument = gql`
    query getActiveQuizDuels($quizSessionId: UUID) {
  activeQuizDuels(quizSessionId: $quizSessionId) {
    id
    opponent {
      id
      avatar
      username
    }
    round {
      id
      roundNumber
      created
      duel {
        id
        status
      }
      userQuestions {
        id
        questionNumber
        user {
          id
        }
        question {
          id
          value
        }
        userAnswer {
          id
          value
        }
      }
    }
    isInitiator
    session {
      id
    }
  }
}
    `;

/**
 * __useGetActiveQuizDuelsQuery__
 *
 * To run a query within a React component, call `useGetActiveQuizDuelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveQuizDuelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveQuizDuelsQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useGetActiveQuizDuelsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveQuizDuelsQuery, GetActiveQuizDuelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveQuizDuelsQuery, GetActiveQuizDuelsQueryVariables>(GetActiveQuizDuelsDocument, options);
      }
export function useGetActiveQuizDuelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveQuizDuelsQuery, GetActiveQuizDuelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveQuizDuelsQuery, GetActiveQuizDuelsQueryVariables>(GetActiveQuizDuelsDocument, options);
        }
export type GetActiveQuizDuelsQueryHookResult = ReturnType<typeof useGetActiveQuizDuelsQuery>;
export type GetActiveQuizDuelsLazyQueryHookResult = ReturnType<typeof useGetActiveQuizDuelsLazyQuery>;
export type GetActiveQuizDuelsQueryResult = Apollo.QueryResult<GetActiveQuizDuelsQuery, GetActiveQuizDuelsQueryVariables>;
export const QuizScoreDocument = gql`
    query quizScore($quizSessionId: UUID) {
  quizDuelScore(quizSessionId: $quizSessionId) {
    id
    duels
    points
    rank
    wins
    ties
    loss
  }
}
    `;

/**
 * __useQuizScoreQuery__
 *
 * To run a query within a React component, call `useQuizScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizScoreQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useQuizScoreQuery(baseOptions?: Apollo.QueryHookOptions<QuizScoreQuery, QuizScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizScoreQuery, QuizScoreQueryVariables>(QuizScoreDocument, options);
      }
export function useQuizScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizScoreQuery, QuizScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizScoreQuery, QuizScoreQueryVariables>(QuizScoreDocument, options);
        }
export type QuizScoreQueryHookResult = ReturnType<typeof useQuizScoreQuery>;
export type QuizScoreLazyQueryHookResult = ReturnType<typeof useQuizScoreLazyQuery>;
export type QuizScoreQueryResult = Apollo.QueryResult<QuizScoreQuery, QuizScoreQueryVariables>;
export const GetCompletedQuizDuelsDocument = gql`
    query getCompletedQuizDuels($quizSessionId: UUID) {
  completedQuizDuels(quizSessionId: $quizSessionId) {
    id
    userDuelsData {
      ...user_score_fragment
      duel {
        id
        updated
        status
      }
    }
    opponentDuelsData {
      ...user_score_fragment
    }
    session {
      id
    }
  }
}
    ${User_Score_FragmentFragmentDoc}`;

/**
 * __useGetCompletedQuizDuelsQuery__
 *
 * To run a query within a React component, call `useGetCompletedQuizDuelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedQuizDuelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedQuizDuelsQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useGetCompletedQuizDuelsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompletedQuizDuelsQuery, GetCompletedQuizDuelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedQuizDuelsQuery, GetCompletedQuizDuelsQueryVariables>(GetCompletedQuizDuelsDocument, options);
      }
export function useGetCompletedQuizDuelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedQuizDuelsQuery, GetCompletedQuizDuelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedQuizDuelsQuery, GetCompletedQuizDuelsQueryVariables>(GetCompletedQuizDuelsDocument, options);
        }
export type GetCompletedQuizDuelsQueryHookResult = ReturnType<typeof useGetCompletedQuizDuelsQuery>;
export type GetCompletedQuizDuelsLazyQueryHookResult = ReturnType<typeof useGetCompletedQuizDuelsLazyQuery>;
export type GetCompletedQuizDuelsQueryResult = Apollo.QueryResult<GetCompletedQuizDuelsQuery, GetCompletedQuizDuelsQueryVariables>;
export const GetQuizSessionPrizeDocument = gql`
    query getQuizSessionPrize($quizSessionId: UUID) {
  quizSessionPrize(quizSessionId: $quizSessionId) {
    placeList {
      ...quiz_prize_item
    }
    participationList {
      ...quiz_prize_item
    }
    lotteryList {
      ...quiz_prize_item
    }
  }
}
    ${Quiz_Prize_ItemFragmentDoc}`;

/**
 * __useGetQuizSessionPrizeQuery__
 *
 * To run a query within a React component, call `useGetQuizSessionPrizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizSessionPrizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizSessionPrizeQuery({
 *   variables: {
 *      quizSessionId: // value for 'quizSessionId'
 *   },
 * });
 */
export function useGetQuizSessionPrizeQuery(baseOptions?: Apollo.QueryHookOptions<GetQuizSessionPrizeQuery, GetQuizSessionPrizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizSessionPrizeQuery, GetQuizSessionPrizeQueryVariables>(GetQuizSessionPrizeDocument, options);
      }
export function useGetQuizSessionPrizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizSessionPrizeQuery, GetQuizSessionPrizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizSessionPrizeQuery, GetQuizSessionPrizeQueryVariables>(GetQuizSessionPrizeDocument, options);
        }
export type GetQuizSessionPrizeQueryHookResult = ReturnType<typeof useGetQuizSessionPrizeQuery>;
export type GetQuizSessionPrizeLazyQueryHookResult = ReturnType<typeof useGetQuizSessionPrizeLazyQuery>;
export type GetQuizSessionPrizeQueryResult = Apollo.QueryResult<GetQuizSessionPrizeQuery, GetQuizSessionPrizeQueryVariables>;
export const GetFeedbackQuestionDocument = gql`
    query getFeedbackQuestion($questionId: UUID!) {
  getFeedbackForQuestion(questionId: $questionId) {
    id
    relevanceRate
    interestRate
    comment
  }
}
    `;

/**
 * __useGetFeedbackQuestionQuery__
 *
 * To run a query within a React component, call `useGetFeedbackQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetFeedbackQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackQuestionQuery, GetFeedbackQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackQuestionQuery, GetFeedbackQuestionQueryVariables>(GetFeedbackQuestionDocument, options);
      }
export function useGetFeedbackQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackQuestionQuery, GetFeedbackQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackQuestionQuery, GetFeedbackQuestionQueryVariables>(GetFeedbackQuestionDocument, options);
        }
export type GetFeedbackQuestionQueryHookResult = ReturnType<typeof useGetFeedbackQuestionQuery>;
export type GetFeedbackQuestionLazyQueryHookResult = ReturnType<typeof useGetFeedbackQuestionLazyQuery>;
export type GetFeedbackQuestionQueryResult = Apollo.QueryResult<GetFeedbackQuestionQuery, GetFeedbackQuestionQueryVariables>;
export const LearningProgressDocument = gql`
    query learningProgress {
  userLearningProgress {
    percentageOfAnswers
    progressStatus
    totalQuestionCount
    answeredQuestionsCount
    correctAnsweredQuestionCount
    incorrectAnsweredQuestionCount
    percentageOfAnswers
    percentageOfCorrectAnswers
    percentageOfIncorrectAnswers
    duelsCount
    wonDuelsCount
    tiedDuelsCount
    loseDuelsCount
    sessionStats {
      totalSessions
      achievedCount
      activeSessions
    }
  }
}
    `;

/**
 * __useLearningProgressQuery__
 *
 * To run a query within a React component, call `useLearningProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useLearningProgressQuery(baseOptions?: Apollo.QueryHookOptions<LearningProgressQuery, LearningProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningProgressQuery, LearningProgressQueryVariables>(LearningProgressDocument, options);
      }
export function useLearningProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningProgressQuery, LearningProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningProgressQuery, LearningProgressQueryVariables>(LearningProgressDocument, options);
        }
export type LearningProgressQueryHookResult = ReturnType<typeof useLearningProgressQuery>;
export type LearningProgressLazyQueryHookResult = ReturnType<typeof useLearningProgressLazyQuery>;
export type LearningProgressQueryResult = Apollo.QueryResult<LearningProgressQuery, LearningProgressQueryVariables>;
export const UserDailyStatsDocument = gql`
    query userDailyStats {
  userDailyStats {
    date
    total
    incorrect
    correct
  }
}
    `;

/**
 * __useUserDailyStatsQuery__
 *
 * To run a query within a React component, call `useUserDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDailyStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDailyStatsQuery(baseOptions?: Apollo.QueryHookOptions<UserDailyStatsQuery, UserDailyStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDailyStatsQuery, UserDailyStatsQueryVariables>(UserDailyStatsDocument, options);
      }
export function useUserDailyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDailyStatsQuery, UserDailyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDailyStatsQuery, UserDailyStatsQueryVariables>(UserDailyStatsDocument, options);
        }
export type UserDailyStatsQueryHookResult = ReturnType<typeof useUserDailyStatsQuery>;
export type UserDailyStatsLazyQueryHookResult = ReturnType<typeof useUserDailyStatsLazyQuery>;
export type UserDailyStatsQueryResult = Apollo.QueryResult<UserDailyStatsQuery, UserDailyStatsQueryVariables>;
export const TakenAchievementDocument = gql`
    query takenAchievement {
  dailyStatus @client
}
    `;

/**
 * __useTakenAchievementQuery__
 *
 * To run a query within a React component, call `useTakenAchievementQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakenAchievementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakenAchievementQuery({
 *   variables: {
 *   },
 * });
 */
export function useTakenAchievementQuery(baseOptions?: Apollo.QueryHookOptions<TakenAchievementQuery, TakenAchievementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TakenAchievementQuery, TakenAchievementQueryVariables>(TakenAchievementDocument, options);
      }
export function useTakenAchievementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TakenAchievementQuery, TakenAchievementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TakenAchievementQuery, TakenAchievementQueryVariables>(TakenAchievementDocument, options);
        }
export type TakenAchievementQueryHookResult = ReturnType<typeof useTakenAchievementQuery>;
export type TakenAchievementLazyQueryHookResult = ReturnType<typeof useTakenAchievementLazyQuery>;
export type TakenAchievementQueryResult = Apollo.QueryResult<TakenAchievementQuery, TakenAchievementQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String) {
  userForgotPassword(email: $email) {
    user {
      id
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;